webpackJsonp([1],{

/***/ "/Sy6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-timepicker/src/vue-timepicker.vue
var vue_timepicker = __webpack_require__("gCMD");
var vue_timepicker_default = /*#__PURE__*/__webpack_require__.n(vue_timepicker);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e76390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-timepicker/src/vue-timepicker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTime),expression:"displayTime"}],staticClass:"display-time",attrs:{"id":_vm.id,"type":"text","readonly":""},domProps:{"value":(_vm.displayTime)},on:{"click":function($event){$event.stopPropagation();_vm.toggleDropdown($event)},"input":function($event){if($event.target.composing){ return; }_vm.displayTime=$event.target.value}}}),_vm._v(" "),(!_vm.hideClearButton)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDropdown && _vm.showClearBtn),expression:"!showDropdown && showClearBtn"}],staticClass:"clear-btn",on:{"click":function($event){$event.stopPropagation();_vm.clearTime($event)}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",on:{"click":function($event){$event.stopPropagation();_vm.toggleDropdown($event)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown"},[_c('div',{staticClass:"select-list"},[_c('ul',{staticClass:"hours"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourType)}}),_vm._v(" "),_vm._l((_vm.hours),function(hr){return _c('li',{class:{active: _vm.hour === hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){$event.stopPropagation();_vm.select('hour', hr)}}})})],2),_vm._v(" "),_c('ul',{staticClass:"minutes"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteType)}}),_vm._v(" "),_vm._l((_vm.minutes),function(m){return _c('li',{class:{active: _vm.minute === m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){$event.stopPropagation();_vm.select('minute', m)}}})})],2),_vm._v(" "),(_vm.secondType)?_c('ul',{staticClass:"seconds"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondType)}}),_vm._v(" "),_vm._l((_vm.seconds),function(s){return _c('li',{class:{active: _vm.second === s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){$event.stopPropagation();_vm.select('second', s)}}})})],2):_vm._e(),_vm._v(" "),(_vm.apmType)?_c('ul',{staticClass:"apms"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmType)}}),_vm._v(" "),_vm._l((_vm.apms),function(a){return _c('li',{class:{active: _vm.apm === a},domProps:{"textContent":_vm._s(a)},on:{"click":function($event){$event.stopPropagation();_vm.select('apm', a)}}})})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_vue_timepicker = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-timepicker/src/vue-timepicker.vue
function injectStyle (ssrContext) {
  __webpack_require__("HcUb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vue_timepicker_default.a,
  src_vue_timepicker,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue2_timepicker_src_vue_timepicker = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "89J7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9/BN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPGk":
/***/ (function(module, exports, __webpack_require__) {

module.exports.baseUrl = function (uri) {
    return location.origin + '/' + uri.replace(/^\//, '');
};

module.exports.apiBaseUrl = function (uri) {
    return "https://api.getparkave.com/".replace(/\/$/, '') + '/' + uri.replace(/^\//, '');
};

module.exports.isApiBaseUrl = function (url) {
    return "https://api.getparkave.com/".replace(/\/$/, '') == url;
};

/***/ }),

/***/ "GFam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/SeriesBadge.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SeriesBadge = ({
  props: ["series", "box"],
  data: function data() {
    return {
      number: "",
      street: ""
    };
  },
  mounted: function mounted() {
    this.setBadge();
  },

  computed: {
    numberIsDigit: function numberIsDigit() {
      return this.number != "";
    }
  },
  methods: {
    setBadge: function setBadge() {
      if (!parseInt(this.series.name.charAt(0))) {
        this.number = "";
        this.street = "Broadway";
      } else {
        this.number = this.series.name.match(/\d+/)[0];
        this.street = this.series.name.match(/\b([A-Z][a-z']*)(\s[A-Z][a-z']*)*\b/)[0];
      }
    }
  },
  watch: {
    series: function series(newVal) {
      this.setBadge();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-764af36c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SeriesBadge.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"series-container"},[(_vm.box)?_c('div',{staticClass:"box",style:({ 'background-color': _vm.series.color })},[(_vm.number)?_c('p',{staticClass:"box--number"},[_vm._v(_vm._s(_vm.number))]):_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"box--series"},[_vm._v(_vm._s(_vm.street))]),_vm._v(" "),_c('p',{staticClass:"box--text"},[_vm._v("Series")])]):_c('div',{staticClass:"rectangle"},[(_vm.numberIsDigit)?_c('div',{staticClass:"rectangle--number",style:({ background: _vm.series.color })},[_c('p',[_vm._v(" "+_vm._s(_vm.number)+" ")])]):_c('div',{staticClass:"rectangle--number"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"rectangle--series"},[_vm._v(_vm._s(_vm.street)+" Series")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_SeriesBadge = (esExports);
// CONCATENATED MODULE: ./src/components/common/SeriesBadge.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SeriesBadge,
  common_SeriesBadge,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_SeriesBadge = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GsNN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HWO9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HcUb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hpkn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKwM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J+Kq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LnNF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LxJn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MIgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MY+i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/lib/api/calls.js
var calls = __webpack_require__("Sy47");

// CONCATENATED MODULE: ./src/lib/EmailField.js
var emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);



/* harmony default export */ var EmailField = (function (newVal, oldVal) {
  this.pristine = newVal == '' ? true : false;
  var passesRegex = emailRegex.test(newVal);

  //Test for . in extension, which technically doesn't need to be there to pass RFC definition of valid email,
  //but which for all practical purposes should be there
  var split = newVal.split('@');
  var last = split.pop();

  if (passesRegex && last.indexOf('.') > -1) {
    this.checkingEmailAvailable = true;
    Object(calls["D" /* emailAvailable */])(newVal).then(function (response) {
      this.checkingEmailAvailable = false;
      if (response.taken) {
        this.emailTaken = true;
        this.validEmail = false;
      } else {
        this.emailTaken = false;
        this.validEmail = true;
      }
    }.bind(this));
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/Password.vue
//
//
//
//
//
//
//

var gradePassword = function gradePassword(password) {
  var score = 0;

  var grades = ['', 'weak', 'ok', 'strong', 'very strong', 'very strong'];
  var colors = ['#8B0000', '#FF0000', '#CCCC00', '#83db4c', '#25a11a', '#25a11a'];

  var hasNumbers = /\d/.test(password);
  var hasLowerCase = /[a-z]/.test(password);
  var hasUpperCase = /[A-Z]/.test(password);
  var hasSpecialCharacter = /[^a-z\d]+/i.test(password);
  var hasLength = password.length >= 8;

  if (hasNumbers) ++score;
  if (hasLowerCase) ++score;
  if (hasUpperCase) ++score;
  if (hasSpecialCharacter) ++score;
  if (hasLength) ++score;

  return {
    name: grades[score],
    color: colors[score]
  };
};

var initialPasswordState = {
  passwordGrade: null,
  passwordColor: null,
  password: null,
  validPassword: null,
  pristine: true
};

/* harmony default export */ var Password = ({
  name: 'Password',
  props: ['placeholder', 'match', 'skipPasswordGrade'],
  data: function data() {
    var obj = {};
    for (var key in initialPasswordState) {
      obj[key] = initialPasswordState[key];
    }return obj;
  },

  methods: {
    update: function update() {
      this.$emit('input', this.password);
    },
    resetState: function resetState() {
      for (var key in initialPasswordState) {
        this[key] = initialPasswordState[key];
      }
    }
  },
  watch: {
    password: function password(newVal, oldVal) {
      this.pristine = newVal === '' || newVal == null;

      if (!this.skipPasswordGrade && newVal != null) {
        var grade = gradePassword(newVal);

        this.passwordGrade = grade.name;
        this.passwordColor = grade.color;

        if (grade.name == 'very strong' || grade.name == 'strong') {
          this.validPassword = true;
        } else {
          this.validPassword = false;
        }
      }

      this.update();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-013a50ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Password.vue
var Password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input",class:{ 'input--success': _vm.validPassword, 'input--error': !_vm.pristine && !_vm.password || (!_vm.pristine && _vm.match && _vm.password != _vm.match)},staticStyle:{"margin-bottom":"1em","position":"relative"}},[(_vm.passwordGrade && !_vm.skipPasswordGrade)?_c('span',{style:({color: _vm.passwordColor, position: 'absolute', right: _vm.validPassword ? '2.5em' : '1.25em', top: '0.75em'})},[_vm._v(_vm._s(_vm.passwordGrade))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"input",staticClass:"input__field",attrs:{"type":"password","placeholder":_vm.placeholder},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: Password_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_Password = (esExports);
// CONCATENATED MODULE: ./src/components/common/Password.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Password,
  common_Password,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_Password = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/lib/responseNotification.js

function responseNotification(store, response) {
  var successMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var config = arguments[3];

  var rootVM = window.rootVM;

  if (response.error) {
    rootVM.$snotify.error(response.error, config);
  } else if (response.info) {
    rootVM.$snotify.info(response.info, config);
  } else {
    rootVM.$snotify.success(successMessage || response.message, config);
  }
}
// CONCATENATED MODULE: ./src/store/accounts.js
/** VUEX module for account management **/




/* harmony default export */ var accounts = ({
  namespaced: true,
  state: {
    owned: [],
    all: [],
    charges: []
  },
  getters: {
    owned: function owned(state) {
      return state.owned;
    },
    all: function all(state) {
      return state.all;
    },
    charges: function charges(state) {
      return state.charges;
    }
  },
  mutations: {
    setOwned: function setOwned(state, accounts) {
      state.owned = accounts;
    },
    setAll: function setAll(state, value) {
      state.all = value;
    },
    setCharges: function setCharges(state, value) {
      state.charges = value;
    }
  },
  actions: {
    loadOwned: function loadOwned(_ref) {
      var commit = _ref.commit;

      return Object(calls["F" /* getAccounts */])().then(function (accounts) {
        commit('setOwned', accounts);
        if (accounts.length) {
          var currAccount = null;
          var first = accounts[0];
          accounts.forEach(function (account) {
            if (account.id == localStorage.account_id) {
              currAccount = account;
            }
          });
          if (currAccount == null) currAccount = first;
          commit('setAccount', currAccount, { root: true });
          return currAccount;
        }
      });
    },
    loadAll: function loadAll(_ref2) {
      var commit = _ref2.commit;

      Object(calls["I" /* getAllAccounts */])().then(function (accounts) {
        return commit('setAll', accounts);
      });
    },
    create: function create(context, name) {
      Object(calls["i" /* createAccount */])(name).then(function (response) {
        responseNotification(context, response, 'Account Created!');
        context.dispatch('loadOwned');
      });
    },
    delete: function _delete(context, account_id) {
      Object(calls["s" /* deleteAccount */])(account_id).then(function (response) {
        responseNotification(context, response, 'Account Deleted!');
        setTimeout(function () {
          location.reload();
        }, 1000);
      });
    },
    issueRefund: function issueRefund(context, _ref3) {
      var account_id = _ref3.account_id,
          charge_id = _ref3.charge_id;

      Object(calls["Z" /* issueRefund */])(account_id, charge_id).then(function (response) {
        responseNotification(context, response, 'Refund Issued Successfully');
        context.dispatch('loadAll');
        context.dispatch('loadCharges', { accountId: account_id });
      });
    },
    loadCharges: function loadCharges(_ref4, _ref5) {
      var commit = _ref4.commit;
      var accountId = _ref5.accountId,
          callback = _ref5.callback;

      Object(calls["M" /* getCharges */])(accountId).then(function (charges) {
        commit('setCharges', charges);
        if (callback) callback();
      });
    },
    update: function update(context, payload) {
      var token = payload.token,
          skipSuccessMessage = payload.skipSuccessMessage;

      if (token) {
        responseNotification(context, { info: 'Updating credit card...' });
      }
      return Object(calls["_8" /* saveAccountInfo */])({ account: payload }).then(function (response) {
        if (response.error) {
          responseNotification(context, response);
        } else {
          context.dispatch('loadOwned');
          if (!skipSuccessMessage) responseNotification(context, response, 'Account info saved!');
        }
        return response;
      });
    }
  },
  modules: {
    users: {
      namespaced: true,
      state: {},
      getters: {},
      mutations: {},
      actions: {
        remove: function remove(context, _ref6) {
          var id = _ref6.id;

          Object(calls["_7" /* removeUserFromAccount */])(id).then(function (response) {
            responseNotification(context, response, 'User Removed From Account!');
            context.dispatch('accounts/loadOwned', {}, { root: true });
          });
        },
        togglePerms: function togglePerms(context, _ref7) {
          var id = _ref7.id,
              permissions = _ref7.permissions;

          Object(calls["_14" /* toggleUserPermissions */])(id, permissions).then(function (response) {
            responseNotification(context, response, 'User Permissions Toggled!');
            context.dispatch('accounts/loadOwned', {}, { root: true });
          });
        }
      }
    },
    formats: {
      namespaced: true,
      state: {
        custom: []
      },
      mutations: {
        setCustom: function setCustom(state, value) {
          state.custom = value;
        }
      },
      actions: {
        add: function add(context, _ref8) {
          var format_id = _ref8.format_id,
              account_id = _ref8.account_id;

          Object(calls["j" /* createAccountFormat */])(format_id, account_id).then(function (response) {
            responseNotification(context, response, 'Format Added!');
            context.dispatch('accounts/loadAll', {}, { root: true });
          });
        },
        delete: function _delete(context, _ref9) {
          var id = _ref9.id;

          Object(calls["t" /* deleteAccountFormat */])(id).then(function (response) {
            responseNotification(context, response, 'Format Removed!');
            context.dispatch('accounts/loadAll', {}, { root: true });
          });
        },
        addSelected: function addSelected(context, _ref10) {
          var format_id = _ref10.format_id;

          Object(calls["k" /* createAccountSelectedFormat */])(format_id).then(function (response) {
            responseNotification(context, response, 'Format Added!');
            context.dispatch('formats/loadSelected', {}, { root: true });
          });
        },
        deleteSelected: function deleteSelected(context, _ref11) {
          var format_id = _ref11.format_id;

          Object(calls["u" /* deleteAccountSelectedFormat */])(format_id).then(function (response) {
            responseNotification(context, response, 'Format Removed!');
            context.dispatch('formats/loadSelected', {}, { root: true });
          });
        },
        loadCustom: function loadCustom(_ref12, _ref13) {
          var commit = _ref12.commit;
          var id = _ref13.id;

          return Object(calls["O" /* getCustomFormats */])(id).then(function (formats) {
            commit('setCustom', formats);
            return formats;
          });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/store/advertisements.js


/** VUEX module for advertisement management **/




/* harmony default export */ var advertisements = ({
  namespaced: true,
  state: {
    ads: [],
    single_ad: {}
  },
  getters: {
    getSortedAds: function getSortedAds(state) {
      return state.ads.sort(function (a, b) {
        return ('' + b.updated_at).localeCompare(a.updated_at);
      });
    }
  },
  mutations: {
    setAds: function setAds(state, value) {
      if (!Array.isArray(value)) value = [];

      value = value.map(function (item) {
        if (typeof item.json == 'string') {
          item.json = JSON.parse(item.json);
          item.link = '/' + ['configuration', item.format_id, item.id].join('/');
        }

        return item;
      });

      state.ads = value;
    },
    setSingleAd: function setSingleAd(state, value) {
      state.single_ad = value;
    }
  },
  actions: {
    load: function load(_ref, payload) {
      var _this = this;

      var commit = _ref.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(calls["H" /* getAds */])().then(function (ads) {
                  return commit('setAds', ads);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadSingle: function loadSingle(_ref2, id) {
      var _this2 = this;

      var commit = _ref2.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(calls["_1" /* loadSingleAd */])(id).then(function (response) {
                  return commit('setSingleAd', response);
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    regenerate: function regenerate(context, formatId) {
      Object(calls["_6" /* regenerateAdvertisementsCode */])(formatId).then(function (response) {
        responseNotification(context, response, 'Ad Format Reloaded!');
      });
    },
    create: function create(context, _ref3) {
      var data = _ref3.data,
          callback = _ref3.callback;

      Object(calls["l" /* createAd */])(data).then(function (response) {
        responseNotification(context, response, 'Ad created!');
        context.dispatch('load');
        if (callback) callback(response);
      }).catch(function (e) {
        console.error(e);
        console.error(data);
        if (FS) {
          FS.log('error', data);
          FS.log('error', e.toString());
        }
        responseNotification(context, { error: 'This ad could not be saved' });
      });
    },
    update: function update(context, _ref4) {
      var id = _ref4.id,
          ad = _ref4.ad,
          callback = _ref4.callback;

      Object(calls["_15" /* updateAd */])(id, ad).then(function (response) {
        responseNotification(context, response, 'Ad updated!');
        context.dispatch('load');
        if (callback) callback(response);
      });
    },
    copy: function copy(context, id) {
      responseNotification(context, { info: 'Duplicating ad...' }, null, { showProgressBar: false });
      Object(calls["h" /* copyAd */])(id).then(function (response) {
        responseNotification(context, response, 'Ad copied!');
        context.dispatch('load');
      });
    },
    delete: function _delete(context, id) {
      Object(calls["v" /* deleteAd */])(id).then(function (response) {
        responseNotification(context, response, 'Ad deleted!');
        context.dispatch('load');
      });
    },
    share: function share(context, _ref5) {
      var email = _ref5.email,
          url = _ref5.url;

      Object(calls["_11" /* shareAd */])(email, url).then(function (response) {
        responseNotification(context, response, 'Ad Shared');
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/categories.js
/** VUEX module for category management **/




/* harmony default export */ var categories = ({
  namespaced: true,
  state: {
    categories: []
  },
  mutations: {
    setCategories: function setCategories(state, categories) {
      state.categories = categories;
    }
  },
  actions: {
    load: function load(_ref) {
      var commit = _ref.commit;

      Object(calls["K" /* getCategories */])().then(function (categories) {
        return commit('setCategories', categories);
      });
    },
    create: function create(context, _ref2) {
      var data = _ref2.data,
          callback = _ref2.callback;

      Object(calls["m" /* createCategory */])(data).then(function (response) {
        responseNotification(context, response, 'Category created!');
        context.dispatch('load');
        if (callback) callback(response);
      }).catch(function (e) {
        console.log('e was', e);
        responseNotification(context, { error: 'Could not create category!' });
      });
    },
    update: function update(context, _ref3) {
      var id = _ref3.id,
          category = _ref3.category,
          callback = _ref3.callback;

      Object(calls["_17" /* updateCategory */])(id, category).then(function (response) {
        responseNotification(context, response, 'Category updated!');
        context.dispatch('load');
        if (callback) callback(response);
      });
    },
    delete: function _delete(context, id) {
      Object(calls["w" /* deleteCategory */])(id).then(function (response) {
        responseNotification(context, response, 'Category deleted!');
        context.dispatch('load');
      });
    }
  },
  modules: {
    formats: {
      namespaced: true,
      state: {
        categoryFormats: []
      },
      mutations: {
        setCategoryFormats: function setCategoryFormats(state, categoryFormats) {
          state.categoryFormats = categoryFormats;
        }
      },
      actions: {
        load: function load(_ref4) {
          var commit = _ref4.commit;

          Object(calls["L" /* getCategoryFormats */])().then(function (categoryFormats) {
            return commit('setCategoryFormats', categoryFormats);
          });
        },
        add: function add(context, payload) {
          Object(calls["a" /* addFormatToCategory */])(payload).then(function (response) {
            responseNotification(context, response, 'Format Added!');
            context.dispatch('categories/load', {}, { root: true });
            context.dispatch('load');
          });
        },
        delete: function _delete(context, id) {
          Object(calls["A" /* deleteFormatFromCategory */])(id).then(function (response) {
            responseNotification(context, response, 'Format Removed!');
            context.dispatch('categories/load', {}, { root: true });
            context.dispatch('load');
          });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/store/formats.js
/** VUEX module for format management **/




/* harmony default export */ var store_formats = ({
  namespaced: true,
  state: {
    formats: [],
    searchFilter: '',
    allFormats: [],
    selectedFormats: []
  },
  getters: {
    formats: function formats(state, getters, rootState) {
      var formats = state.formats;
      if (rootState.account && rootState.account.has_selected_formats) {
        formats = state.selectedFormats;
      }
      if (state.searchFilter) {
        return formats.filter(function (item) {
          return item.name.toLowerCase().indexOf(state.searchFilter.toLowerCase()) > -1;
        });
      }
      return formats;
    },
    unfiltered: function unfiltered(state) {
      return state.formats;
    },
    allFormats: function allFormats(state) {
      return state.allFormats;
    },
    custom: function custom(state) {
      if (state.searchFilter) {
        return state.formats.filter(function (format) {
          return format.custom;
        }).filter(function (item) {
          return item.name.toLowerCase().indexOf(state.searchFilter.toLowerCase()) > -1;
        });
      }
      return state.formats.filter(function (format) {
        return format.custom;
      });
    }
  },
  mutations: {
    setSearchFilter: function setSearchFilter(state, value) {
      state.searchFilter = value;
    },
    setFormats: function setFormats(state, formats) {
      state.formats = formats;
    },
    setAllFormats: function setAllFormats(state, formats) {
      state.allFormats = formats;
    },
    setSelectedFormats: function setSelectedFormats(state, formats) {
      state.selectedFormats = formats;
    },
    updateSort: function updateSort(state, formats) {
      var _this = this;

      if (state.formats.length != formats.length) {
        responseNotification(this, { error: 'Must sort original list of ads only! (Clear Search)' });
        return;
      }
      state.formats = formats;
      var format_ids = formats.map(function (obj) {
        return obj.id;
      });
      Object(calls["_22" /* updateSortFormats */])(format_ids).then(function (response) {
        responseNotification(_this, {}, 'Successfully Updated Order!');
      });
    }
  },
  actions: {
    load: function load(_ref) {
      var commit = _ref.commit;

      return Object(calls["P" /* getFormats */])().then(function (formats) {
        commit('setFormats', formats);
        return formats;
      });
    },
    loadAll: function loadAll(_ref2) {
      var commit = _ref2.commit;

      return Object(calls["J" /* getAllFormats */])().then(function (formats) {
        return commit('setAllFormats', formats);
      });
    },
    loadSelected: function loadSelected(_ref3) {
      var commit = _ref3.commit;

      return Object(calls["U" /* getSelectedFormats */])().then(function (formats) {
        return commit('setSelectedFormats', formats);
      });
    },
    update: function update(context, _ref4) {
      var id = _ref4.id,
          payload = _ref4.payload,
          callback = _ref4.callback;

      Object(calls["_19" /* updateFormat */])(id, payload).then(function (response) {
        responseNotification(context, response, 'Format updated!');
        context.dispatch('loadAll');
        if (callback) callback(response);
      });
    },
    delete: function _delete(context, id) {
      Object(calls["z" /* deleteFormat */])(id).then(function (response) {
        responseNotification(context, response, 'Format Deleted!');
        context.dispatch('formats/loadAll', {}, { root: true });
      });
    }
  }
});
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Home = ({
  name: 'Home',
  computed: {
    formats: function formats() {
      return this.$store.getters['formats/formats'];
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$tours['home_tour'].isRunning) {
      this.$tours['home_tour'].stop();
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      if (_this.$store.state.me.errors !== 'unauthorized') {
        var homeTour = _this.$store.state.preferences['home_tour'];
        if (!homeTour || homeTour !== 'finished') {
          //this.$tours['home_tour'].start();
        }
      }
      FS.event('Viewing Formats', {
        category_name: 'Home',
        category_id: 0
      });
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4398e1a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('section',{staticClass:"main-content__full section"},[_c('header',{staticClass:"section__header"},[_c('h1',{staticClass:"section__title"},[_vm._v("Browse formats")]),_vm._v(" "),_c('section',{staticClass:"section__header__area"},[_c('form',{staticClass:"search"},[_c('input-search',{attrs:{"placeholder":"Search formats"},on:{"submit":function($event){$event.preventDefault();}}})],1)])])]),_vm._v(" "),_c('aside',{staticClass:"main-content__side section"},[_c('categories-listing',{staticClass:"section__content categories"})],1),_vm._v(" "),_c('section',{staticClass:"main-content__main section",attrs:{"data-v-home-step":"1"}},[_c('format-listing',{staticClass:"section__content formats formats--list",attrs:{"formats":_vm.formats}})],1)])}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function injectStyle (ssrContext) {
  __webpack_require__("J+Kq")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-4398e1a3"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Categories.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Categories = ({
  name: 'Categories'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ac43fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Categories.vue
var Categories_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('section',{staticClass:"main-content__full section"},[_c('header',{staticClass:"section__header"},[_c('nav',{staticClass:"breadcrumb"},[_c('ul',{staticClass:"breadcrumb__list"},[_c('li',{staticClass:"breadcrumb__level"},[_c('router-link',{staticClass:"breadcrumb__link",attrs:{"to":"/"}},[_vm._v("Categories")])],1),_vm._v(" "),_vm._m(0,false,false)])])]),_vm._v(" "),_c('categories-listing',{staticClass:"section__content categories categories--full"})],1)])}
var Categories_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb__level"},[_c('a',{staticClass:"breadcrumb__link breadcrumb__link--inactive"},[_vm._v("All categories")])])}]
var Categories_esExports = { render: Categories_render, staticRenderFns: Categories_staticRenderFns }
/* harmony default export */ var components_Categories = (Categories_esExports);
// CONCATENATED MODULE: ./src/components/Categories.vue
var Categories_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Categories___vue_template_functional__ = false
/* styles */
var Categories___vue_styles__ = null
/* scopeId */
var Categories___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Categories___vue_module_identifier__ = null
var Categories_Component = Categories_normalizeComponent(
  Categories,
  components_Categories,
  Categories___vue_template_functional__,
  Categories___vue_styles__,
  Categories___vue_scopeId__,
  Categories___vue_module_identifier__
)

/* harmony default export */ var src_components_Categories = (Categories_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Category.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Category = ({
  name: 'Category',
  mounted: function mounted() {
    if (this.$route.params.id == 'invisible') {
      this.$store.dispatch('formats/loadAll');
    }
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('categories', ['categories']), Object(vuex_esm["b" /* mapState */])('users', ['favorites']), Object(vuex_esm["b" /* mapState */])(['account']), {
    getFormats: function getFormats() {
      var _this = this;

      if (!this.category.formats) return;
      this.category.formats.sort(function (a, b) {
        return a.sort - b.sort;
      });
      if (this.$route.params.id != 'invisible') {
        this.category.formats.filter(function (item) {
          return item.visible;
        });
      }
      FS.event('Viewing Formats', {
        category_name_str: this.category.name,
        category_id: this.category.id
      });
      if (this.$store.state.formats.searchFilter) {
        return this.category.formats.filter(function (item) {
          return item.name.toLowerCase().indexOf(_this.$store.state.formats.searchFilter.toLowerCase()) > -1;
        });
      } else {
        return this.category.formats;
      }
    },
    category: function category() {
      if (this.$route.params.id == 'favorites') {
        var rtnVal = {
          name: 'Favorites',
          formats: []
        };
        var formats = this.$store.getters['formats/formats'];
        var favorites = this.favorites;
        if (formats && favorites) {
          formats.forEach(function (format) {
            favorites.forEach(function (favorite) {
              if (format.id === favorite.format_id) {
                rtnVal.formats.push(format);
              }
            });
          });
          return rtnVal;
        }
      } else if (this.$route.params.id == 'recent') {
        var _rtnVal = {
          name: 'Recently Released',
          formats: []
        };
        var _formats = this.$store.getters['formats/formats'];
        if (_formats) {
          _formats.forEach(function (format) {
            var today = new Date();
            if (new Date(format.updated_at) > new Date().setDate(today.getDate() - 30)) {
              _rtnVal.formats.push(format);
            }
          });
        }
        return _rtnVal;
      } else if (this.$route.params.id == 'custom') {
        var _rtnVal2 = {
          name: '',
          formats: []
        };
        var accountFormats = this.$store.getters['formats/custom'];
        if (accountFormats) {
          _rtnVal2.name = this.account.name + ' Premium';
          accountFormats.forEach(function (af) {
            _rtnVal2.formats.push(af);
          });
        }
        return _rtnVal2;
      } else if (this.$route.params.id == 'invisible') {
        var _rtnVal3 = {
          name: 'Non Public Ads',
          description: 'Ads that are not visible to the public consumer base.',
          formats: []
        };
        var _accountFormats = this.$store.state.formats.allFormats;
        if (_accountFormats) {
          _accountFormats.forEach(function (af) {
            if (!af.visible) {
              _rtnVal3.formats.push(af);
            }
          });
          return _rtnVal3;
        }
      } else {
        var categoryId = parseInt(this.$route.params.id, 10);

        var category = this.categories.filter(function (category) {
          return categoryId === category.id;
        })[0];

        return category ? category : {};
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987ff94a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category.vue
var Category_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('section',{staticClass:"main-content__full section"},[_c('header',{staticClass:"section__header"},[_c('h1',{staticClass:"section__title"},[_vm._v("Browse formats: "+_vm._s(_vm.category.name))]),_vm._v(" "),_c('section',{staticClass:"section__header__area"},[_c('form',{staticClass:"search"},[_c('input-search',{attrs:{"placeholder":"Search formats"}})],1)])])]),_vm._v(" "),_c('aside',{staticClass:"main-content__side section"},[_c('categories-listing',{staticClass:"section__content categories"})],1),_vm._v(" "),_c('section',{staticClass:"main-content__main section"},[_c('h1',{staticClass:"section__title"},[_vm._v(_vm._s(_vm.category.name))]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('h1',{staticClass:"section__subtitle"},[_vm._v(_vm._s(_vm.category.description))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('format-listing',{staticClass:"section__content formats formats--list",attrs:{"formats":_vm.getFormats}})],1)])}
var Category_staticRenderFns = []
var Category_esExports = { render: Category_render, staticRenderFns: Category_staticRenderFns }
/* harmony default export */ var components_Category = (Category_esExports);
// CONCATENATED MODULE: ./src/components/Category.vue
var Category_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Category___vue_template_functional__ = false
/* styles */
var Category___vue_styles__ = null
/* scopeId */
var Category___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Category___vue_module_identifier__ = null
var Category_Component = Category_normalizeComponent(
  Category,
  components_Category,
  Category___vue_template_functional__,
  Category___vue_styles__,
  Category___vue_scopeId__,
  Category___vue_module_identifier__
)

/* harmony default export */ var src_components_Category = (Category_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/TimeSpan.vue
//
//
//
//
//
//


/* harmony default export */ var TimeSpan = ({
  name: 'TimeSpan',
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  props: ['defaultValue'],
  data: function data() {
    return {
      timespan: this.defaultValue || null
    };
  },

  watch: {
    timespan: function timespan(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a0a7a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TimeSpan.vue
var TimeSpan_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timespan),expression:"timespan"}],staticClass:"input__field",attrs:{"type":"number","min":"1","step":"1","onkeypress":"return event.charCode >= 48 && event.charCode <= 57"},domProps:{"value":(_vm.timespan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timespan=$event.target.value}}})])}
var TimeSpan_staticRenderFns = []
var TimeSpan_esExports = { render: TimeSpan_render, staticRenderFns: TimeSpan_staticRenderFns }
/* harmony default export */ var common_TimeSpan = (TimeSpan_esExports);
// CONCATENATED MODULE: ./src/components/common/TimeSpan.vue
var TimeSpan_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TimeSpan___vue_template_functional__ = false
/* styles */
var TimeSpan___vue_styles__ = null
/* scopeId */
var TimeSpan___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TimeSpan___vue_module_identifier__ = null
var TimeSpan_Component = TimeSpan_normalizeComponent(
  TimeSpan,
  common_TimeSpan,
  TimeSpan___vue_template_functional__,
  TimeSpan___vue_styles__,
  TimeSpan___vue_scopeId__,
  TimeSpan___vue_module_identifier__
)

/* harmony default export */ var components_common_TimeSpan = (TimeSpan_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/TimeSpanInput.vue
//
//
//
//
//
//



/* harmony default export */ var TimeSpanInput = ({
  name: 'DateTimeInput',
  components: {
    TimeSpan: components_common_TimeSpan
  },
  props: ['settings', 'defaultValue', 'id'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5568bfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/TimeSpanInput.vue
var TimeSpanInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('time-span',{attrs:{"id":_vm.id,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var TimeSpanInput_staticRenderFns = []
var TimeSpanInput_esExports = { render: TimeSpanInput_render, staticRenderFns: TimeSpanInput_staticRenderFns }
/* harmony default export */ var configurator_TimeSpanInput = (TimeSpanInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/TimeSpanInput.vue
var TimeSpanInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TimeSpanInput___vue_template_functional__ = false
/* styles */
var TimeSpanInput___vue_styles__ = null
/* scopeId */
var TimeSpanInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TimeSpanInput___vue_module_identifier__ = null
var TimeSpanInput_Component = TimeSpanInput_normalizeComponent(
  TimeSpanInput,
  configurator_TimeSpanInput,
  TimeSpanInput___vue_template_functional__,
  TimeSpanInput___vue_styles__,
  TimeSpanInput___vue_scopeId__,
  TimeSpanInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_TimeSpanInput = (TimeSpanInput_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-editor/dist/vue2-editor.js
var vue2_editor = __webpack_require__("aYpo");
var vue2_editor_default = /*#__PURE__*/__webpack_require__.n(vue2_editor);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/RichText.vue
//
//
//
//
//
//



/* harmony default export */ var RichText = ({
  name: 'RichText',
  components: {
    VueEditor: vue2_editor["VueEditor"]
  },
  props: ['defaultValue', 'id'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      content: this.defaultValue || null
    };
  },

  watch: {
    content: function content(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-900bbbb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RichText.vue
var RichText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"500px"}},[_c('vue-editor',{attrs:{"id":_vm.id},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var RichText_staticRenderFns = []
var RichText_esExports = { render: RichText_render, staticRenderFns: RichText_staticRenderFns }
/* harmony default export */ var common_RichText = (RichText_esExports);
// CONCATENATED MODULE: ./src/components/common/RichText.vue
var RichText_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var RichText___vue_template_functional__ = false
/* styles */
var RichText___vue_styles__ = null
/* scopeId */
var RichText___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RichText___vue_module_identifier__ = null
var RichText_Component = RichText_normalizeComponent(
  RichText,
  common_RichText,
  RichText___vue_template_functional__,
  RichText___vue_styles__,
  RichText___vue_scopeId__,
  RichText___vue_module_identifier__
)

/* harmony default export */ var components_common_RichText = (RichText_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/RichTextInput.vue
//
//
//
//
//
//



/* harmony default export */ var RichTextInput = ({
  name: 'RichTextInput',
  components: {
    RichText: components_common_RichText
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  props: ['defaultValue', 'id'],
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b003b592","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/RichTextInput.vue
var RichTextInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input config_input"},[_c('rich-text',{attrs:{"id":_vm.id,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var RichTextInput_staticRenderFns = []
var RichTextInput_esExports = { render: RichTextInput_render, staticRenderFns: RichTextInput_staticRenderFns }
/* harmony default export */ var configurator_RichTextInput = (RichTextInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/RichTextInput.vue
var RichTextInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var RichTextInput___vue_template_functional__ = false
/* styles */
var RichTextInput___vue_styles__ = null
/* scopeId */
var RichTextInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RichTextInput___vue_module_identifier__ = null
var RichTextInput_Component = RichTextInput_normalizeComponent(
  RichTextInput,
  configurator_RichTextInput,
  RichTextInput___vue_template_functional__,
  RichTextInput___vue_styles__,
  RichTextInput___vue_scopeId__,
  RichTextInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_RichTextInput = (RichTextInput_Component.exports);

// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.js
var vue_fontawesome = __webpack_require__("U0v6");
var vue_fontawesome_default = /*#__PURE__*/__webpack_require__.n(vue_fontawesome);

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome/styles.css
var styles = __webpack_require__("HWO9");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome/index.es.js
var index_es = __webpack_require__("QxPg");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-free-solid/index.es.js
var fontawesome_free_solid_index_es = __webpack_require__("1P+R");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/FileUpload.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







index_es["default"].config = {
  autoAddCss: false
};

index_es["default"].library.add(fontawesome_free_solid_index_es["c" /* faSpinner */]);

/* harmony default export */ var FileUpload = ({
  name: 'FileUpload',
  components: {
    FontAwesomeIcon: vue_fontawesome_default.a
  },
  props: ['id', 'defaultValue'],
  methods: {
    update: function update(value) {
      // if it's an image return all the info
      this.$emit('input', value.sizes ? value : value.url);
    },
    onFileGiven: function onFileGiven(e) {
      // Depreciated
      var input = event.target;
      var file = input.files[0];

      var reader = new FileReader();
      this.uploading = true;
      reader.onload = function () {
        var dataURL = reader.result;

        Object(calls["_25" /* uploadFile */])(dataURL, file).then(function (data) {
          this.uploading = false;
          return data.json();
        }.bind(this)).then(function (json) {
          if (json.url) {
            this.file = json;
            this.fileURL = json.url;
          }
        }.bind(this));
      }.bind(this);

      if (file) {
        reader.readAsDataURL(file);
        this.fileName = file.name;
      } else {
        this.uploading = false;
      }
    },
    upload_it: function upload_it(fileName, remoteUrl, extType) {
      this.uploading = true;
      Object(calls["_26" /* uploadRemoteFile */])(remoteUrl, extType).then(function (data) {
        this.uploading = false;
        return data.json();
      }.bind(this)).then(function (json) {
        if (json.url) {
          this.file = json;
          this.fileURL = json.url;
        }
      }.bind(this));

      if (remoteUrl) {
        this.fileName = fileName;
      } else {
        this.uploading = false;
      }
    }
  },
  mounted: function mounted() {
    var widget = uploadcare.Widget('[role=uploadcare-uploader-' + this.id + ']');
    var func = this;
    widget.onUploadComplete(function (info) {
      func.upload_it(info.name, info.cdnUrl, info.mimeType);
    });
  },
  data: function data() {
    return {
      file: this.defaultValue || null,
      fileURL: this.defaultValue || null,
      fileName: null,
      uploading: false
    };
  },

  watch: {
    fileURL: function fileURL(newVal) {},
    file: function file(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0009a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FileUpload.vue
var FileUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"right","margin":"10px 0"}},[_c('svg',{staticStyle:{"position":"absolute"},attrs:{"width":"0","height":"0"}},[_c('symbol',{attrs:{"id":"uploadcare--icon-localhistory","viewBox":"0 0 32 32"}},[_c('g',[_c('path',{attrs:{"d":"M21.3,5c-2.9-1.3-6.2-1.4-9.2-0.2C10.1,5.6,8.3,6.9,7,8.6L6.5,6.8C6.4,6.2,5.9,5.9,5.3,6C4.8,6.2,4.5,6.7,4.6,7.2l1,4.1   c0.1,0.5,0.5,0.8,1,0.8c0.1,0,0.2,0,0.2,0l4.1-1c0.5-0.1,0.9-0.7,0.7-1.2C11.6,9.3,11,9,10.5,9.2L8.8,9.6c1.1-1.3,2.4-2.3,4-2.9   c2.5-1,5.2-0.9,7.7,0.2c2.4,1.1,4.3,3,5.3,5.5c1,2.5,0.9,5.2-0.2,7.7s-3,4.3-5.5,5.3c-3.5,1.3-7.4,0.7-10.2-1.8   c-1.2-1.1-2.2-2.4-2.8-3.9c-0.2-0.5-0.8-0.8-1.3-0.6c-0.5,0.2-0.8,0.8-0.6,1.3c0.7,1.8,1.9,3.5,3.3,4.7c2.2,1.9,5,2.9,7.9,2.9   c1.5,0,2.9-0.3,4.3-0.8c3-1.2,5.3-3.4,6.6-6.3c1.3-2.9,1.4-6.2,0.2-9.2S24.3,6.3,21.3,5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16.5,10c-0.6,0-1,0.4-1,1v6c0,0.3,0.1,0.6,0.4,0.8l4,3c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.4   c0.3-0.4,0.2-1.1-0.2-1.4l-3.6-2.7V11C17.5,10.4,17.1,10,16.5,10z"}})])])]),_vm._v(" "),_c('svg',{staticStyle:{"position":"absolute"},attrs:{"width":"0","height":"0"}},[_c('symbol',{attrs:{"id":"uploadcare--icon-googlesearch","viewBox":"0 0 900 900"}},[_c('g',{attrs:{"transform":"translate(0.000000,900.000000) scale(0.100000,-0.100000)"}},[_c('path',{attrs:{"d":"M4320 8624 c-1565 -141 -2920 -1153 -3493 -2609 -257 -654 -342 -1347 -251 -2060 212 -1668 1471 -3072 3114 -3474 510 -124 1029 -151 1620 -85 1160 131 2072 666 2665 1564 206 312 342 595 467 975 210 635 279 1391 187 2040 -19 132 -64 374 -72 382 -2 1 -916 6 -2030 10 l-2027 6 0 -936 0 -937 1035 0 c595 0 1035 -4 1035 -9 0 -5 -27 -61 -59 -124 -147 -288 -359 -534 -616 -715 -100 -70 -310 -179 -435 -225 -333 -124 -734 -164 -1100 -111 -960 139 -1716 895 -1867 1865 -24 157 -24 481 0 638 138 887 784 1604 1642 1820 193 48 328 65 535 65 558 2 1033 -178 1479 -557 l93 -80 679 679 c374 373 678 683 676 689 -5 15 -202 191 -314 283 -832 673 -1906 1001 -2963 906z"}})])])]),_vm._v(" "),_c('svg',{staticStyle:{"position":"absolute"},attrs:{"width":"0","height":"0"}},[_c('symbol',{attrs:{"id":"uploadcare--icon-pexels","viewBox":"0 0 32 32"}},[_c('g',{attrs:{"transform":"translate(0.000000,32.000000) scale(0.01,-0.01)","stroke":"none"}},[_c('path',{attrs:{"d":"M105 2983 c-44 -23 -65 -44 -86 -85 -18 -36 -19 -82 -19 -1398 0 -1316 1 -1362 19 -1398 22 -42 43 -63 88 -86 29 -14 158 -16 1393 -16 1316 0 1362 1 1398 19 42 22 63 43 86 88 14 29 16 158 16 1393 0 1235 -2 1364 -16 1393 -23 45 -44 66 -86 88 -36 18 -82 19 -1400 19 -1224 -1 -1366 -2 -1393 -17z m1687 -834 c221 -46 379 -241 379 -467 0 -146 -47 -261 -148 -357 -51 -49 -162 -110 -219 -121 l-34 -6 0 -179 0 -179 -370 0 -370 0 0 660 0 660 355 0 c219 0 374 -4 407 -11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M1220 1500 l0 -460 180 0 180 0 0 174 0 174 98 4 c110 5 152 21 214 84 59 58 83 117 83 199 -1 118 -60 210 -169 261 -50 23 -58 24 -318 24 l-268 0 0 -460z"}})])])]),_vm._v(" "),_c('svg',{staticStyle:{"position":"absolute"},attrs:{"width":"0","height":"0"}},[_c('symbol',{attrs:{"id":"uploadcare--icon-pixabay","viewBox":"0 0 32 32"}},[_c('g',{attrs:{"transform":"translate(0.000000,25.000000) scale(0.01,-0.01)","stroke":"none"}},[_c('path',{attrs:{"d":"M1406 1972 c-10 -17 -106 -297 -106 -310 0 -10 15 -12 58 -10 l57 3 30 90 c16 50 30 91 31 93 1 2 636 -237 642 -243 1 -1 -32 -90 -74 -196 -41 -107 -80 -204 -85 -216 l-8 -23 -53 21 c-88 36 -83 37 -80 -30 l4 -60 90 -36 c50 -20 95 -34 100 -33 14 5 259 631 250 639 -10 8 -828 319 -841 319 -5 0 -12 -4 -15 -8z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M840 1649 c0 -43 -18 -59 -65 -59 l-45 0 0 -290 0 -290 510 0 510 0 0 290 0 290 -328 0 c-328 0 -329 0 -349 23 -11 12 -23 30 -26 40 -6 15 -20 17 -107 17 -94 0 -100 -1 -100 -21z m647 -175 c78 -45 112 -142 79 -227 -75 -196 -367 -160 -384 48 -13 161 159 262 305 179z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M1340 1423 c-31 -11 -70 -58 -76 -90 -13 -69 41 -133 113 -133 87 0 145 81 110 155 -27 56 -94 87 -147 68z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M1560 588 c0 -206 3 -238 19 -273 79 -170 319 -183 411 -22 70 122 17 278 -112 331 -24 11 -69 16 -128 16 l-90 0 0 90 0 90 -50 0 -50 0 0 -232z m297 -68 c18 -10 39 -33 48 -49 60 -117 -71 -239 -183 -171 -45 27 -62 74 -62 165 l0 75 83 0 c64 0 89 -4 114 -20z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M497 644 c-4 -4 -7 -110 -7 -236 l0 -228 50 0 50 0 -2 233 -3 232 -40 3 c-23 2 -44 0 -48 -4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M630 636 c0 -5 6 -17 14 -25 16 -19 136 -190 136 -195 0 -2 -38 -54 -85 -115 -47 -62 -85 -114 -85 -117 0 -2 28 -4 63 -4 l62 1 55 75 c30 42 58 78 62 80 3 2 32 -32 65 -76 l58 -79 63 -1 c57 0 77 10 52 25 -5 3 -43 53 -85 110 l-76 104 76 106 c41 58 75 109 75 113 0 4 -28 6 -63 4 l-62 -3 -49 -75 -49 -75 -34 48 c-19 26 -42 60 -50 75 -15 23 -23 27 -80 30 -35 2 -63 -1 -63 -6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M1253 639 c-59 -11 -96 -32 -136 -79 -92 -108 -65 -269 57 -345 48 -29 52 -30 203 -33 l153 -3 0 128 c0 70 -5 144 -10 164 -32 115 -149 188 -267 168z m112 -119 c43 -27 48 -39 54 -148 l6 -92 -81 0 c-68 0 -87 4 -115 23 -66 44 -83 121 -42 184 35 54 120 69 178 33z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M140 624 c-45 -19 -97 -69 -121 -116 -17 -34 -19 -60 -19 -273 l0 -235 50 0 50 0 0 90 0 90 90 0 c103 0 147 14 199 63 95 90 95 244 0 334 -19 18 -51 39 -71 47 -47 20 -132 20 -178 0z m145 -98 c91 -39 99 -173 12 -226 -25 -16 -50 -20 -114 -20 l-83 0 0 80 c0 93 15 131 63 160 38 24 75 25 122 6z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2163 610 c-137 -79 -157 -256 -41 -367 56 -54 91 -63 248 -63 l140 0 0 140 c0 157 -9 192 -63 248 -49 52 -97 72 -169 72 -52 0 -72 -6 -115 -30z m185 -90 c45 -27 62 -74 62 -165 l0 -75 -75 0 c-43 0 -90 6 -110 14 -74 31 -99 136 -48 196 14 18 36 36 47 40 37 15 90 11 124 -10z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2540 503 c0 -124 3 -143 24 -188 25 -54 71 -100 123 -122 43 -17 125 -17 170 2 44 18 43 18 43 0 0 -8 -15 -32 -33 -52 -30 -32 -41 -37 -90 -41 l-57 -4 0 -50 0 -50 69 4 c81 4 135 34 178 100 l28 41 3 249 3 248 -51 0 -50 0 0 -141 0 -141 -33 -33 c-57 -57 -132 -59 -185 -5 -36 36 -42 64 -42 206 l0 114 -50 0 -50 0 0 -137z"}})])])]),_vm._v(" "),_c('input',{staticClass:"file",attrs:{"id":_vm.id,"type":"hidden","role":'uploadcare-uploader-' + _vm.id,"data-crop":"free, 1:1, 2:1, 4:1, 3:1, 1:2, 16:9"}}),_vm._v(" "),(_vm.uploading)?_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"spinner"}}):_vm._e()],1)}
var FileUpload_staticRenderFns = []
var FileUpload_esExports = { render: FileUpload_render, staticRenderFns: FileUpload_staticRenderFns }
/* harmony default export */ var common_FileUpload = (FileUpload_esExports);
// CONCATENATED MODULE: ./src/components/common/FileUpload.vue
var FileUpload_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FileUpload___vue_template_functional__ = false
/* styles */
var FileUpload___vue_styles__ = null
/* scopeId */
var FileUpload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FileUpload___vue_module_identifier__ = null
var FileUpload_Component = FileUpload_normalizeComponent(
  FileUpload,
  common_FileUpload,
  FileUpload___vue_template_functional__,
  FileUpload___vue_styles__,
  FileUpload___vue_scopeId__,
  FileUpload___vue_module_identifier__
)

/* harmony default export */ var components_common_FileUpload = (FileUpload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/FileUploadInput.vue
//
//
//
//
//
//



/* harmony default export */ var FileUploadInput = ({
  name: 'FileUploadInput',
  components: {
    FileUpload: components_common_FileUpload
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  props: ['defaultValue', 'id'],
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54be2c7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/FileUploadInput.vue
var FileUploadInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('file-upload',{attrs:{"id":_vm.id,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var FileUploadInput_staticRenderFns = []
var FileUploadInput_esExports = { render: FileUploadInput_render, staticRenderFns: FileUploadInput_staticRenderFns }
/* harmony default export */ var configurator_FileUploadInput = (FileUploadInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/FileUploadInput.vue
var FileUploadInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FileUploadInput___vue_template_functional__ = false
/* styles */
var FileUploadInput___vue_styles__ = null
/* scopeId */
var FileUploadInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FileUploadInput___vue_module_identifier__ = null
var FileUploadInput_Component = FileUploadInput_normalizeComponent(
  FileUploadInput,
  configurator_FileUploadInput,
  FileUploadInput___vue_template_functional__,
  FileUploadInput___vue_styles__,
  FileUploadInput___vue_scopeId__,
  FileUploadInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_FileUploadInput = (FileUploadInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/ImageUpload.vue
//
//
//
//
//
//
//



/* harmony default export */ var ImageUpload = ({
  name: 'ImageUpload',
  components: {
    FileUpload: components_common_FileUpload
  },
  props: ['id', 'defaultValue'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      file: this.defaultValue || null
    };
  },

  watch: {
    file: function file(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50eed233","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ImageUpload.vue
var ImageUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('file-upload',{attrs:{"id":_vm.id},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_vm._v(" "),(_vm.file)?_c('img',{attrs:{"src":_vm.file.url,"width":"250"}}):_vm._e()],1)}
var ImageUpload_staticRenderFns = []
var ImageUpload_esExports = { render: ImageUpload_render, staticRenderFns: ImageUpload_staticRenderFns }
/* harmony default export */ var common_ImageUpload = (ImageUpload_esExports);
// CONCATENATED MODULE: ./src/components/common/ImageUpload.vue
var ImageUpload_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ImageUpload___vue_template_functional__ = false
/* styles */
var ImageUpload___vue_styles__ = null
/* scopeId */
var ImageUpload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ImageUpload___vue_module_identifier__ = null
var ImageUpload_Component = ImageUpload_normalizeComponent(
  ImageUpload,
  common_ImageUpload,
  ImageUpload___vue_template_functional__,
  ImageUpload___vue_styles__,
  ImageUpload___vue_scopeId__,
  ImageUpload___vue_module_identifier__
)

/* harmony default export */ var components_common_ImageUpload = (ImageUpload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/ImageUploadInput.vue
//
//
//
//
//
//



/* harmony default export */ var ImageUploadInput = ({
  name: 'ImageUploadInput',
  components: {
    ImageUpload: components_common_ImageUpload
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  props: ['defaultValue', 'id'],
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2289448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/ImageUploadInput.vue
var ImageUploadInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('image-upload',{attrs:{"id":_vm.id,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var ImageUploadInput_staticRenderFns = []
var ImageUploadInput_esExports = { render: ImageUploadInput_render, staticRenderFns: ImageUploadInput_staticRenderFns }
/* harmony default export */ var configurator_ImageUploadInput = (ImageUploadInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/ImageUploadInput.vue
var ImageUploadInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ImageUploadInput___vue_template_functional__ = false
/* styles */
var ImageUploadInput___vue_styles__ = null
/* scopeId */
var ImageUploadInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ImageUploadInput___vue_module_identifier__ = null
var ImageUploadInput_Component = ImageUploadInput_normalizeComponent(
  ImageUploadInput,
  configurator_ImageUploadInput,
  ImageUploadInput___vue_template_functional__,
  ImageUploadInput___vue_styles__,
  ImageUploadInput___vue_scopeId__,
  ImageUploadInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_ImageUploadInput = (ImageUploadInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/String.vue
//
//
//
//
//
//


/* harmony default export */ var configurator_String = ({
  name: 'String',
  components: {},
  props: ['settings', 'defaultValue'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4160f223","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/String.vue
var String_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"input__field",attrs:{"type":"text","value":""},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var String_staticRenderFns = []
var String_esExports = { render: String_render, staticRenderFns: String_staticRenderFns }
/* harmony default export */ var components_configurator_String = (String_esExports);
// CONCATENATED MODULE: ./src/components/configurator/String.vue
var String_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var String___vue_template_functional__ = false
/* styles */
var String___vue_styles__ = null
/* scopeId */
var String___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var String___vue_module_identifier__ = null
var String_Component = String_normalizeComponent(
  configurator_String,
  components_configurator_String,
  String___vue_template_functional__,
  String___vue_styles__,
  String___vue_scopeId__,
  String___vue_module_identifier__
)

/* harmony default export */ var src_components_configurator_String = (String_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/Number.vue
//
//
//
//
//
//


/* harmony default export */ var configurator_Number = ({
  name: 'Number',
  components: {},
  props: ['settings', 'defaultValue'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25bbb582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/Number.vue
var Number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"input__field",attrs:{"type":"number","value":""},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var Number_staticRenderFns = []
var Number_esExports = { render: Number_render, staticRenderFns: Number_staticRenderFns }
/* harmony default export */ var components_configurator_Number = (Number_esExports);
// CONCATENATED MODULE: ./src/components/configurator/Number.vue
var Number_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Number___vue_template_functional__ = false
/* styles */
var Number___vue_styles__ = null
/* scopeId */
var Number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Number___vue_module_identifier__ = null
var Number_Component = Number_normalizeComponent(
  configurator_Number,
  components_configurator_Number,
  Number___vue_template_functional__,
  Number___vue_styles__,
  Number___vue_scopeId__,
  Number___vue_module_identifier__
)

/* harmony default export */ var src_components_configurator_Number = (Number_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/Boolean.vue
//
//
//
//
//
//
//


/* harmony default export */ var Boolean = ({
  name: 'Boolean',
  components: {},
  props: ['settings', 'defaultValue', 'id'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf7c138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/Boolean.vue
var Boolean_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input switch__container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"switch",attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"switch__label",attrs:{"for":_vm.id}})])}
var Boolean_staticRenderFns = []
var Boolean_esExports = { render: Boolean_render, staticRenderFns: Boolean_staticRenderFns }
/* harmony default export */ var configurator_Boolean = (Boolean_esExports);
// CONCATENATED MODULE: ./src/components/configurator/Boolean.vue
var Boolean_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Boolean___vue_template_functional__ = false
/* styles */
var Boolean___vue_styles__ = null
/* scopeId */
var Boolean___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Boolean___vue_module_identifier__ = null
var Boolean_Component = Boolean_normalizeComponent(
  Boolean,
  configurator_Boolean,
  Boolean___vue_template_functional__,
  Boolean___vue_styles__,
  Boolean___vue_scopeId__,
  Boolean___vue_module_identifier__
)

/* harmony default export */ var components_configurator_Boolean = (Boolean_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/Date.vue
//
//
//
//
//
//



/* harmony default export */ var configurator_Date = ({
  name: 'Date',
  components: {
    VueDatepicker: build_default.a
  },
  props: ['settings', 'defaultValue', 'id'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d97d98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/Date.vue
var Date_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input config_input"},[_c('vue-datepicker',{staticClass:"datepicker_input",attrs:{"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var Date_staticRenderFns = []
var Date_esExports = { render: Date_render, staticRenderFns: Date_staticRenderFns }
/* harmony default export */ var components_configurator_Date = (Date_esExports);
// CONCATENATED MODULE: ./src/components/configurator/Date.vue
var Date_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Date___vue_template_functional__ = false
/* styles */
var Date___vue_styles__ = null
/* scopeId */
var Date___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Date___vue_module_identifier__ = null
var Date_Component = Date_normalizeComponent(
  configurator_Date,
  components_configurator_Date,
  Date___vue_template_functional__,
  Date___vue_styles__,
  Date___vue_scopeId__,
  Date___vue_module_identifier__
)

/* harmony default export */ var src_components_configurator_Date = (Date_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-timepicker/index.js
var vue2_timepicker = __webpack_require__("SVjV");
var vue2_timepicker_default = /*#__PURE__*/__webpack_require__.n(vue2_timepicker);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/Timepicker.vue
//
//
//
//
//
//




/* harmony default export */ var Timepicker = ({
  name: 'Timepicker',
  components: {
    VueTimepicker: vue2_timepicker_default.a
  },
  props: ['settings', 'defaultValue', 'id'],
  methods: {
    onChangeTime: function onChangeTime(newVal) {
      var _newVal$data = newVal.data,
          HH = _newVal$data.HH,
          mm = _newVal$data.mm,
          ss = _newVal$data.ss;

      this.value = { HH: HH, mm: mm, ss: ss };
      this.$emit('input', this.value);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b30133ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/Timepicker.vue
var Timepicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('vue-timepicker',{attrs:{"id":_vm.id,"format":"HH:mm:ss"},on:{"change":function (data){ _vm.onChangeTime(data) }},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var Timepicker_staticRenderFns = []
var Timepicker_esExports = { render: Timepicker_render, staticRenderFns: Timepicker_staticRenderFns }
/* harmony default export */ var configurator_Timepicker = (Timepicker_esExports);
// CONCATENATED MODULE: ./src/components/configurator/Timepicker.vue
var Timepicker_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Timepicker___vue_template_functional__ = false
/* styles */
var Timepicker___vue_styles__ = null
/* scopeId */
var Timepicker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Timepicker___vue_module_identifier__ = null
var Timepicker_Component = Timepicker_normalizeComponent(
  Timepicker,
  configurator_Timepicker,
  Timepicker___vue_template_functional__,
  Timepicker___vue_styles__,
  Timepicker___vue_scopeId__,
  Timepicker___vue_module_identifier__
)

/* harmony default export */ var components_configurator_Timepicker = (Timepicker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/DateTimePicker.vue
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DateTimePicker = ({
  name: 'DateTimePicker',
  components: {
    Datepicker: build_default.a,
    VueTimepicker: vue2_timepicker_default.a
  },
  props: ['defaultValue'],
  methods: {
    update: function update() {
      if (!this.date) return;

      var date = moment_default()(this.date).format('YYYY-MM-DD');
      var _time = this.time,
          HH = _time.HH,
          mm = _time.mm,
          ss = _time.ss;

      var time = HH + ':' + mm + ':' + ss;

      this.$emit('input', date + 'T' + time);
    },
    onChangeTime: function onChangeTime(newVal) {
      var _newVal$data = newVal.data,
          HH = _newVal$data.HH,
          mm = _newVal$data.mm,
          ss = _newVal$data.ss;

      if (!HH) HH = "00";
      if (!mm) mm = "00";
      if (!ss) ss = "00";

      var value = HH + ':' + mm + ':' + ss;
      this.time = { HH: HH, mm: mm, ss: ss };
      this.update();
    }
  },
  computed: {},
  data: function data() {
    var date = null;
    var time = {};
    var s = null;

    try {
      s = this.defaultValue.split('T');
    } catch (e) {}

    try {
      date = s[0];
    } catch (e) {}

    try {
      var s_ = s[1].split(':');
      time = { HH: s_[0], mm: s_[1], ss: s_[2] };
    } catch (e) {}

    return {
      date: date,
      time: time
    };
  },

  watch: {
    date: function date(newVal) {
      this.update();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d84a6266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DateTimePicker.vue
var DateTimePicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"1em","height":"4.25em","text-align":"right"}},[_c('label',{staticStyle:{"margin-bottom":"0.5em !important"}},[_vm._v("Date")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker_input",staticStyle:{"padding-top":"0.75em"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('div',[_c('label',{staticStyle:{"display":"block","margin-bottom":"0.5em","text-align":"right"}},[_vm._v("Time")]),_vm._v(" "),_c('vue-timepicker',{staticStyle:{"float":"right"},attrs:{"format":"HH:mm:ss"},on:{"change":_vm.onChangeTime},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)])}
var DateTimePicker_staticRenderFns = []
var DateTimePicker_esExports = { render: DateTimePicker_render, staticRenderFns: DateTimePicker_staticRenderFns }
/* harmony default export */ var common_DateTimePicker = (DateTimePicker_esExports);
// CONCATENATED MODULE: ./src/components/common/DateTimePicker.vue
var DateTimePicker_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DateTimePicker___vue_template_functional__ = false
/* styles */
var DateTimePicker___vue_styles__ = null
/* scopeId */
var DateTimePicker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DateTimePicker___vue_module_identifier__ = null
var DateTimePicker_Component = DateTimePicker_normalizeComponent(
  DateTimePicker,
  common_DateTimePicker,
  DateTimePicker___vue_template_functional__,
  DateTimePicker___vue_styles__,
  DateTimePicker___vue_scopeId__,
  DateTimePicker___vue_module_identifier__
)

/* harmony default export */ var components_common_DateTimePicker = (DateTimePicker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/DateTimeInput.vue
//
//
//
//
//
//



/* harmony default export */ var DateTimeInput = ({
  name: 'DateTimeInput',
  components: {
    DateTimePicker: components_common_DateTimePicker
  },
  props: ['settings', 'defaultValue', 'id'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a9a3e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/DateTimeInput.vue
var DateTimeInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('date-time-picker',{attrs:{"id":_vm.id,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var DateTimeInput_staticRenderFns = []
var DateTimeInput_esExports = { render: DateTimeInput_render, staticRenderFns: DateTimeInput_staticRenderFns }
/* harmony default export */ var configurator_DateTimeInput = (DateTimeInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/DateTimeInput.vue
var DateTimeInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DateTimeInput___vue_template_functional__ = false
/* styles */
var DateTimeInput___vue_styles__ = null
/* scopeId */
var DateTimeInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DateTimeInput___vue_module_identifier__ = null
var DateTimeInput_Component = DateTimeInput_normalizeComponent(
  DateTimeInput,
  configurator_DateTimeInput,
  DateTimeInput___vue_template_functional__,
  DateTimeInput___vue_styles__,
  DateTimeInput___vue_scopeId__,
  DateTimeInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_DateTimeInput = (DateTimeInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/LongText.vue
//
//
//
//
//
//


/* harmony default export */ var LongText = ({
  name: 'LongText',
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  props: ['defaultValue'],
  data: function data() {
    return {
      text: this.defaultValue || null
    };
  },

  watch: {
    text: function text(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25803608","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LongText.vue
var LongText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"input__field",domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}})])}
var LongText_staticRenderFns = []
var LongText_esExports = { render: LongText_render, staticRenderFns: LongText_staticRenderFns }
/* harmony default export */ var common_LongText = (LongText_esExports);
// CONCATENATED MODULE: ./src/components/common/LongText.vue
var LongText_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LongText___vue_template_functional__ = false
/* styles */
var LongText___vue_styles__ = null
/* scopeId */
var LongText___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LongText___vue_module_identifier__ = null
var LongText_Component = LongText_normalizeComponent(
  LongText,
  common_LongText,
  LongText___vue_template_functional__,
  LongText___vue_styles__,
  LongText___vue_scopeId__,
  LongText___vue_module_identifier__
)

/* harmony default export */ var components_common_LongText = (LongText_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/LongTextInput.vue
//
//
//
//
//
//



/* harmony default export */ var LongTextInput = ({
  name: 'LongTextInput',
  components: {
    LongText: components_common_LongText
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  props: ['defaultValue', 'id'],
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b94e122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/LongTextInput.vue
var LongTextInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('long-text',{attrs:{"id":_vm.id,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var LongTextInput_staticRenderFns = []
var LongTextInput_esExports = { render: LongTextInput_render, staticRenderFns: LongTextInput_staticRenderFns }
/* harmony default export */ var configurator_LongTextInput = (LongTextInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/LongTextInput.vue
var LongTextInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LongTextInput___vue_template_functional__ = false
/* styles */
var LongTextInput___vue_styles__ = null
/* scopeId */
var LongTextInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LongTextInput___vue_module_identifier__ = null
var LongTextInput_Component = LongTextInput_normalizeComponent(
  LongTextInput,
  configurator_LongTextInput,
  LongTextInput___vue_template_functional__,
  LongTextInput___vue_styles__,
  LongTextInput___vue_scopeId__,
  LongTextInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_LongTextInput = (LongTextInput_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-color/dist/vue-color.min.js
var vue_color_min = __webpack_require__("Zzkc");
var vue_color_min_default = /*#__PURE__*/__webpack_require__.n(vue_color_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/ColorPickerInput.vue
//
//
//
//
//
//



/* harmony default export */ var ColorPickerInput = ({
  name: 'ColorPickerInput',
  components: {
    'color-picker': vue_color_min["Chrome"]
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  props: ['defaultValue', 'id'],
  data: function data() {
    return {
      value: this.defaultValue || '#194d33'
    };
  },

  watch: {
    value: function value(newVal) {
      console.log('newVal', newVal);
      this.update(newVal.hex);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5839605a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/ColorPickerInput.vue
var ColorPickerInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('color-picker',{attrs:{"id":_vm.id,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var ColorPickerInput_staticRenderFns = []
var ColorPickerInput_esExports = { render: ColorPickerInput_render, staticRenderFns: ColorPickerInput_staticRenderFns }
/* harmony default export */ var configurator_ColorPickerInput = (ColorPickerInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/ColorPickerInput.vue
var ColorPickerInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ColorPickerInput___vue_template_functional__ = false
/* styles */
var ColorPickerInput___vue_styles__ = null
/* scopeId */
var ColorPickerInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ColorPickerInput___vue_module_identifier__ = null
var ColorPickerInput_Component = ColorPickerInput_normalizeComponent(
  ColorPickerInput,
  configurator_ColorPickerInput,
  ColorPickerInput___vue_template_functional__,
  ColorPickerInput___vue_styles__,
  ColorPickerInput___vue_scopeId__,
  ColorPickerInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_ColorPickerInput = (ColorPickerInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/SelectInput.vue
//
//
//
//
//
//
//
//


/* harmony default export */ var SelectInput = ({
  name: 'SelectInput',
  components: {},
  props: ['settings', 'defaultValue', 'options', 'selectClass'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    },
    getSelectClass: function getSelectClass() {
      return this.selectClass || 'select';
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebe6b4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/SelectInput.vue
var SelectInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],class:_vm.getSelectClass(),on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.options),function(option){return _c('option',{staticClass:"select__option select-preview__option",domProps:{"value":option.value}},[_vm._v(_vm._s(option.label))])}))])}
var SelectInput_staticRenderFns = []
var SelectInput_esExports = { render: SelectInput_render, staticRenderFns: SelectInput_staticRenderFns }
/* harmony default export */ var configurator_SelectInput = (SelectInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/SelectInput.vue
function SelectInput_injectStyle (ssrContext) {
  __webpack_require__("9/BN")
}
var SelectInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SelectInput___vue_template_functional__ = false
/* styles */
var SelectInput___vue_styles__ = SelectInput_injectStyle
/* scopeId */
var SelectInput___vue_scopeId__ = "data-v-7ebe6b4e"
/* moduleIdentifier (server only) */
var SelectInput___vue_module_identifier__ = null
var SelectInput_Component = SelectInput_normalizeComponent(
  SelectInput,
  configurator_SelectInput,
  SelectInput___vue_template_functional__,
  SelectInput___vue_styles__,
  SelectInput___vue_scopeId__,
  SelectInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_SelectInput = (SelectInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/SizeInput.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SizeInput = ({
  name: 'SizeInput',
  components: {
    SelectInput: components_configurator_SelectInput
  },
  props: ['defaultValue', 'options', 'selectClass'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  },
  data: function data() {
    var selectOptions = this.options ? this.options.map(function (item) {
      var label = "";
      if (item.type == 'fixed') {
        label = "Fixed (" + item.width + "x" + item.height + ")";
      } else if (item.type == 'flexible') {
        label = "Flexible (" + item.width + ":" + item.height + ")";
      } else if (item.type == 'dynamic') {
        label = "Dynamic";
      } else if (item.type == 'custom') {
        label = "Custom";
        //if(this.defaultValue) item = this.defaultValue;
      } else if (item.type == 'none') {
        label = "None";
      }

      return { label: label, value: item };
    }) : [];

    var value = this.defaultValue || selectOptions[0].value || {};

    return {
      value: value,
      selectOptions: selectOptions,
      height: value.height,
      width: value.width
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    },
    height: function height(newVal) {
      this.value.height = Number(newVal);
      this.update(this.value);
    },
    width: function width(newVal) {
      this.value.width = Number(newVal);
      this.update(this.value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ef8ece","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/SizeInput.vue
var SizeInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input"},[_c('select-input',{staticStyle:{"min-width":"185px"},attrs:{"selectClass":_vm.selectClass,"options":_vm.selectOptions,"defaultValue":_vm.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),(_vm.value && _vm.value.type == 'custom')?_c('div',{staticStyle:{"text-align":"right","width":"500px"}},[_c('div',{staticStyle:{"display":"inline-block","padding-right":"1em","padding-top":"1em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.width),expression:"width"}],staticClass:"input__field",staticStyle:{"width":"85%"},attrs:{"type":"number","placeholder":_vm.value.width},domProps:{"value":(_vm.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.width=$event.target.value}}}),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","padding-top":"10px"}},[_vm._v("px")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.height),expression:"height"}],staticClass:"input__field",staticStyle:{"width":"85%"},attrs:{"type":"number","placeholder":_vm.value.height},domProps:{"value":(_vm.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.height=$event.target.value}}}),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","padding-top":"10px"}},[_vm._v("px")])])]):_vm._e()],1)}
var SizeInput_staticRenderFns = []
var SizeInput_esExports = { render: SizeInput_render, staticRenderFns: SizeInput_staticRenderFns }
/* harmony default export */ var configurator_SizeInput = (SizeInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/SizeInput.vue
var SizeInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SizeInput___vue_template_functional__ = false
/* styles */
var SizeInput___vue_styles__ = null
/* scopeId */
var SizeInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SizeInput___vue_module_identifier__ = null
var SizeInput_Component = SizeInput_normalizeComponent(
  SizeInput,
  configurator_SizeInput,
  SizeInput___vue_template_functional__,
  SizeInput___vue_styles__,
  SizeInput___vue_scopeId__,
  SizeInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_SizeInput = (SizeInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/LinkInput.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LinkInput = ({
  name: 'LinkInput',
  components: {},
  props: ['settings', 'defaultValue'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    },
    toggleHttp: function toggleHttp() {
      this.https = !this.https;
      var newerVal = this.value;

      if (this.https) {
        newerVal = 'https://' + newerVal.split('http://').join('');
      } else {
        newerVal = 'http://' + newerVal.split('https://').join('');
      }

      this.value = newerVal;
      this.update(newerVal);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null,
      valid: null,
      https: true
    };
  },

  watch: {
    value: function value(newVal) {
      var newerVal = newVal.split('https://').join('');
      newerVal = newerVal.split('http://').join('');
      newerVal = newerVal.split('https://').join('');
      newerVal = newerVal.split('https:/').join('');
      newerVal = newerVal.split('http:/').join('');
      newerVal = newerVal.split('https/').join('');
      newerVal = newerVal.split('http/').join('');
      newerVal = newerVal.split('https:').join('');
      newerVal = newerVal.split('http:').join('');

      if (this.https) {
        newerVal = 'https://' + newerVal;
      } else {
        newerVal = 'http://' + newerVal;
      }

      this.update(newerVal);
      this.value = newerVal;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e3d460c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/LinkInput.vue
var LinkInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input input"},[_c('div',{staticClass:"form__row"},[_c('button',{staticClass:"button button--secondary input__button--subtle",on:{"click":function($event){$event.preventDefault();_vm.toggleHttp($event)}}},[_vm._v("Toggle to: "+_vm._s(_vm.https ? 'http://' : 'https://'))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"input__field",attrs:{"type":"text"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var LinkInput_staticRenderFns = []
var LinkInput_esExports = { render: LinkInput_render, staticRenderFns: LinkInput_staticRenderFns }
/* harmony default export */ var configurator_LinkInput = (LinkInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/LinkInput.vue
var LinkInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LinkInput___vue_template_functional__ = false
/* styles */
var LinkInput___vue_styles__ = null
/* scopeId */
var LinkInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LinkInput___vue_module_identifier__ = null
var LinkInput_Component = LinkInput_normalizeComponent(
  LinkInput,
  configurator_LinkInput,
  LinkInput___vue_template_functional__,
  LinkInput___vue_styles__,
  LinkInput___vue_scopeId__,
  LinkInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_LinkInput = (LinkInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/Scheduler.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Scheduler = ({
  name: 'Scheduler',
  data: function data() {
    return {
      current_datetime: '',
      times: [],
      value: this.defaultValue || null
    };
  },

  props: ['settings', 'defaultValue', 'options'],
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var selection_limits, length, rolling_date, i;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('loadScheduled', _this.$route.params.advertisement_id);

            case 2:
              _context.next = 4;
              return _this.$store.dispatch('loadUpdateRuleLimited', _this.ad.update_rule_id);

            case 4:
              _this.current_datetime = new Date();

              selection_limits = 16;
              length = _this.limited_update_rule.length_of_run_minutes;
              rolling_date = _this.getNearestTimeRounded(_this.current_datetime, length);

              for (i = 0; i < selection_limits; i++) {
                _this.times.push({
                  start_time: rolling_date.toUTCString(),
                  iso_string: rolling_date.toISOString(),
                  string_time: rolling_date,
                  duration: length,
                  available: true,
                  selected: false
                });
                rolling_date = _this.addMinutes(rolling_date, length);
              }

              _this.times.forEach(function (time) {
                if (_this.scheduled.includes(time.iso_string)) {
                  time.available = false;
                }
              });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getTimeOfDay: function getTimeOfDay(date) {
      var hours = new Date(date).getHours();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      return ampm;
    },
    addMinutes: function addMinutes(date, minutes) {
      var newDateObj = new Date();
      newDateObj.setTime(date.getTime() + minutes * 60 * 1000);
      return newDateObj;
    },
    prettyString: function prettyString(date) {
      var temp_date = new Date(date);
      var hours = temp_date.getHours() % 12;
      if (hours == 0) hours = 12;
      temp_date.setHours(hours);
      return temp_date.toTimeString().match(/[0-9][0-9]:[0-9][0-9]/)[0];
    },
    selectTime: function selectTime(time) {
      if (!time.available) return;
      this.times.forEach(function (item) {
        item.selected = false;
      });
      time.selected = true;
      this.value = time.start_time;
    },
    getNearestTimeRounded: function getNearestTimeRounded(time, length) {
      var minutes = time.getMinutes();
      var round_by = void 0;
      if (length / 30 % 2 === 0) {
        round_by = 0;
      } else {
        round_by = 30;
      }
      var round_to = void 0;
      if (minutes <= 30 && round_by == 30) {
        round_to = 30;
      } else {
        round_to = 60;
      }
      var difference = round_to - minutes;
      time.setMinutes(time.getMinutes() + difference);
      time.setSeconds(0);
      time.setMilliseconds(0);
      return time;
    },
    update: function update(value) {
      this.$emit('input', value);
    },
    getStringMonth: function getStringMonth(date) {
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months[date.getMonth()];
    },
    getDuration: function getDuration(minutes) {
      var hours = minutes / 60;
      if (hours > 24) {
        return hours / 24 + ' days';
      } else {
        return hours + ' hours';
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['scheduled', 'limited_update_rule']), Object(vuex_esm["b" /* mapState */])('advertisements', {
    ad: 'single_ad'
  })),
  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b12b2eee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/Scheduler.vue
var Scheduler_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scheduler"},[(_vm.current_datetime)?_c('h4',{staticClass:"headline"},[_vm._v("Today is "+_vm._s(_vm.current_datetime.toDateString()))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("Duration: "+_vm._s(_vm.getDuration(_vm.limited_update_rule.length_of_run_minutes))+" ")]),_c('p'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.times),function(time){return _c('div',{staticClass:"time_item",class:{'unavailable': !time.available, 'selected': time.selected},on:{"click":function($event){_vm.selectTime(time)}}},[_c('h1',[_vm._v(_vm._s(_vm.prettyString(time.string_time))),_c('small',[_vm._v(_vm._s(_vm.getTimeOfDay(time.string_time)))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getStringMonth(time.string_time))),_c('br'),_vm._v(" "+_vm._s(time.string_time.getDate()))]),_c('p')])})],2)}
var Scheduler_staticRenderFns = []
var Scheduler_esExports = { render: Scheduler_render, staticRenderFns: Scheduler_staticRenderFns }
/* harmony default export */ var configurator_Scheduler = (Scheduler_esExports);
// CONCATENATED MODULE: ./src/components/configurator/Scheduler.vue
function Scheduler_injectStyle (ssrContext) {
  __webpack_require__("T+hK")
}
var Scheduler_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Scheduler___vue_template_functional__ = false
/* styles */
var Scheduler___vue_styles__ = Scheduler_injectStyle
/* scopeId */
var Scheduler___vue_scopeId__ = "data-v-b12b2eee"
/* moduleIdentifier (server only) */
var Scheduler___vue_module_identifier__ = null
var Scheduler_Component = Scheduler_normalizeComponent(
  Scheduler,
  configurator_Scheduler,
  Scheduler___vue_template_functional__,
  Scheduler___vue_styles__,
  Scheduler___vue_scopeId__,
  Scheduler___vue_module_identifier__
)

/* harmony default export */ var components_configurator_Scheduler = (Scheduler_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/EmailInput.vue
//
//
//
//
//
//

/* harmony default export */ var EmailInput = ({
  name: 'EmailInput',
  props: ['settings', 'defaultValue', 'options'],
  methods: {
    update: function update(value) {
      this.invalid = this.invalidFormat(value);
      if (value == '') {
        this.invalid = null;
      }
      this.$emit('input', value);
    },
    invalidFormat: function invalidFormat(email) {
      var re = /(\w(=?@)\w+\.{1}[a-zA-Z]{2,})/i;
      return !re.test(email);
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null,
      invalid: null
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-717645ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/EmailInput.vue
var EmailInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input input",class:{ 'input--success': _vm.invalid == false, 'input--error': _vm.invalid }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"input__field input--success",attrs:{"type":"email","value":""},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})])}
var EmailInput_staticRenderFns = []
var EmailInput_esExports = { render: EmailInput_render, staticRenderFns: EmailInput_staticRenderFns }
/* harmony default export */ var configurator_EmailInput = (EmailInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/EmailInput.vue
function EmailInput_injectStyle (ssrContext) {
  __webpack_require__("LnNF")
}
var EmailInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EmailInput___vue_template_functional__ = false
/* styles */
var EmailInput___vue_styles__ = EmailInput_injectStyle
/* scopeId */
var EmailInput___vue_scopeId__ = "data-v-717645ac"
/* moduleIdentifier (server only) */
var EmailInput___vue_module_identifier__ = null
var EmailInput_Component = EmailInput_normalizeComponent(
  EmailInput,
  configurator_EmailInput,
  EmailInput___vue_template_functional__,
  EmailInput___vue_styles__,
  EmailInput___vue_scopeId__,
  EmailInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_EmailInput = (EmailInput_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/lib/PlaceEventHandler.js


var fields = ['place_id', 'geometry', 'name', 'formatted_address'];

var mapsScriptInjected = false;

function injectMapScript() {
  if (!mapsScriptInjected) {
    var placeScript = document.createElement('script');
    placeScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBHpEudkaJz_RnsBeyqrFvmgxhhqbG9ViM&libraries=places';
    document.head.appendChild(placeScript);
    mapsScriptInjected = true;
  }
}

var PlaceEventHandler_PlaceEventHandler = function () {
  function PlaceEventHandler(map, origin, opts) {
    classCallCheck_default()(this, PlaceEventHandler);

    this.origin = null;
    this.map = null;
    this.placesService = null;
    this.infowindow = null;
    this.infowindowContent = null;
    this.opts = null;
    this.marker = null;
    this.autocomplete = null;

    this.origin = origin;
    this.map = map;
    this.placesService = new google.maps.places.PlacesService(map);
    this.infowindow = new google.maps.InfoWindow();
    this.infowindowContent = document.getElementById('infowindow-content');
    this.infowindow.setContent(this.infowindowContent);
    this.opts = opts;
    this.marker = new google.maps.Marker({ map: this.map });

    var input = document.getElementById('pac-input');
    this.autocomplete = new google.maps.places.Autocomplete(input);
    this.autocomplete.bindTo('bounds', map);

    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
    // Specify just the place data fields that you need.
    this.autocomplete.setFields(fields);

    if (this.opts.place_id) {
      this.setPlace(this.opts.place_id, true);
    }

    var me = this;
    this.autocomplete.addListener('place_changed', function () {
      me.infowindow.close();
      var place = me.autocomplete.getPlace();
      me.setPlace(place.place_id, false);
    });

    // Listen for clicks on the map.
    this.map.addListener('click', this.handleClick.bind(this));
  }

  createClass_default()(PlaceEventHandler, [{
    key: 'setPlace',
    value: function setPlace(placeId) {
      var currentlyUsing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


      this.marker.addListener('click', function () {
        this.infowindow.open(this.map, marker);
      });

      var me = this;
      loadPlaceFromId(placeId);

      function loadPlaceFromId(id) {
        var request = {
          placeId: id,
          fields: fields
        };

        var service = me.placesService;
        service.getDetails(request, function (place, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            loadPlace(place);
          }
        });
      }

      function loadPlace(place) {
        if (!place.geometry) {
          return;
        }

        if (place.geometry.viewport) {
          me.map.fitBounds(place.geometry.viewport);
        } else {
          me.map.setCenter(place.geometry.location);
          me.map.setZoom(17);
        }

        // Set the position of the marker using the place ID and location.
        me.marker.setPlace({
          placeId: place.place_id,
          location: place.geometry.location
        });

        me.marker.setVisible(true);

        me.infowindowContent.children['place-name'].textContent = place.name;
        if (currentlyUsing) {
          me.infowindowContent.children['place-choose'].textContent = "Currently Using";
        } else {
          me.infowindowContent.children['place-choose'].textContent = "Use Place";
        }
        me.infowindowContent.children['place-choose'].onclick = function () {
          if (me.opts.callback) {
            me.opts.callback(place.place_id);
          }
        };
        me.infowindowContent.children['place-address'].textContent = place.formatted_address;
        me.infowindow.open(me.map, me.marker);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      console.log('You clicked on: ' + event.latLng);
      // If the event has a placeId, use it.
      if (event.placeId) {
        console.log('You clicked on place:' + event.placeId);

        // Calling e.stop() on the event prevents the default info window from
        // showing.
        // If you call stop here when there is no placeId you will prevent some
        // other map click event handlers from receiving the event.
        event.stop();
        this.setPlace(event.placeId, false);
      }
    }
  }]);

  return PlaceEventHandler;
}();
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/PlaceInput.vue
//
//
//
//
//
//
//




/* harmony default export */ var PlaceInput = ({
  name: 'PlaceInput',
  components: {},
  props: ['settings', 'defaultValue'],
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    },
    launchPlaceFinder: function launchPlaceFinder() {
      this.loadChooser();
      this.place_finder_shown = true;
      return false;
    },
    loadChooser: function loadChooser() {
      var chooser = document.createElement('div');
      chooser.id = "place-id-finder";

      chooser.innerHTML = '<div style="display: none">' + '<input id="pac-input" class="controls" type="text" placeholder="Enter a location">' + '<a id="place-close" class="btn btn-danger">Close</a><br>' + '</div>' + '<div id="map"></div>' + '<div id="infowindow-content">' + '<span id="place-name" class="title"></span><br>' + '<span id="place-address"></span><br>' + '<a id="place-choose" class="btn btn-primary">Use This</a><br>' + '</div>';

      document.body.appendChild(chooser);
      var data = this;
      fetch('https://red.broadstreetads.com/me').then(function (response) {
        response.json().then(function (d) {
          data.initMap({
            location: d.location,
            callback: function callback(placeID) {
              if (placeID) {
                data.value = placeID;
              }
              document.body.removeChild(chooser);
              data.closePlaceFinder();
            },
            place_id: data.value
          });
        });
      });
    },
    initMap: function initMap(opts) {
      var origin = { lat: opts.location.latitude, lng: opts.location.longitude };
      var map = new google.maps.Map(document.getElementById('map'), {
        center: origin,
        zoom: 13
      });

      // We use this class so we can handle the click and the autocomplete without repeating code
      var placeHandler = new PlaceEventHandler_PlaceEventHandler(map, origin, opts);

      var close = document.getElementById('place-close');
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(close);

      close.addEventListener('click', function () {
        opts.callback();
      });
    },
    closePlaceFinder: function closePlaceFinder() {
      this.place_finder_shown = false;
    }
  },
  data: function data() {
    return {
      value: this.defaultValue || null,
      place_finder_shown: false
    };
  },

  watch: {
    value: function value(newVal) {
      this.update(newVal);
    }
  },
  created: function created() {
    injectMapScript();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e76442c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/PlaceInput.vue
var PlaceInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"input__field",staticStyle:{"display":"none"},attrs:{"type":"text","value":""},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),(!_vm.place_finder_shown)?_c('a',{staticClass:"window__button button button--primary",on:{"click":function($event){_vm.launchPlaceFinder()}}},[_vm._v("Launch Place Finder")]):_vm._e()])}
var PlaceInput_staticRenderFns = []
var PlaceInput_esExports = { render: PlaceInput_render, staticRenderFns: PlaceInput_staticRenderFns }
/* harmony default export */ var configurator_PlaceInput = (PlaceInput_esExports);
// CONCATENATED MODULE: ./src/components/configurator/PlaceInput.vue
var PlaceInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PlaceInput___vue_template_functional__ = false
/* styles */
var PlaceInput___vue_styles__ = null
/* scopeId */
var PlaceInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PlaceInput___vue_module_identifier__ = null
var PlaceInput_Component = PlaceInput_normalizeComponent(
  PlaceInput,
  configurator_PlaceInput,
  PlaceInput___vue_template_functional__,
  PlaceInput___vue_styles__,
  PlaceInput___vue_scopeId__,
  PlaceInput___vue_module_identifier__
)

/* harmony default export */ var components_configurator_PlaceInput = (PlaceInput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/Item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ var Item = ({
  name: 'Item',
  components: {
    Date: src_components_configurator_Date,
    TimeSpanInput: components_configurator_TimeSpanInput,
    LongTextInput: components_configurator_LongTextInput,
    RichTextInput: components_configurator_RichTextInput,
    FileUploadInput: components_configurator_FileUploadInput,
    ImageUploadInput: components_configurator_ImageUploadInput,
    String: src_components_configurator_String,
    Number: src_components_configurator_Number,
    Boolean: components_configurator_Boolean,
    Timepicker: components_configurator_Timepicker,
    DateTimeInput: components_configurator_DateTimeInput,
    ColorPickerInput: components_configurator_ColorPickerInput,
    SelectInput: components_configurator_SelectInput,
    SizeInput: components_configurator_SizeInput,
    LinkInput: components_configurator_LinkInput,
    SchedulerInput: components_configurator_Scheduler,
    EmailInput: components_configurator_EmailInput,
    PlaceInput: components_configurator_PlaceInput
  },
  props: ['item', 'defaultValue', 'id'],
  methods: {
    getFormName: function getFormName(type, index) {
      var rand = parseInt(Math.random() * 100000000, 0);
      return type + '-' + index + '-' + rand;
    }
  },
  data: function data() {
    var obj = {
      value: this.defaultValue || null
    };

    return obj;
  },
  mounted: function mounted() {
    if (this.item.subtype) {
      this.item.type = this.item.subtype.replace('broadstreetads/', '');
    }
  },

  watch: {
    value: function value(newVal) {
      this.$emit('input', newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe63295a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/Item.vue
var Item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.type == 'string' && (_vm.item.name != 'url' && _vm.item.name != 'link'))?_c('string',{attrs:{"settings":_vm.item,"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'string' && (_vm.item.name == 'url' || _vm.item.name == 'link'))?_c('link-input',{attrs:{"settings":_vm.item,"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'email')?_c('email-input',{attrs:{"defaultValue":_vm.value,"options":_vm.item.options,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'schedule')?_c('scheduler-input',{attrs:{"defaultValue":_vm.value,"options":_vm.item.options,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'number')?_c('number',{attrs:{"settings":_vm.item,"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'boolean')?_c('boolean',{attrs:{"settings":_vm.item,"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'date')?_c('date',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'time')?_c('timepicker',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'datetime')?_c('date-time-input',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'timespan')?_c('time-span-input',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'longtext')?_c('long-text-input',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'richtext')?_c('rich-text-input',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'file')?_c('file-upload-input',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'image')?_c('image-upload-input',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'color')?_c('color-picker-input',{attrs:{"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'select')?_c('select-input',{attrs:{"defaultValue":_vm.value,"options":_vm.item.options,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'size')?_c('size-input',{attrs:{"defaultValue":_vm.value,"options":_vm.item.options,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),(_vm.item.type == 'place')?_c('place-input',{attrs:{"settings":_vm.item,"defaultValue":_vm.value,"id":_vm.id},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.item.inputs),function(object,index){return (_vm.item.type == 'object')?_c('div',{staticClass:"object_input",staticStyle:{"display":"block","margin-bottom":"30px"}},[_c('label',[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(object.label))]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v(_vm._s(object.description))])]),_vm._v(" "),_c('item',{attrs:{"id":_vm.getFormName([_vm.item.name, _vm.item.type, object.type].join('-'), index),"defaultValue":_vm.value[object.name],"item":object},model:{value:(_vm.value[object.name]),callback:function ($$v) {_vm.$set(_vm.value, object.name, $$v)},expression:"value[object.name]"}})],1):_vm._e()})],2)}
var Item_staticRenderFns = []
var Item_esExports = { render: Item_render, staticRenderFns: Item_staticRenderFns }
/* harmony default export */ var configurator_Item = (Item_esExports);
// CONCATENATED MODULE: ./src/components/configurator/Item.vue
var Item_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Item___vue_template_functional__ = false
/* styles */
var Item___vue_styles__ = null
/* scopeId */
var Item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Item___vue_module_identifier__ = null
var Item_Component = Item_normalizeComponent(
  Item,
  configurator_Item,
  Item___vue_template_functional__,
  Item___vue_styles__,
  Item___vue_scopeId__,
  Item___vue_module_identifier__
)

/* harmony default export */ var components_configurator_Item = (Item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/configurator/ArrayItem.vue

//
//
//
//
//
//
//
//
//
//
//
//







index_es["default"].config = {
  autoAddCss: false
};

index_es["default"].library.add(fontawesome_free_solid_index_es["b" /* faPlus */]);
index_es["default"].library.add(fontawesome_free_solid_index_es["a" /* faMinus */]);

/* harmony default export */ var ArrayItem = ({
  name: 'Configuration',
  components: {
    Item: components_configurator_Item,
    FontAwesomeIcon: vue_fontawesome_default.a
  },
  props: ['item', 'defaultValue', 'id'],
  methods: {
    getFormName: function getFormName(type, index) {
      return type + '-' + index;
    },
    addField: function addField(item, e) {
      e.preventDefault();
      var placeholderValue = null;
      if (item.type == 'object') {
        placeholderValue = {};
        placeholderValue = JSON.parse(stringify_default()(this.item.default));
      }
      this.value.push(placeholderValue);
    },
    removeField: function removeField(index) {
      this.value = this.value.slice(0, index).concat(this.value.slice(index + 1));
    }
  },
  mounted: function mounted() {
    // respect the minlength of the array
    if (this.value.length < this.item.minLength) {
      for (var i = this.value.length; i < this.item.minLength; i++) {
        var placeholderValue = null;
        if (this.item.type == 'object') {
          placeholderValue = {};
          placeholderValue = JSON.parse(stringify_default()(this.item.default));
        }
        this.value.push(placeholderValue);
      }
    }
  },
  data: function data() {
    var value = this.defaultValue;

    if (!Array.isArray(value) && value) {
      value = [value];
    } else if (Array.isArray(value)) {} else {
      value = [];
    }

    var obj = {
      value: value
    };

    return obj;
  },

  watch: {
    value: function value(newVal) {
      this.$emit('input', newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080f9e57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/configurator/ArrayItem.vue
var ArrayItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-right":"1.5em","position":"relative"}},[_vm._l((_vm.value),function(val,index){return _c('div',{staticStyle:{"position":"relative","padding-left":"1.5em","overflow":"auto","margin-bottom":"1em"}},[_c('item',{attrs:{"item":_vm.item,"defaultValue":val,"id":_vm.id + index},model:{value:(_vm.value[index]),callback:function ($$v) {_vm.$set(_vm.value, index, $$v)},expression:"value[index]"}}),_vm._v(" "),(_vm.value.length > 1 && _vm.value.length > _vm.item.minLength)?_c('font-awesome-icon',{staticStyle:{"position":"absolute","left":"0","top":"12px","cursor":"pointer"},attrs:{"icon":"minus"},on:{"click":function($event){_vm.removeField(index)}}}):_vm._e()],1)}),_vm._v(" "),(_vm.value.length < _vm.item.maxLength)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.addField(_vm.item, $event)}}},[_c('font-awesome-icon',{staticStyle:{"position":"absolute","right":"0","bottom":"28px"},attrs:{"icon":"plus"}})],1):_vm._e()],2)}
var ArrayItem_staticRenderFns = []
var ArrayItem_esExports = { render: ArrayItem_render, staticRenderFns: ArrayItem_staticRenderFns }
/* harmony default export */ var configurator_ArrayItem = (ArrayItem_esExports);
// CONCATENATED MODULE: ./src/components/configurator/ArrayItem.vue
var ArrayItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArrayItem___vue_template_functional__ = false
/* styles */
var ArrayItem___vue_styles__ = null
/* scopeId */
var ArrayItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ArrayItem___vue_module_identifier__ = null
var ArrayItem_Component = ArrayItem_normalizeComponent(
  ArrayItem,
  configurator_ArrayItem,
  ArrayItem___vue_template_functional__,
  ArrayItem___vue_styles__,
  ArrayItem___vue_scopeId__,
  ArrayItem___vue_module_identifier__
)

/* harmony default export */ var components_configurator_ArrayItem = (ArrayItem_Component.exports);

// EXTERNAL MODULE: ./src/components/common/SeriesBadge.vue + 2 modules
var SeriesBadge = __webpack_require__("GFam");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/lib/integration.js
var integration = __webpack_require__("rqOl");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Configuration.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var configLocalStorageKey = 'parkave_config';

/* harmony default export */ var Configuration = ({
  name: 'Configuration',
  components: {
    Item: components_configurator_Item,
    ArrayItem: components_configurator_ArrayItem,
    SizeInput: components_configurator_SizeInput,
    SeriesBadge: SeriesBadge["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (src_store.state.me.id) return next();
    src_store.dispatch('loadMe').then(function (me) {
      if (me.admin || me.format_admin) {
        return src_store.dispatch('formats/loadAll').then(next);
      } else {
        return next();
      }
    });
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var formatsInterval;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:

              _this.getConfigFromLocalStorage = function () {
                return JSON.parse(localStorage.getItem(configLocalStorageKey));
              };

              _this.getUpdateConfigFromLocalStorage = function () {
                return JSON.parse(localStorage.getItem(configLocalStorageKey + '_updateable'));
              };

              _this.shouldUseLocalStorage = function () {
                return _this.$route.params.format_id && !_this.$route.params.id;
              };

              _this.writeUpdateConfigToLocalStorage = function (config) {
                localStorage.setItem(configLocalStorageKey + '_updateable', stringify_default()(config));
              };

              _this.writeConfigToLocalStorage = function (config) {
                localStorage.setItem(configLocalStorageKey, stringify_default()(config));
              };

              formatsInterval = setInterval(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var _this2 = this;

                var key, value, values, update_config, thisUpdateConfig, format_id, config, thisConfig, _format_id;

                return regenerator_default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!this.$store.getters['formats/unfiltered'].length) {
                          _context.next = 23;
                          break;
                        }

                        clearInterval(formatsInterval);

                        this.format = this.$store.getters['formats/unfiltered'].filter(function (format) {
                          return parseInt(_this2.$route.params.format_id) === format.id;
                        })[0];

                        if (!this.format && this.$store.getters.isFormatAdmin) {
                          this.format = this.$store.getters['formats/allFormats'].filter(function (format) {
                            return parseInt(_this2.$route.params.format_id) === format.id;
                          })[0];
                        }

                        if (this.format) {
                          FS.event('Viewing Format Builder', {
                            format_id: this.format.id,
                            format_name_str: this.format.name
                          });
                        }

                        if (!this.$route.params.id) {
                          _context.next = 10;
                          break;
                        }

                        if (!(!this.ads.length && this.$route.query.share_code)) {
                          _context.next = 9;
                          break;
                        }

                        _context.next = 9;
                        return this.$store.dispatch('advertisements/load');

                      case 9:
                        this.ad = this.ads.filter(function (ad) {
                          return parseInt(_this2.$route.params.id) == ad.id;
                        })[0];

                      case 10:

                        if (!localStorage.getItem(configLocalStorageKey + '_updateable')) this.writeUpdateConfigToLocalStorage({});

                        if (!(this.ad && this.ad.update_rule_id || this.getUpdateConfigFromLocalStorage()[this.format.id] && this.getUpdateConfigFromLocalStorage()[this.format.id].isUpdateable)) {
                          _context.next = 14;
                          break;
                        }

                        _context.next = 14;
                        return this.makeUpdateable();

                      case 14:

                        try {
                          this.fields = JSON.parse(this.format.specification).inputs;
                          for (key in this.fields) {
                            value = this.fields[key];
                            values = this.ad ? this.ad.json : {};


                            if (value.type == 'object') {
                              this.$set(this.settings, value.name, {});
                            }

                            if (values && value.name in values) {
                              this.$set(this.settings, value.name, values[value.name]);
                            } else if (value.default) {
                              this.$set(this.settings, value.name, value.default);
                            }

                            this.$set(this.settings, 'name', this.ad.name ? this.ad.name : 'Untitled ' + this.format.name);

                            if (this.isUpdateable) {
                              this.settings['link'] = location.origin + '/updates/' + this.$route.params.format_id + '/' + this.$route.params.id;
                            }
                          }
                        } catch (e) {
                          console.log('error parsing fields', e);
                        }

                        this.loadedConfigDefaults = true;

                        if (!localStorage.getItem(configLocalStorageKey)) this.writeConfigToLocalStorage({});

                        update_config = this.getUpdateConfigFromLocalStorage();
                        thisUpdateConfig = null;


                        if (this.isUpdateable) {
                          format_id = this.$route.params.format_id;


                          if (format_id in update_config) {
                            thisUpdateConfig = update_config[format_id];
                          }

                          if (thisUpdateConfig) {
                            this.$store.commit('setUpdateRuleSettings', thisUpdateConfig);
                          }
                        }

                        config = this.getConfigFromLocalStorage();
                        thisConfig = null;


                        if (this.shouldUseLocalStorage()) {
                          _format_id = this.$route.params.format_id;


                          if (_format_id in config) {
                            thisConfig = config[_format_id];
                          }

                          if (thisConfig) this.$set(this, 'settings', thisConfig);
                        }

                      case 23:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              })).bind(_this), 100);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  methods: {
    removeUpdateable: function removeUpdateable(e) {
      if (e) e.preventDefault();
      this.isUpdateable = false;
      this.updateLocalStorage();
    },
    makeUpdateable: function makeUpdateable(e) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var me, data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (e) e.preventDefault();

                me = _this3.$store.state.me;

                // if the user isn't logged in, prompt them to log in

                if (me.id) {
                  _context3.next = 5;
                  break;
                }

                _this3.$modal.show('intersection');
                return _context3.abrupt('return');

              case 5:

                _this3.isUpdateable = true;
                data = _this3;
                _context3.next = 9;
                return _this3.$store.dispatch('loadUpdateRuleFields').then(function (fields) {
                  if (!data.ad.update_rule_id) {
                    fields.forEach(function (field) {
                      data.updateable_settings[field.name] = field.default;
                    });
                  }
                });

              case 9:
                if (!_this3.ad.update_rule_id) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 12;
                return _this3.$store.dispatch('getUpdateRule', _this3.ad.update_rule_id);

              case 12:
                _context3.next = 16;
                break;

              case 14:
                _context3.next = 16;
                return _this3.$store.commit('setUpdateRuleSettings', _this3.updateable_settings);

              case 16:
                if (e) {
                  _this3.updateLocalStorage();
                }

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    openPricingModal: function openPricingModal() {
      this.$modal.show('pricing');
    },
    openReferralModal: function openReferralModal() {
      this.$modal.show('userinput', {
        modalTitle: 'Refer a Friend to ParkAve',
        messageText: 'Enter the email of the person you want to refer to ParkAve (You will recieve an email about your watermark removal once your referral creates their first ad): ',
        fieldType: 'email',
        fieldPlaceholder: 'example@parkave.com',
        buttonText: 'Refer',
        callback: function callback(value) {
          this.$modal.hide('userinput');
          src_store.dispatch('createReferral', { email: value });
        }
      });
    },
    configurableFields: function configurableFields() {
      return this.fields.filter(function (o) {
        return o.type !== 'size';
      });
    },
    updateLocalStorage: function updateLocalStorage() {
      var options = this.updateable_settings;
      options.isUpdateable = this.isUpdateable;
      var format_id = this.$route.params.format_id;

      var config = this.getUpdateConfigFromLocalStorage();
      config[format_id] = options;
      this.writeUpdateConfigToLocalStorage(config);
    },
    sizeItem: function sizeItem() {
      for (var key in this.fields) {
        if (this.fields[key].type == 'size') {
          return this.fields[key];
        }
      }
      return null;
    },
    save: function save(e, insert) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var me, temp, load, payload, key, finish;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e.preventDefault();
                me = _this4.$store.state.me;
                // if the user isn't logged in, prompt them to log in

                if (!(!me.id && !_this4.$route.query.share_code)) {
                  _context4.next = 5;
                  break;
                }

                _this4.$modal.show('intersection');
                return _context4.abrupt('return');

              case 5:

                responseNotification({}, { info: 'Creating ad...' }, {}, { timeout: 4000 });

                temp = _this4;

                if (!_this4.isUpdateable) {
                  _context4.next = 20;
                  break;
                }

                load = _this4.updateable_settings;

                load.timezone = window.timezone;

                if (!_this4.ad.update_rule_id) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 13;
                return _this4.$store.dispatch('updateUpdateRule', { id: _this4.ad.update_rule_id, payload: load });

              case 13:
                temp.temp_id = _this4.ad.update_rule_id;
                _context4.next = 18;
                break;

              case 16:
                _context4.next = 18;
                return _this4.$store.dispatch('createUpdateRule', load).then(function (response) {
                  temp.temp_id = response.update_rule_id;
                });

              case 18:
                _context4.next = 21;
                break;

              case 20:
                _this4.temp_id = null;

              case 21:
                if (!(_this4.format.premium && !_this4.planChosen.allow_premium_formats && localStorage.account_id)) {
                  _context4.next = 25;
                  break;
                }

                _this4.$modal.show('pricing');
                _this4.$snotify.info('This is a premium ad format! Upgrade your account to \'Pro\' or higher to gain access to it!', { timeout: 5000 });
                return _context4.abrupt('return');

              case 25:
                payload = {
                  format_id: parseInt(_this4.$route.params.format_id),
                  name: _this4.settings.name,
                  json: {},
                  share_code: _this4.getShareCode(),
                  update_rule_id: _this4.temp_id
                };

                if (!(!_this4.settings.name || _this4.settings.name.length < 3)) {
                  _context4.next = 28;
                  break;
                }

                return _context4.abrupt('return');

              case 28:

                if (_this4.isUpdateable && _this4.ad.id) {
                  _this4.$set(_this4.settings, 'link', location.origin + '/updates/' + _this4.$route.params.format_id + '/' + _this4.$route.params.id);
                }

                for (key in _this4.settings) {
                  if (key != 'name') {
                    payload.json[key] = _this4.settings[key];
                  }
                }

                finish = function finish() {
                  if (_this4.ad.id) {
                    src_store.dispatch('advertisements/update', { id: _this4.ad.id, ad: payload, callback: function callback(response) {
                        FS.event('Update Advertisement', {
                          advertisement_id: response.id,
                          advertisement_name_str: response.name,
                          format_name_str: _this4.format.name,
                          format_id: response.format_id,
                          placement_id: response.placement_id
                        });
                        if (insert) {
                          Object(integration["c" /* passback */])(response);
                        }
                        _this4.$router.push('/ads');
                      } }, _this4.$snotify);
                  } else {
                    var data = _this4;
                    src_store.dispatch('advertisements/create', { data: payload, callback: function callback(response) {
                        FS.event('Create Advertisement', {
                          advertisement_id: response.id,
                          advertisement_name_str: response.name,
                          format_name_str: _this4.format.name,
                          format_id: response.format_id,
                          placement_id: response.placement_id
                        });
                        if (data.isUpdateable) {
                          var _load = {
                            format_id: parseInt(_this4.$route.params.format_id),
                            name: response.name,
                            json: payload.json
                          };
                          _load.json['link'] = location.origin + '/updates/' + _this4.$route.params.format_id + '/' + response.id;
                          src_store.dispatch('advertisements/update', { id: response.id, ad: _load });
                        }
                        if (insert) {
                          Object(integration["c" /* passback */])(response);
                        }
                        if (localStorage.parkave_referral_code) {
                          if (!_this4.account.referred_by_id) {
                            src_store.dispatch('confirmReferral', { token: localStorage.parkave_referral_code });
                          }
                          delete localStorage.parkave_referral_code;
                        }
                        _this4.$router.push('/ads');
                      } });
                  }

                  var update_config = _this4.getUpdateConfigFromLocalStorage();
                  var format_id = _this4.$route.params.format_id;


                  if (_this4.shouldUseLocalStorage()) {
                    if (format_id in update_config) {
                      var newConfig = lodash_default.a.omit(update_config, [format_id]);

                      _this4.writeUpdateConfigToLocalStorage(newConfig);
                    }
                  }

                  var config = _this4.getConfigFromLocalStorage();

                  if (_this4.shouldUseLocalStorage()) {
                    if (format_id in config) {
                      var _newConfig = lodash_default.a.omit(config, [format_id]);

                      _this4.writeConfigToLocalStorage(_newConfig);
                    }
                  }
                };

                if (!me.id && !payload.share_code) {
                  window.scrollTo(0, 0);
                  window.afterCompleteSignUpModal = function () {
                    finish();
                    _this4.$modal.hide('intersection');
                    src_store.dispatch('accounts/update', { plan: 'free', skipSuccessMessage: true });
                  };

                  _this4.$modal.show('intersection');
                  //this.$modal.show('sign-up');
                } else {
                  finish();
                }

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getFormName: function getFormName(type, index) {
      return type + '-' + index;
    },
    onChangeTime: function onChangeTime(binding, newVal) {
      var _newVal$data = newVal.data,
          HH = _newVal$data.HH,
          mm = _newVal$data.mm,
          ss = _newVal$data.ss;

      this.settings[binding] = { HH: HH, mm: mm, ss: ss };
    },
    onPreviewData: function onPreviewData(preview) {
      if (preview.scale) {
        this.$set(this.preview, 'scale', preview.scale);
      }
    }
  },
  watch: {
    sidebarActive: {
      handler: function handler() {
        this.$refs.preview.generatePreview();
      }
    },
    settings: {
      deep: true,
      handler: function handler(newVal) {
        var config = this.getConfigFromLocalStorage();

        if (this.shouldUseLocalStorage() && this.loadedConfigDefaults) {
          var format_id = this.$route.params.format_id;

          config[format_id] = newVal;
          this.writeConfigToLocalStorage(config);
        }
      }
    }
  },
  data: function data() {
    return {
      sidebarActive: true,
      format: {},
      fields: [],
      settings: {},
      ad: {},
      meta: {},
      preview: {
        srcdoc: '',
        length: 0,
        scale: 100
      },
      temp_id: null,
      isUpdateable: false
    };
  },
  mounted: function mounted() {
    var _this5 = this;

    setTimeout(function () {
      if (_this5.$store.state.me.errors !== 'unauthorized') {
        var configTour = _this5.$store.state.preferences['ad_creation_tour'];
        if (!configTour || configTour !== 'finished') {
          //this.$tours['config_tour'].start();
        }
      }

      // If user is logged in, but is not a admin or format_admin and there is no format
      if ((!_this5.$store.state.me.admin || !_this5.$store.state.me.format_admin) && !_this5.format) {
        _this5.$router.push('/');
      }
    }, 500);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$tours['config_tour'].isRunning) {
      this.$tours['config_tour'].stop();
    }
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['planChosen', 'account']), Object(vuex_esm["b" /* mapState */])('advertisements', ['ads']), Object(vuex_esm["b" /* mapState */])(['updateable_fields', 'updateable_settings']), {
    hideWatermark: function hideWatermark() {
      if (this.format.updateable) {
        return this.account.hide_selfserve_watermark || this.planChosen.short_name != 'free';
      } else {
        return this.planChosen.short_name != 'free';
      }
    },
    approvalEmail: function approvalEmail() {
      return this.updateable_settings.approval_email;
    },
    getSelfServeLink: function getSelfServeLink() {
      var link = location.origin + '/updates/' + this.$route.params.format_id + '/' + this.$route.params.id;
      return link;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f752ca94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Configuration.vue
var Configuration_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"breadcrumb-dark"},[_c('ul',{staticClass:"breadcrumb-dark__list"},[_c('li',{staticClass:"breadcrumb-dark__level"},[_c('router-link',{staticClass:"breadcrumb-dark__link",attrs:{"to":"/","active-class":"breadcrumb-dark__link--active"}},[_vm._v("Choose a format")])],1),_vm._v(" "),_vm._m(0,false,false)]),_vm._v(" "),(_vm.format.id)?_c('SeriesBadge',{staticClass:"series-center",attrs:{"series":_vm.format.series,"box":false}}):_vm._e(),_vm._v(" "),(_vm.sidebarActive)?_c('div',{staticClass:"breadcrumb-dark__select-preview select-preview",attrs:{"data-v-config-step":"4"}},[_c('label',{staticClass:"select-preview__label"},[_vm._v("Display size")]),_vm._v(" "),(_vm.sizeItem())?_c('size-input',{attrs:{"selectClass":"select-preview__select","defaultValue":_vm.settings['size'],"options":_vm.sizeItem().options},model:{value:(_vm.settings['size']),callback:function ($$v) {_vm.$set(_vm.settings, 'size', $$v)},expression:"settings['size']"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"main-content main-content--white-background",class:{'main-content--full-width': _vm.sidebarActive}},[(!_vm.sidebarActive)?_c('section',{staticClass:"main-content__full section section--configuration"},[_c('header',{staticClass:"section__header"},[_c('h1',{staticClass:"section__title"},[_vm._v("New creative")]),_vm._v(" "),_c('div',{staticClass:"section__header__area"},[_c('a',{staticClass:"section__header__button button button--secondary button--ghost",class:{ 'button--disabled': !_vm.settings.name || (_vm.settings.name && _vm.settings.name.length < 3) },attrs:{"href":"#"},on:{"click":_vm.save}},[_vm._v("Save")]),_vm._v(" "),(!_vm.getShareCode() && !_vm.isAppStandalone())?_c('a',{staticClass:"section__header__button button button--primary",class:{ 'button--disabled': !_vm.settings.name || (_vm.settings.name && _vm.settings.name.length < 3) },attrs:{"href":"#"},on:{"click":_vm.save}},[_vm._v("Save and Insert")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"main-content__full section",class:{'section--sidebar': _vm.sidebarActive}},[_c('form',{staticClass:"section__content section__content--form form",attrs:{"data-v-config-step":"1","data-v-long-step":"8"}},[_c('fieldset',{staticClass:"form__group",attrs:{"data-v-config-step":"2"}},[_c('article',{staticClass:"form__item"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.format.name),expression:"format.name"}],staticClass:"input__field",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":(_vm.format.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.format, "name", $event.target.value)}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item"},[_vm._m(2,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings.name),expression:"settings.name"}],staticClass:"input__field",class:{ 'input--success': _vm.settings.name, 'input--error': !_vm.settings.name },attrs:{"type":"text"},domProps:{"value":(_vm.settings.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings, "name", $event.target.value)}}})])]),_vm._v(" "),(_vm.format.updateable)?_c('article',{staticClass:"form__item"},[_vm._m(3,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[(!_vm.isUpdateable)?_c('button',{staticClass:"button button--primary",on:{"click":_vm.makeUpdateable}},[_vm._v("Enable Self-Serve")]):_vm._e(),_vm._v(" "),(_vm.isUpdateable)?_c('button',{staticClass:"button button--remove update__button--remove",on:{"click":function($event){_vm.removeUpdateable()}}},[_vm._v("Disable Self-Serve")]):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._l((_vm.configurableFields()),function(field,index){return ((_vm.isUpdateable && field.name != 'link') || !_vm.isUpdateable)?_c('article',{staticClass:"form__item"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v(_vm._s(field.description))])]),_vm._v(" "),(!field.array)?_c('item',{attrs:{"id":_vm.getFormName(field.type, index),"defaultValue":_vm.settings[field.name],"item":field},model:{value:(_vm.settings[field.name]),callback:function ($$v) {_vm.$set(_vm.settings, field.name, $$v)},expression:"settings[field.name]"}}):_vm._e(),_vm._v(" "),(field.array)?_c('array-item',{attrs:{"id":_vm.getFormName(field.type, index),"defaultValue":_vm.settings[field.name],"item":field},model:{value:(_vm.settings[field.name]),callback:function ($$v) {_vm.$set(_vm.settings, field.name, $$v)},expression:"settings[field.name]"}}):_vm._e()],1):_vm._e()}),_vm._v(" "),(_vm.isUpdateable)?_c('article',{staticClass:"form__item"},[_vm._m(4,false,false),_vm._v(" "),(_vm.isUpdateable)?_c('div',[_vm._l((_vm.updateable_fields),function(field,index){return _c('div',[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v(_vm._s(field.description))])]),_vm._v(" "),_c('item',{attrs:{"id":_vm.getFormName(field.type,index),"defaultValue":_vm.updateable_settings[field.name],"item":field},on:{"input":_vm.updateLocalStorage},model:{value:(_vm.updateable_settings[field.name]),callback:function ($$v) {_vm.$set(_vm.updateable_settings, field.name, $$v)},expression:"updateable_settings[field.name]"}})],1)}),_vm._v(" "),_c('article',{staticClass:"form__item"},[_vm._m(5,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[(_vm.ad.id)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getSelfServeLink),expression:"getSelfServeLink"}],staticClass:"input__field",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":(_vm.getSelfServeLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.getSelfServeLink=$event.target.value}}}):_vm._e(),_vm._v(" "),(!_vm.ad.id)?_c('input',{staticClass:"input__field",attrs:{"type":"text","disabled":"disabled","value":"This link will be displayed here after you create the ad."}}):_vm._e()])])],2):_vm._e()]):_vm._e()],2)]),_vm._v(" "),_c('section',{staticClass:"section__content section__content--preview"},[_c('article',{staticClass:"section__content__preview preview"},[(!_vm.sidebarActive)?_c('header',{staticClass:"preview__header"},[_c('h1',{staticClass:"preview__title"},[_vm._v("Preview")])]):_vm._e(),_vm._v(" "),_c('preview-settings',{ref:"preview",attrs:{"data-v-config-step":"3","ad":_vm.ad,"inputs":_vm.settings},on:{"preview-data":_vm.onPreviewData}}),_vm._v(" "),(!_vm.hideWatermark)?_c('div',{staticClass:"main-content__watermark"},[_c('p',[_vm._v("Remove the watermark "),(_vm.isUpdateable)?_c('span',[_vm._v("for self serve")]):_vm._e(),_vm._v(".")]),_vm._v(" "),(!_vm.isUpdateable)?_c('div',{staticClass:"button button--primary",on:{"click":function($event){$event.preventDefault();_vm.openPricingModal($event)}}},[_vm._v("Upgrade your account.")]):_vm._e(),_vm._v(" "),(_vm.isUpdateable)?_c('div',{staticClass:"button button--primary",on:{"click":function($event){$event.preventDefault();_vm.openReferralModal($event)}}},[_vm._v("Refer someone to ParkAve.")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.sidebarActive)?_c('footer',{staticClass:"preview__footer"},[_c('ul',{staticClass:"preview__details details"},[_c('li',{staticClass:"details__item"},[_vm._v("\n                Preview Size: "),_c('strong',{staticClass:"details__item__value"},[_vm._v(_vm._s(_vm.preview.length)+" Bytes")])]),_vm._v(" "),_c('li',{staticClass:"details__item details__item--preview detail__item__select-preview"},[_c('div',{staticClass:"select-preview select-preview--light select-preview--small"},[_c('label',{staticClass:"select-preview__label"},[_vm._v("Preview size")]),_vm._v(" "),(_vm.sizeItem())?_c('size-input',{attrs:{"selectClass":"select-preview__select","defaultValue":_vm.settings['size'],"options":_vm.sizeItem().options},model:{value:(_vm.settings['size']),callback:function ($$v) {_vm.$set(_vm.settings, 'size', $$v)},expression:"settings['size']"}}):_vm._e()],1)])])]):_vm._e()],1),_vm._v(" "),(!_vm.sidebarActive)?_c('hr',{staticClass:"seperator"}):_vm._e(),_vm._v(" "),_c('footer',{staticClass:"section__footer"},[(_vm.sidebarActive)?_c('ul',{staticClass:"details"},[_c('li',{staticClass:"details__item"},[(_vm.preview.scale < 100)?_c('span',[_c('strong',{staticClass:"details__item__value"},[_vm._v("Note:")]),_vm._v(" Scaled down for preview")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.sidebarActive)?_c('a',{staticClass:"section__footer__button button button--secondary",attrs:{"href":"#"}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(!_vm.getShareCode() && !_vm.isAppStandalone())?_c('a',{staticClass:"section__footer__button section__footer__button--right button button--primary",class:{ 'button--disabled': !_vm.settings.name || (_vm.settings.name && _vm.settings.name.length < 3) },attrs:{"href":"#"},on:{"click":function($event){_vm.save($event, true)}}},[_vm._v("Save and Insert")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"section__footer__button section__footer__button--right button button--primary",class:{ 'button--disabled': !_vm.settings.name || (_vm.settings.name && _vm.settings.name.length < 3) },attrs:{"href":"#"},on:{"click":function($event){_vm.save($event, false)}}},[_vm._v("Save")])])])])])])}
var Configuration_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb-dark__level"},[_c('span',{staticClass:"breadcrumb-dark__link",attrs:{"data-v-config-step":"0","data-v-long-step":"7"}},[_vm._v("Configuration")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Advertisement format")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is the format chosen for this adverisement. This cannot be changed.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Advertisement name (Required)")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is a unique name for the advertisement so you can identify it. Minimum 3 characters long.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Self-Serve")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("You can make this ad \"self-serve\" in that readers can update its contents for a period of time (with your approval, of course). If this is enabled, additional options will be made available.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Self-Serve Advertisements")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("These are the fields for a self-serve advertisement.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Create Update Link")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("\n                    Share this link with your advertisers so they can create self-serve updates after saving this ad.\n                    This link will also be auto-filled as the click destination link of this advertisement.\n                  ")])])}]
var Configuration_esExports = { render: Configuration_render, staticRenderFns: Configuration_staticRenderFns }
/* harmony default export */ var components_Configuration = (Configuration_esExports);
// CONCATENATED MODULE: ./src/components/Configuration.vue
function Configuration_injectStyle (ssrContext) {
  __webpack_require__("XCeO")
}
var Configuration_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Configuration___vue_template_functional__ = false
/* styles */
var Configuration___vue_styles__ = Configuration_injectStyle
/* scopeId */
var Configuration___vue_scopeId__ = "data-v-f752ca94"
/* moduleIdentifier (server only) */
var Configuration___vue_module_identifier__ = null
var Configuration_Component = Configuration_normalizeComponent(
  Configuration,
  components_Configuration,
  Configuration___vue_template_functional__,
  Configuration___vue_styles__,
  Configuration___vue_scopeId__,
  Configuration___vue_module_identifier__
)

/* harmony default export */ var src_components_Configuration = (Configuration_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Ads.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var filterFn = function filterFn(val, item) {
  var name = item.name;


  return name.toLowerCase().indexOf(val.toLowerCase()) > -1;
};



/* harmony default export */ var Ads = ({
  name: 'Ads',
  methods: {
    deleteAd: function deleteAd(id) {
      var store = this.$store;
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to remove the selected ad?',
        buttonText: 'Delete ad',
        callback: function callback(params) {
          store.dispatch('advertisements/delete', id);
        }
      });
    },
    copyAd: function copyAd(id) {
      this.$store.dispatch('advertisements/copy', id);
    },
    getPaginatedResults: function getPaginatedResults() {
      var sliceStart = this.adPagination.page == 1 ? 0 : (this.adPagination.page - 1) * this.adPagination.resultsPerPage;
      var sliceEnd = this.adPagination.resultsPerPage * this.adPagination.page;

      var ads = this.allAds;

      if (this.filterText && ads) {
        ads = ads.filter(filterFn.bind(null, this.filterText));
      }

      this.ads = ads.slice(sliceStart, sliceEnd);

      if (this.ads.length < 1) {
        this.adsShown = false;
      } else {
        this.adsShown = true;
      }
    },
    prevPage: function prevPage(e) {
      e.preventDefault();

      this.adPagination.page = this.adPagination.page - 1;
    },
    nextPage: function nextPage(e) {
      e.preventDefault();

      this.adPagination.page = this.adPagination.page + 1;
    },
    showModal: function showModal(ad) {
      this.$modal.show('export-ad', ad);
    }
  },
  mounted: function mounted() {
    this.$store.subscribe(function (mutation, state) {
      this.ads = this.$store.getters['advertisements/getSortedAds'];
    }.bind(this));
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('advertisements', {
    allAds: 'ads'
  }), {
    totalAds: function totalAds() {
      return this.allAds.length;
    }
  }),
  data: function data() {
    var obj = {
      ads: this.$store.getters['advertisements/getSortedAds'],
      adPagination: {
        resultsPerPage: 1000,
        page: 1
      },
      initialAdPaginate: false,
      paginationApplied: false,
      searchText: null,
      filterText: '',
      adsShown: true
    };

    return obj;
  },

  watch: {
    ads: function ads() {
      if (!this.initialAdPaginate && this.ads.length) {
        this.initialAdPaginate = true;
      }

      if (this.ads.length && this.allAds) {
        var withFilter = this.allAds.filter(filterFn.bind(null, this.filterText));
        this.adPagination.pages = Math.ceil(withFilter.length / this.adPagination.resultsPerPage);
      }
    },
    initialAdPaginate: function initialAdPaginate() {
      var _this = this;

      setTimeout(function () {
        _this.ads = _this.ads.slice(0, _this.adPagination.resultsPerPage);
        _this.paginationApplied = true;
      }, 100);
    },
    searchText: function searchText(newVal) {
      this.filterText = newVal;

      this.getPaginatedResults();
    },
    'adPagination.resultsPerPage': function adPaginationResultsPerPage(newVal) {
      this.getPaginatedResults();
      this.adPagination.page = 1;
    },
    'adPagination.page': function adPaginationPage() {
      this.getPaginatedResults();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0f8d7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ads.vue
var Ads_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('section',{staticClass:"main-content__full section"},[_c('header',{staticClass:"section__header"},[_c('h1',{staticClass:"section__title creatives__title"},[_vm._v("Creatives "),_c('span',{staticClass:"section__title--count"},[_vm._v("("+_vm._s(_vm.totalAds)+")")])]),_vm._v(" "),_c('section',{staticClass:"section__header__area"},[(_vm.adPagination)?_c('form',{staticClass:"section__header__area__pagination",staticStyle:{"display":"none"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.adPagination.resultsPerPage),expression:"adPagination.resultsPerPage"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.adPagination, "resultsPerPage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":6}},[_vm._v("6")]),_vm._v(" "),_c('option',{domProps:{"value":12}},[_vm._v("12")]),_vm._v(" "),_c('option',{domProps:{"value":24}},[_vm._v("24")]),_vm._v(" "),_c('option',{domProps:{"value":48}},[_vm._v("48")]),_vm._v(" "),_c('option',{domProps:{"value":96}},[_vm._v("96")])]),_vm._v(" per Page\n\n          "),(_vm.adPagination.pages > 1)?_c('span',[_vm._v(" | ")]):_vm._e(),_vm._v(" "),(_vm.adPagination.pages > 1)?_c('button',{attrs:{"disabled":!(_vm.adPagination.page > 1)},on:{"click":_vm.prevPage}},[_vm._v("←")]):_vm._e(),_vm._v(" "),(_vm.adPagination.pages > 1)?_c('span',[_vm._v("Page "+_vm._s(_vm.adPagination.page))]):_vm._e(),_vm._v(" "),(_vm.adPagination.pages > 1)?_c('button',{attrs:{"disabled":!(_vm.adPagination.page < _vm.adPagination.pages)},on:{"click":_vm.nextPage}},[_vm._v("→")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"section__header__area__search search"},[_c('div',{staticClass:"input input--search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"input__field",attrs:{"type":"text","placeholder":"Search ads"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])]),_vm._v(" "),_c('nav',{staticClass:"section__header__area__controls controls"})])])]),_vm._v(" "),_c('section',{staticClass:"section"},[_c('section',{staticClass:"section__content banners"},[_c('ul',{staticClass:"banners__list"},_vm._l((_vm.ads),function(banner){return _c('li',{staticClass:"banners__item"},[_c('banner-item',{ref:'banner'+banner.id,refInFor:true,attrs:{"title":banner.name,"id":banner.id,"format-id":banner.format_id,"link":banner.link,"size":banner.json.size,"banner":banner},on:{"copied":_vm.copyAd,"deleted":_vm.deleteAd}})],1)}))])])])}
var Ads_staticRenderFns = []
var Ads_esExports = { render: Ads_render, staticRenderFns: Ads_staticRenderFns }
/* harmony default export */ var components_Ads = (Ads_esExports);
// CONCATENATED MODULE: ./src/components/Ads.vue
var Ads_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Ads___vue_template_functional__ = false
/* styles */
var Ads___vue_styles__ = null
/* scopeId */
var Ads___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Ads___vue_module_identifier__ = null
var Ads_Component = Ads_normalizeComponent(
  Ads,
  components_Ads,
  Ads___vue_template_functional__,
  Ads___vue_styles__,
  Ads___vue_scopeId__,
  Ads___vue_module_identifier__
)

/* harmony default export */ var src_components_Ads = (Ads_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/CreditCardForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CreditCardForm = ({
  name: 'CreditCardForm',
  mounted: function mounted() {
    var _this = this;

    // Create a Stripe client
    var stripe = Stripe(location.port ? 'pk_test_sqc5TkzskX6KlDziFbOqiJnp' : 'pk_live_cbOV0nOnVVGVkU0RtcRZw6yQ'); // Production runs on port 80

    // Create an instance of Elements
    var elements = stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    // Create an instance of the card Element
    this.card = elements.create('card', { style: style });

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount('#card-element');

    var completed = false;

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }

      if (event.complete) {
        this.bus.$emit('creditCardEntered');
      }

      completed = event.complete;
    }.bind(this));

    var getCard = function getCard() {
      return _this.card;
    };

    this.bus._events['billingFormSaved'] = [];
    this.bus.$on('billingFormSaved', function (id) {
      if (!completed) return this.bus.$emit('noCardValidation');

      stripe.createToken(this.card).then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
        } else {
          // Send the token to your server
          this.bus.$emit('cardValidated', result.token);
        }
      }.bind(this));
    }.bind(this));

    this.bus._events['cardCleared'] = [];
    this.bus.$on('cardCleared', function () {
      this.card.clear();
    }.bind(this));
  },

  components: {},
  methods: {
    update: function update() {
      this.$emit('input', null);
    }
  },
  computed: {},
  data: function data() {
    return {
      result: null
    };
  },

  watch: {},
  props: ['bus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1044684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CreditCardForm.vue
var CreditCardForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var CreditCardForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-row"},[_c('div',{attrs:{"id":"card-element"}}),_vm._v(" "),_c('p',{staticClass:"receipt"},[_vm._v("A receipt of this transaction will be emailed to you.")]),_vm._v(" "),_c('div',{attrs:{"id":"card-errors","role":"alert"}})])])}]
var CreditCardForm_esExports = { render: CreditCardForm_render, staticRenderFns: CreditCardForm_staticRenderFns }
/* harmony default export */ var common_CreditCardForm = (CreditCardForm_esExports);
// CONCATENATED MODULE: ./src/components/common/CreditCardForm.vue
var CreditCardForm_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var CreditCardForm___vue_template_functional__ = false
/* styles */
var CreditCardForm___vue_styles__ = null
/* scopeId */
var CreditCardForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreditCardForm___vue_module_identifier__ = null
var CreditCardForm_Component = CreditCardForm_normalizeComponent(
  CreditCardForm,
  common_CreditCardForm,
  CreditCardForm___vue_template_functional__,
  CreditCardForm___vue_styles__,
  CreditCardForm___vue_scopeId__,
  CreditCardForm___vue_module_identifier__
)

/* harmony default export */ var components_common_CreditCardForm = (CreditCardForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProfileAccount.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ProfileAccount = ({
  name: 'ProfileAccount',
  components: {
    'credit-card-form': components_common_CreditCardForm,
    'boolean': components_configurator_Boolean
  },
  props: ['billing', 'planTerm', 'currentAccount', 'plan_id'],
  data: function data() {
    return {
      accountName: '',
      accountNameDirty: false,
      bus: new vue_esm["a" /* default */](),
      adSearch: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.plan_id) {
      this.billing.plan_id = this.plan_id;
    }

    this.bus.$on('creditCardEntered', function () {
      _this.billing.dirty = true;
    });

    this.bus.$on('cardValidated', function (token) {
      console.log('card validated', token);
      _this.billing.token = token;
      src_store.dispatch('accounts/update', _this.billing);

      _this.billing.dirty = false;
      _this.billing.newCard = false;
    });

    this.bus.$on('noCardValidation', function () {
      src_store.dispatch('accounts/update', _this.billing);
      _this.billing.dirty = false;
    });

    if (this.currentAccount) {
      this.accountName = this.currentAccount.name;

      //this.selected_formats = this.$store.getters['']
    }
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['plans', 'planChosen']), Object(vuex_esm["b" /* mapState */])(['account', 'me']), {
    selectedFormats: function selectedFormats() {
      if (this.$store.state.formats.selectedFormats) {
        return this.$store.state.formats.selectedFormats.filter(function (f) {
          return !f.custom;
        });
      } else {
        return [];
      }
    },
    formats: function formats() {
      var _this2 = this;

      var formats = this.$store.getters['formats/unfiltered'];
      formats.forEach(function (f, index) {
        _this2.selectedFormats.forEach(function (sf) {
          if (sf.id == f.id || f.custom) {
            formats.splice(index, 1);
          }
        });
      });
      return formats;
    },
    planIsVisible: function planIsVisible() {
      return this.currentAccount && this.currentAccount.plan.visible;
    },
    getMonthlyPlans: function getMonthlyPlans() {
      return this.plans.filter(function (plan) {
        return plan.term == 'month';
      });
    },
    getYearlyPlans: function getYearlyPlans() {
      return this.plans.filter(function (plan) {
        return plan.term == 'year';
      });
    },
    getAccount: function getAccount() {
      if (this.account.id) {
        this.currentAccount = this.account;
      }
      return this.currentAccount;
    },
    isCouponApplied: function isCouponApplied() {
      var account = this.currentAccount;
      if (!account) return;
      if (account.coupon_id) {
        return account.plan_id;
      } else {
        return false;
      }
    },
    getAccountUsers: function getAccountUsers() {
      return this.account.account_users;
    },
    getAccounts: function getAccounts() {
      return src_store.getters['accounts/owned'];
    },
    isUserAccountAdmin: function isUserAccountAdmin() {
      var _this3 = this;

      var rtnValue = false;
      if (this.account.account_users) {
        this.account.account_users.forEach(function (account_user) {
          if (account_user.user_id === _this3.me.id) {
            if (account_user.permissions == 'admin') {
              rtnValue = true;
            }
          }
        });
      }
      return rtnValue;
    },
    hasOneAccount: function hasOneAccount() {
      if (src_store.getters['accounts/owned']) {
        return src_store.getters['accounts/owned'].length == 1;
      }
    },
    isUserAccountOwner: function isUserAccountOwner() {
      var _this4 = this;

      var rtnValue = false;
      if (this.account.account_users) {
        this.account.account_users.forEach(function (account_user) {
          if (account_user.user_id === _this4.me.id) {
            if (account_user.owner) {
              rtnValue = true;
            }
          }
        });
      }
      return rtnValue;
    },
    checkUserCount: function checkUserCount() {
      if (this.currentAccount.id) {
        if (this.currentAccount.account_users.length && this.billing.plan) {
          if (this.currentAccount.account_users.length == 1 && this.billing.plan.max_users == 1) {
            return true;
          }
          return this.currentAccount.account_users.length < this.billing.plan.max_users;
        }
      }
    },
    getViewPlanText: function getViewPlanText() {
      if (this.planTerm == 'month') {
        return 'View Yearly Plans';
      } else if (this.planTerm == 'year') {
        return 'View Monthly Plans';
      }
    },
    getCurrentUser: function getCurrentUser() {
      if (this.me.id) {
        return this.me.id;
      } else {
        return false;
      }
    },
    currentAccountName: function currentAccountName() {
      if (this.currentAccount) {
        return this.currentAccount.name;
      }
    }
  }),
  methods: {
    addFormat: function addFormat() {
      var _this5 = this;

      var ad = this.adSearch;
      this.formats.forEach(function (format) {
        if (format.name === ad) {
          _this5.$store.dispatch('accounts/formats/addSelected', { format_id: format.id });
        }
      });
      this.adSearch = '';
      return null;
    },
    deleteFormat: function deleteFormat(format_id) {
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to remove this format from visibility? (Users on your account will not be able to see this format until you re-add it)',
        buttonText: 'Remove Format',
        callback: function (params) {
          this.$store.dispatch('accounts/formats/deleteSelected', { format_id: format_id });
        }.bind(this)
      });
    },
    saveAccountName: function saveAccountName() {
      var payload = {
        name: this.accountName,
        id: this.currentAccount.id
      };
      src_store.dispatch('accounts/update', payload);
      this.accountNameDirty = false;
    },
    cancelAccountName: function cancelAccountName() {
      this.accountName = this.currentAccount.name;
      this.accountNameDirty = false;
    },
    needsCard: function needsCard() {
      return !this.billing.id || this.billing.newCard || !this.billing.cardType;
    },
    togglePlanTerm: function togglePlanTerm() {
      if (this.planTerm == 'month') {
        this.planTerm = 'year';
      } else if (this.planTerm == 'year') {
        this.planTerm = 'month';
      }
    },
    removeUserFromAccount: function removeUserFromAccount(id) {
      src_store.dispatch('accounts/users/remove', { id: id });
    },
    toggleUserPermissions: function toggleUserPermissions(id, perms) {
      var passperms = void 0;
      if (perms == 'admin') {
        passperms = 'normal';
      } else if (perms == 'normal') {
        passperms = 'admin';
      }
      src_store.dispatch('accounts/users/togglePerms', { id: id, permissions: passperms });
    },
    promptCreateAccount: function promptCreateAccount() {
      this.$modal.show('userinput', {
        modalTitle: 'Create Account',
        messageText: 'Enter the name of the account you want to create!',
        fieldType: 'text',
        fieldPlaceholder: 'ParkAve Inc.',
        buttonText: 'Create',
        callback: function callback(value) {
          src_store.dispatch('accounts/create', value);
        }
      });
    },
    prettyPrice: function prettyPrice(plan) {
      var price = (plan.price / 100).toFixed(2);
      return '$' + price + ' / ' + plan.term;
    },
    requiresCard: function requiresCard(plan) {
      if (plan) {
        return plan.price > 0;
      }
    },
    cancelAccount: function cancelAccount(e) {
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to cancel your account?',
        buttonText: 'Yes',
        callback: function callback(params) {
          src_store.dispatch('cancelAccount');
        }
      });
    },
    promptDeleteAccount: function promptDeleteAccount() {
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to delete your account?',
        buttonText: 'Yes',
        callback: function callback(params) {
          src_store.dispatch('accounts/delete', this.account.id);
        }
      });
    },
    saveCardInfo: function saveCardInfo(e) {
      e.preventDefault();
      this.bus.$emit('billingFormSaved');
    },
    saveBilling: function saveBilling(e) {
      var _this6 = this;

      console.log('billing', this.billing);

      if (this.needsCard()) {
        this.saveCardInfo(e);
        return;
      }

      e.preventDefault();
      src_store.dispatch('accounts/update', this.billing).then(function () {
        FS.event('Signed Up', {
          plan_name_str: _this6.billing.plan.name,
          plan_id: _this6.billing.plan_id,
          coupon_code_str: null,
          amount_discounted: 0
        });

        if (_this6.isProduction()) {
          var image = document.createElement('img');
          var script = document.createElement('script');
          script.src = 'https://www.dwin1.com/19038.js';
          script.defer = 'defer';
          script.type = 'text/javascript';
          image.src = 'https://www.shareasale.com/sale.cfm?tracking=' + _this6.billing.id + 'p' + _this6.billing.plan_id + '&amount=' + (_this6.billing.plan.price / 100).toFixed(2) + '&merchantID=97774&transtype=sale';
          image.width = '1';
          image.height = '1';

          document.body.appendChild(image);
          document.body.appendChild(script);
        }
      });
      this.billing.dirty = false;
    },
    cancelSaveBilling: function cancelSaveBilling(e) {
      e.preventDefault();

      this.billing.token = null;
      this.billing.dirty = false;

      this.bus.$emit('cardCleared');
    },
    updateCard: function updateCard(e) {
      e.preventDefault();

      this.billing.newCard = true;
    },
    cancelUpdateCard: function cancelUpdateCard(e) {
      e.preventDefault();

      this.billing.newCard = false;
    },
    choosePlan: function choosePlan(plan) {
      if (this.billing.plan_id != plan.id && !this.billing.dirty) {
        this.billing.dirty = true;
      }
      this.billing.plan_id = plan.id;
      this.billing.plan = plan;
      if (plan.id == this.planChosen.id) {
        this.billing.dirty = false;
      }
    },
    promptAddUser: function promptAddUser() {
      if (this.billing.plan.max_users == 1) {
        this.$modal.show('pricing');
        this.$snotify.info('Want to add users to your account? Upgrade your account to a Team Account!', { timeout: 5000 });
        return;
      }

      this.$modal.show('userinput', {
        modalTitle: 'Invite User',
        messageText: 'Enter the email of the user you want to invite: (Also note that your monthly or yearly rate is prorated on how many users you added to the account)',
        fieldType: 'email',
        fieldPlaceholder: 'example@parkave.com',
        buttonText: 'Invite',
        callback: function callback(value) {
          src_store.dispatch('inviteUser', value);
        }
      });
    }
  },
  watch: {
    accountName: function accountName(newVal) {
      if (newVal != this.currentAccount.name) {
        this.accountNameDirty = true;
      } else {
        this.accountNameDirty = false;
      }
    },
    currentAccountName: function currentAccountName(newVal) {
      if (newVal) {
        this.accountName = this.currentAccountName;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e404f17","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileAccount.vue
var ProfileAccount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"section__content form"},[_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(0,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[(_vm.currentAccount)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accountName),expression:"accountName"}],staticClass:"input__field",attrs:{"type":"text"},domProps:{"value":(_vm.accountName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.accountName=$event.target.value}}}):_vm._e()])]),_vm._v(" "),(_vm.accountNameDirty)?_c('article',{staticClass:"form__item form__item--show-border"},[_c('a',{staticClass:"section__footer__button button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveAccountName($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('a',{staticClass:"section__footer__button section__footer__button--right button button--secondary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelAccountName($event)}}},[_vm._v("Cancel")])]):_vm._e()])]),_vm._v(" "),(_vm.planIsVisible)?_c('form',{staticClass:"section__content form"},[_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__group"},[_c('aside',{staticClass:"choose-plan"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title centered"},[_vm._v("Choose a plan")]),_vm._v(" "),(_vm.isCouponApplied)?_c('h1',{staticClass:"window__description window__description--active"},[_vm._v("You have a limited edition coupon active on your plan")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button button--secondary",on:{"click":_vm.togglePlanTerm}},[_vm._v(_vm._s(_vm.getViewPlanText))])]),_vm._v(" "),_c('section',{staticClass:"window__content pricing"},[(_vm.planTerm == 'month')?_c('ul',{staticClass:"pricing__list"},_vm._l((_vm.getMonthlyPlans),function(plan){return _c('li',{staticClass:"pricing__item"},[_c('article',{staticClass:"plan",class:{'plan--selected': _vm.billing.plan_id == plan.id},on:{"click":function($event){_vm.choosePlan(plan)}}},[_c('header',{staticClass:"plan__header"},[_c('h1',{staticClass:"plan__type"},[_vm._v(_vm._s(plan.name))]),_vm._v(" "),_c('h2',{staticClass:"plan__price"},[_c('span',{staticClass:"plan__price__value"},[_c('span',{staticClass:"plan__price__currency"},[_vm._v("$")]),_c('span',{class:{'plan__coupon--strike': plan.id == _vm.isCouponApplied}},[_vm._v(_vm._s(plan.price / 100))]),_vm._v(" "),(plan.id == _vm.isCouponApplied)?_c('span',{staticClass:"plan__price__currency",class:{'plan__coupon': plan.id == _vm.isCouponApplied}},[_vm._v("$")]):_vm._e(),(plan.id == _vm.isCouponApplied)?_c('span',{class:{'plan__coupon': plan.id == _vm.isCouponApplied}},[_vm._v(_vm._s((plan.price / 100) - _vm.currentAccount.coupon_amount_discounted))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"plan__price__frequency"},[_vm._v("/ month ")])])]),_vm._v(" "),_c('ul',{staticClass:"plan__properties plan__properties--expanded"},_vm._l((plan.properties),function(property){return _c('li',{staticClass:"plan__property"},[_vm._v("\n                      "+_vm._s(property)+"\n                    ")])}))])])})):_vm._e(),_vm._v(" "),(_vm.planTerm == 'year')?_c('ul',{staticClass:"pricing__list"},_vm._l((_vm.getYearlyPlans),function(plan){return _c('li',{staticClass:"pricing__item"},[_c('article',{staticClass:"plan",class:{'plan--selected': _vm.billing.plan_id == plan.id},on:{"click":function($event){_vm.choosePlan(plan)}}},[_c('header',{staticClass:"plan__header"},[_c('h1',{staticClass:"plan__type"},[_vm._v(_vm._s(plan.name))]),_vm._v(" "),_c('h2',{staticClass:"plan__price"},[_c('span',{staticClass:"plan__price__value"},[_c('span',{staticClass:"plan__price__currency"},[_vm._v("$")]),_c('span',{class:{'plan__coupon--strike': plan.id == _vm.isCouponApplied}},[_vm._v(_vm._s(plan.price / 100))]),_vm._v(" "),(plan.id == _vm.isCouponApplied)?_c('span',{staticClass:"plan__price__currency",class:{'plan__coupon': plan.id == _vm.isCouponApplied}},[_vm._v("$")]):_vm._e(),(plan.id == _vm.isCouponApplied)?_c('span',{class:{'plan__coupon': plan.id == _vm.isCouponApplied}},[_vm._v(_vm._s((plan.price / 100) - _vm.currentAccount.coupon_amount_discounted))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"plan__price__frequency"},[_vm._v("/ year")])])]),_vm._v(" "),_c('ul',{staticClass:"plan__properties"},_vm._l((plan.properties),function(property){return _c('li',{staticClass:"plan__property"},[_vm._v("\n                      "+_vm._s(property)+"\n                    ")])}))])])})):_vm._e()])])]),_vm._v(" "),(_vm.requiresCard(_vm.billing.plan))?_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input card__management"},[(_vm.needsCard())?_c('credit-card-form',{staticStyle:{"min-width":"500px","margin-bottom":"1em"},attrs:{"bus":_vm.bus},model:{value:(_vm.billing.token),callback:function ($$v) {_vm.$set(_vm.billing, "token", $$v)},expression:"billing.token"}}):_vm._e(),_vm._v(" "),(_vm.billing.newCard)?_c('a',{staticClass:"button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveCardInfo($event)}}},[_vm._v("Save")]):_vm._e(),(_vm.billing.newCard)?_c('a',{staticClass:"button button--secondary",attrs:{"href":"#"},on:{"click":_vm.cancelUpdateCard}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.billing.id && !_vm.billing.newCard && _vm.billing.cardType)?_c('div',{staticStyle:{"min-width":"450px","text-align":"right"}},[_c('span',{staticStyle:{"margin-right":"1em","display":"inline-block"}},[_vm._v(_vm._s(_vm.billing.cardType)+" ending in "+_vm._s(_vm.billing.last4)+" and expiring on "+_vm._s(_vm.billing.exp))]),_vm._v(" "),_c('a',{staticClass:"button button--secondary",staticStyle:{"display":"inline-block"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.updateCard($event)}}},[_vm._v("Update")])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(this.billing.dirty)?_c('article',{staticClass:"form__item form__item--show-border"},[_c('a',{staticClass:"section__footer__button button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveBilling($event)}}},[_vm._v("Save")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.getAccount && _vm.getAccount.plan.team)?_c('form',{staticClass:"section__content form section__team"},[_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_c('strong',[_vm._v("Current Account:")]),_vm._v(" "+_vm._s(_vm.getAccount.name))])]),_vm._v(" "),(_vm.getAccount.plan)?_c('label',{staticClass:"form__item__label"},[(_vm.getAccount.plan.max_users > 11)?_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(_vm.getAccount.plan.name)+": $"+_vm._s((_vm.getAccount.plan.price / 100))+" per user in account")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.checkUserCount)?_c('div',{staticClass:"button button--primary",on:{"click":_vm.promptAddUser}},[_vm._v("Add User")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.getAccountUsers),function(user){return (_vm.getAccountUsers)?_c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(user.user.name))]),_vm._v(" "),_c('p',{staticClass:"form__item__subname"},[_vm._v(_vm._s(_vm.capitalize(user.permissions)))])]),_vm._v(" "),(_vm.isUserAccountAdmin && user.user_id !== _vm.getCurrentUser)?_c('section',{staticClass:"form__item__input input"},[_c('span',[_vm._v("Toggle admin")])]):_vm._e(),_vm._v(" "),(_vm.isUserAccountAdmin && user.user_id !== _vm.getCurrentUser)?_c('section',{staticClass:"form__item__input input form__switch"},[_c('boolean',{attrs:{"defaultValue":user.permissions == 'admin',"id":user.user.id},on:{"input":function($event){_vm.toggleUserPermissions(user.id, user.permissions)}}})],1):_vm._e(),_vm._v(" "),(_vm.isUserAccountAdmin && user.user_id !== _vm.getCurrentUser)?_c('section',{staticClass:"form__item__input input"},[_c('div',{staticClass:"button button--faded",on:{"click":function($event){_vm.removeUserFromAccount(user.id)}}},[_vm._v("Remove User")])]):_vm._e()]):_vm._e()})],2),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isUserAccountAdmin)?_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item"},[_vm._m(2,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adSearch),expression:"adSearch"}],staticClass:"input__field",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.adSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adSearch=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"admin__category__ul"}},_vm._l((_vm.formats),function(format){return _c('div',[(format.name.toUpperCase().indexOf(_vm.adSearch.toUpperCase()) > -1 && format.name !== _vm.adSearch)?_c('a',{staticClass:"admin__li",attrs:{"href":"#"},on:{"click":function($event){_vm.adSearch = format.name}}},[_vm._v(_vm._s(format.name))]):_vm._e()])}))]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input"},[_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":_vm.addFormat}},[_vm._v("Add Format")])])]),_vm._v(" "),_vm._l((_vm.selectedFormats),function(ad){return _c('article',{staticClass:"form__item"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(ad.name))])]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('div',{staticClass:"admin__button button button--remove",on:{"click":function($event){_vm.deleteFormat(ad.id)}}},[_vm._v("Remove")])])])})],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"section__content form"},[_c('fieldset',{staticClass:"form__group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"button button--primary",on:{"click":_vm.promptCreateAccount}},[_vm._v("Create A New Account")]),_vm._v(" "),(_vm.isUserAccountOwner && !_vm.hasOneAccount)?_c('div',{staticClass:"button button--faded",on:{"click":_vm.promptDeleteAccount}},[_vm._v("Delete Current Account")]):_vm._e(),_vm._v(" "),_vm._m(3,false,false)])])])])}
var ProfileAccount_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("This Account Name")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("What should we call this account?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Payment information")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Manage your saved card")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Selective Formats for Users")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Which formats will the users of your account be able to see? (If there are no formats selected all of our formats will display to your users by default.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help__tip"},[_c('p',[_vm._v("You can make multiple accounts for your user and then invite other users to the account.")])])}]
var ProfileAccount_esExports = { render: ProfileAccount_render, staticRenderFns: ProfileAccount_staticRenderFns }
/* harmony default export */ var components_ProfileAccount = (ProfileAccount_esExports);
// CONCATENATED MODULE: ./src/components/ProfileAccount.vue
function ProfileAccount_injectStyle (ssrContext) {
  __webpack_require__("QcU8")
}
var ProfileAccount_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ProfileAccount___vue_template_functional__ = false
/* styles */
var ProfileAccount___vue_styles__ = ProfileAccount_injectStyle
/* scopeId */
var ProfileAccount___vue_scopeId__ = "data-v-1e404f17"
/* moduleIdentifier (server only) */
var ProfileAccount___vue_module_identifier__ = null
var ProfileAccount_Component = ProfileAccount_normalizeComponent(
  ProfileAccount,
  components_ProfileAccount,
  ProfileAccount___vue_template_functional__,
  ProfileAccount___vue_styles__,
  ProfileAccount___vue_scopeId__,
  ProfileAccount___vue_module_identifier__
)

/* harmony default export */ var src_components_ProfileAccount = (ProfileAccount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProfileGeneral.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ProfileGeneral_gradePassword = function gradePassword(password) {
  var score = 0;

  var grades = ['very weak', 'weak', 'ok', 'strong', 'very strong'];
  var colors = ['#8B0000', '#FF0000', '#CCCC00', '#83db4c', '#25a11a'];

  var hasNumbers = /\d/.test(password);
  var hasLowerCase = /[a-z]/.test(password);
  var hasUpperCase = /[A-Z]/.test(password);
  var hasSpecialCharacter = /[^a-z\d]+/i.test(password);
  var hasLength = password.length >= 8;

  if (hasNumbers) ++score;
  if (hasLowerCase) ++score;
  if (hasUpperCase) ++score;
  if (hasSpecialCharacter) ++score;
  if (hasLength) ++score;

  if (score >= grades.length) {
    score = grades.length - 1;
  }

  return {
    name: grades[score],
    color: colors[score]
  };
};

/* harmony default export */ var ProfileGeneral = ({
  name: 'ProfileGeneral',
  components: {
    'password': components_common_Password
  },
  props: ['name', 'email'],
  data: function data() {
    return {
      basicDirty: false,
      currentPassword: null,
      newPassword: null,
      confirmNewPassword: null,
      passwordDirty: null,
      validPassword: false
    };
  },
  mounted: function mounted() {
    this.resetPasswordStates();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['me']), {
    hasPassword: function hasPassword() {
      // This always returns false right now
      return this.me.password;
    }
  }),
  methods: {
    saveBasicDetails: function saveBasicDetails(e) {
      e.preventDefault();
      var payload = {
        name: this.name,
        email: this.email
      };
      src_store.dispatch('users/updateBasicDetails', { userId: this.me.id, payload: payload });
      this.basicDirty = false;
    },
    cancelBasicDetails: function cancelBasicDetails(e) {
      e.preventDefault();
      this.name = this.me.name;
      this.email = this.me.email;
    },
    resetPasswordStates: function resetPasswordStates() {
      if (this.$refs.currentPassword) this.$refs.currentPassword.resetState();
      this.$refs.newPassword.resetState();
      this.$refs.confirmNewPassword.resetState();
      this.currentPassword = null;
      this.newPassword = null;
      this.confirmNewPassword = null;
      this.passwordDirty = false;
    },
    savePassword: function savePassword(e) {
      e.preventDefault();
      var newPassword = this.newPassword,
          currentPassword = this.currentPassword,
          hasPassword = this.hasPassword;

      src_store.dispatch('users/updatePassword', { userId: this.me.id, currentPassword: currentPassword, hasPassword: hasPassword, newPassword: newPassword });
      this.resetPasswordStates();
    },
    cancelSavePassword: function cancelSavePassword(e) {
      e.preventDefault();
      this.resetPasswordStates();
    }
  },
  watch: {
    name: function name(newVal) {
      if (newVal != this.me.name) {
        this.basicDirty = true;
      } else {
        this.basicDirty = false;
      }
    },
    email: function email(newVal) {
      if (newVal != this.me.email) {
        this.basicDirty = true;
      } else {
        this.basicDirty = false;
      }
    },
    currentPassword: function currentPassword(newVal) {
      // Temporarily Disabled because hasPassword() returns false always
      if (newVal == '') {
        this.passwordDirty = false;
      } else {
        this.passwordDirty = true;
      }
    },

    newPassword: function newPassword(newVal, oldVal) {

      if (newVal == '') {
        this.passwordDirty = false;
      } else {
        this.passwordDirty = true;
      }

      var grade = ProfileGeneral_gradePassword(newVal);

      this.passwordGrade = grade.name;
      this.passwordColor = grade.color;

      if (grade.name == 'very strong' || grade.name == 'strong') {
        this.validPassword = true;
      } else {
        this.validPassword = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6240a5d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileGeneral.vue
var ProfileGeneral_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"section__content form"},[_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(0,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input__field",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input__field",attrs:{"type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),(_vm.basicDirty)?_c('article',{staticClass:"form__item form__item--show-border"},[_c('a',{staticClass:"section__footer__button button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveBasicDetails($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('a',{staticClass:"section__footer__button section__footer__button--right button button--secondary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelBasicDetails($event)}}},[_vm._v("Cancel")])]):_vm._e()])]),_vm._v(" "),_c('form',{staticClass:"section__content form"},[_c('fieldset',{staticClass:"form__group"},[(false)?_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(2,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('password',{ref:"currentPassword",attrs:{"match":null,"skipPasswordGrade":true},model:{value:(_vm.currentPassword),callback:function ($$v) {_vm.currentPassword=$$v},expression:"currentPassword"}})],1)]):_vm._e(),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(3,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('password',{ref:"newPassword",attrs:{"match":null,"skipPasswordGrade":false},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1)]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(4,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('password',{ref:"confirmNewPassword",attrs:{"match":_vm.newPassword,"skipPasswordGrade":false},model:{value:(_vm.confirmNewPassword),callback:function ($$v) {_vm.confirmNewPassword=$$v},expression:"confirmNewPassword"}})],1)]),_vm._v(" "),((_vm.passwordDirty && _vm.currentPassword || !_vm.hasPassword) && _vm.validPassword && _vm.newPassword && _vm.newPassword == _vm.confirmNewPassword)?_c('article',{staticClass:"form__item form__item--show-border"},[_c('a',{staticClass:"section__footer__button button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.savePassword($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('a',{staticClass:"section__footer__button section__footer__button--right button button--secondary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelSavePassword($event)}}},[_vm._v("Cancel")])]):_vm._e()])])])}
var ProfileGeneral_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Your name")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("What should we call you?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Current Email ")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("The email that is associated to your user.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Current password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("New password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Confirm new password")])])}]
var ProfileGeneral_esExports = { render: ProfileGeneral_render, staticRenderFns: ProfileGeneral_staticRenderFns }
/* harmony default export */ var components_ProfileGeneral = (ProfileGeneral_esExports);
// CONCATENATED MODULE: ./src/components/ProfileGeneral.vue
function ProfileGeneral_injectStyle (ssrContext) {
  __webpack_require__("MY+i")
}
var ProfileGeneral_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ProfileGeneral___vue_template_functional__ = false
/* styles */
var ProfileGeneral___vue_styles__ = ProfileGeneral_injectStyle
/* scopeId */
var ProfileGeneral___vue_scopeId__ = "data-v-6240a5d8"
/* moduleIdentifier (server only) */
var ProfileGeneral___vue_module_identifier__ = null
var ProfileGeneral_Component = ProfileGeneral_normalizeComponent(
  ProfileGeneral,
  components_ProfileGeneral,
  ProfileGeneral___vue_template_functional__,
  ProfileGeneral___vue_styles__,
  ProfileGeneral___vue_scopeId__,
  ProfileGeneral___vue_module_identifier__
)

/* harmony default export */ var src_components_ProfileGeneral = (ProfileGeneral_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Profile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Profile = ({
  name: 'Profile',
  components: {
    ProfileAccount: src_components_ProfileAccount,
    ProfileGeneral: src_components_ProfileGeneral
  },
  mounted: function mounted() {
    if (this.$route.hash.slice(1)) {
      this.current = this.$route.hash.slice(1);
    }
    if (!localStorage.account_id) {
      this.$router.push('/');
    }
    this.plan_id = this.$store.state.account.plan_id;
    this.billing.id = this.$store.state.account.id;
    this.billing.plan = this.$store.state.account.plan;
    this.billing.last4 = this.$store.state.account.card_last_4;
    this.billing.cardType = this.$store.state.account.card_type;
    this.billing.exp = [this.$store.state.account.card_exp_month, this.$store.state.account.card_exp_year].join('/');
    this.name = this.$store.state.me.name;
    this.email = this.$store.state.me.email;
    this.$store.subscribe(function (mutation, state) {
      if (state.me.name) this.name = state.me.name;
      if (state.me.email) this.email = state.me.email;
      if (state.account.id) {
        this.currentAccount = state.account;
        this.planTerm = state.account.plan.term;
        this.billing = lodash_default.a.extend(this.billing, {
          id: state.account.id,
          plan: state.account.plan,
          plan_id: state.account.plan_id,
          last4: state.account.card_last_4,
          cardType: state.account.card_type,
          exp: [state.account.card_exp_month, state.account.card_exp_year].join('/')
        });
      }
    }.bind(this));
  },
  data: function data() {
    return {
      name: '',
      email: '',
      billing: {
        plan: {},
        plan_id: null,
        token: null,
        dirty: false,
        last4: null,
        cardType: null,
        newCard: false
      },
      currentAccount: null,
      planTerm: 'month',
      current: '',
      plan_id: null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d3b10f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('nav',{staticClass:"tabs"},[_c('router-link',{staticClass:"tabs__tab tab",class:{'tab--active': (_vm.current === '')},attrs:{"to":""},nativeOn:{"click":function($event){_vm.current = ''}}},[_vm._v("General")]),_vm._v(" "),_c('router-link',{staticClass:"tabs__tab tab",class:{'tab--active': _vm.current === 'account'},attrs:{"to":"#account"},nativeOn:{"click":function($event){_vm.current = 'account'}}},[_vm._v("Account")])],1),_vm._v(" "),_c('section',{staticClass:"main-content main-content--white-background"},[_c('section',{staticClass:"main-content__full section"},[(_vm.current == '')?_c('profile-general',{attrs:{"name":_vm.name,"email":_vm.email}}):_vm._e(),_vm._v(" "),(_vm.current == 'account')?_c('profile-account',{attrs:{"plan_id":_vm.plan_id,"billing":_vm.billing,"planTerm":_vm.planTerm,"currentAccount":_vm.currentAccount}}):_vm._e()],1)])])}
var Profile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h1',{staticClass:"header__title"},[_vm._v("Account Settings")]),_vm._v(" "),_c('section',{staticClass:"header__area"})])}]
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var components_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/components/Profile.vue
function Profile_injectStyle (ssrContext) {
  __webpack_require__("ZPjm")
}
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = Profile_injectStyle
/* scopeId */
var Profile___vue_scopeId__ = "data-v-4d3b10f4"
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  components_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var src_components_Profile = (Profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InsertCreative.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var InsertCreative = ({
  name: 'InsertCreative',
  components: {},
  mounted: function mounted() {},

  computed: {},
  methods: {},
  data: function data() {
    return {
      'showTooltipCreative': false,
      'showTooltipSize': false
    };
  },

  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705c7eb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InsertCreative.vue
var InsertCreative_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"width":"800px","margin":"0 auto","display":"flex","flex-flow":"row","min-height":"500px","align-items":"flex-start"}},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"tooltip",staticStyle:{"width":"400px"}},[_c('div',{staticStyle:{"margin-bottom":"30px","border-bottom":"1px solid #ddd","padding-bottom":"10px"}},[_vm._v("Click \"Parkave\"... and then click \"Browse all\"...")]),_vm._v(" "),_c('a',{staticClass:"tooltip__button-branded button-branded button-branded--is-blue",on:{"click":function($event){_vm.showTooltipCreative = !_vm.showTooltipCreative}}},[_c('span',{staticClass:"button-branded__label"},[_vm._v("PARKAVE")])]),_vm._v(" "),_c('aside',{staticClass:"tooltip__wrapper",class:{'tooltip__wrapper--is-visible': _vm.showTooltipCreative}},[_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('ul',{staticClass:"tooltip__list"},_vm._l((4),function(index){return _c('li',{key:index,staticClass:"tooltip__list__item"},[_vm._m(3,true,false)])})),_vm._v(" "),_c('footer',{staticClass:"tooltip__footer"},[_c('a',{staticClass:"tooltip__footer__link link link--chevron",on:{"click":function($event){(_vm.showTooltipSize = !_vm.showTooltipSize); (_vm.showTooltipCreative = false)}}},[_vm._v("Browse all")])])]),_vm._v(" "),_c('aside',{staticClass:"tooltip__wrapper",class:{'tooltip__wrapper--is-visible': _vm.showTooltipSize}},[_c('header',{staticClass:"tooltip__header tooltip__header--has-prefix"},[_c('a',{staticClass:"tooltip__header__prefix",attrs:{"href":"#"},on:{"click":function($event){(_vm.showTooltipSize = false); (_vm.showTooltipCreative = true)}}},[_c('span',{staticClass:"tooltip__header__prefix__label"},[_vm._v("Back")])]),_vm._v(" "),_c('h1',{staticClass:"tooltip__header__title"},[_vm._v("Choose size")])]),_vm._v(" "),_c('ul',{staticClass:"tooltip__list"},_vm._l((4),function(index){return _c('li',{key:index,staticClass:"tooltip__list__item"},[_vm._m(4,true,false)])}))])])])}
var InsertCreative_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip",staticStyle:{"margin-right":"200px","width":"400px"}},[_c('div',{staticStyle:{"margin-bottom":"30px","border-bottom":"1px solid #ddd","padding-bottom":"10px"}},[_vm._v("Buttons")]),_vm._v(" "),_c('a',{staticClass:"tooltip__button-branded button-branded button-branded--is-white"},[_c('span',{staticClass:"button-branded__label"},[_vm._v("PARKAVE")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"30px"}}),_vm._v(" "),_c('a',{staticClass:"tooltip__button-branded button-branded button-branded--is-blue"},[_c('span',{staticClass:"button-branded__label"},[_vm._v("PARKAVE")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"30px"}}),_vm._v(" "),_c('a',{staticClass:"button-dfp button-dfp--is-green",attrs:{"href":"#"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"30px"}}),_vm._v(" "),_c('a',{staticClass:"button-dfp button-dfp--is-white",attrs:{"href":"#"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"tooltip__header"},[_c('h1',{staticClass:"tooltip__header__title"},[_vm._v("Insert my creative")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip__input input input--search input--search-outline"},[_c('input',{staticClass:"input__field",attrs:{"type":"text","placeholder":"Search my creatives"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltip__list__link",attrs:{"href":"#"}},[_c('figure',{staticClass:"tooltip__list__image"},[_c('img',{staticClass:"tooltip__list__image__source",attrs:{"src":"https://via.placeholder.com/40x40/2558BB/ffffff","alt":""}})]),_vm._v(" "),_c('span',{staticClass:"tooltip__list__title"},[_vm._v("Rook Coffee")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tooltip__list__link",attrs:{"href":"#"}},[_c('span',{staticClass:"tooltip__list__title"},[_vm._v("728x320")])])}]
var InsertCreative_esExports = { render: InsertCreative_render, staticRenderFns: InsertCreative_staticRenderFns }
/* harmony default export */ var components_InsertCreative = (InsertCreative_esExports);
// CONCATENATED MODULE: ./src/components/InsertCreative.vue
var InsertCreative_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var InsertCreative___vue_template_functional__ = false
/* styles */
var InsertCreative___vue_styles__ = null
/* scopeId */
var InsertCreative___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InsertCreative___vue_module_identifier__ = null
var InsertCreative_Component = InsertCreative_normalizeComponent(
  InsertCreative,
  components_InsertCreative,
  InsertCreative___vue_template_functional__,
  InsertCreative___vue_styles__,
  InsertCreative___vue_scopeId__,
  InsertCreative___vue_module_identifier__
)

/* harmony default export */ var src_components_InsertCreative = (InsertCreative_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/DemoLinks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DemoLinks = ({
  name: 'demo-links',
  data: function data() {
    var obj = {
      selected: undefined,
      links: ['Description', 'Available Sizes', 'Media Kit Material', 'Design Information']
    };
    return obj;
  },

  computed: {
    sectionLinks: function sectionLinks() {}
  },
  methods: {
    navigateTo: function navigateTo(index) {
      this.selected = index;
      this.$emit('clicked', '' + index);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7afc41f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/DemoLinks.vue
var DemoLinks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"flex-basis":"20%"}},[_c('header',{staticClass:"categories__header"},[_c('h2',{staticClass:"categories__title"},[_vm._v("Important Links "+_vm._s(_vm.sectionLinks))])]),_vm._v(" "),_c('ul',{staticClass:"categories__list"},_vm._l((_vm.links),function(link,index){return _c('li',{staticClass:"categories__item demo-listitem-active"},[_c('a',{staticClass:"categories__link",class:{'demo-link-active': index == _vm.selected},attrs:{"href":"#"},on:{"click":function($event){_vm.navigateTo(index)}}},[_vm._v(_vm._s(link))])])}))])}
var DemoLinks_staticRenderFns = []
var DemoLinks_esExports = { render: DemoLinks_render, staticRenderFns: DemoLinks_staticRenderFns }
/* harmony default export */ var demo_DemoLinks = (DemoLinks_esExports);
// CONCATENATED MODULE: ./src/components/demo/DemoLinks.vue
function DemoLinks_injectStyle (ssrContext) {
  __webpack_require__("IKwM")
}
var DemoLinks_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DemoLinks___vue_template_functional__ = false
/* styles */
var DemoLinks___vue_styles__ = DemoLinks_injectStyle
/* scopeId */
var DemoLinks___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DemoLinks___vue_module_identifier__ = null
var DemoLinks_Component = DemoLinks_normalizeComponent(
  DemoLinks,
  demo_DemoLinks,
  DemoLinks___vue_template_functional__,
  DemoLinks___vue_styles__,
  DemoLinks___vue_scopeId__,
  DemoLinks___vue_module_identifier__
)

/* harmony default export */ var components_demo_DemoLinks = (DemoLinks_Component.exports);

// EXTERNAL MODULE: ./src/components/common/PreviewSettings.vue + 2 modules
var PreviewSettings = __webpack_require__("gtId");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/DemoItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DemoItem = ({
  name: 'DemoItem',
  props: ['title', 'adformat'],
  mounted: function mounted() {
    var s = document.createElement('script');
    s.src = 'https://cdn.getparkave.com/go-sell.js';
    document.body.insertBefore(s, document.body.firstChild);
  },

  methods: {
    getDisplaySize: function getDisplaySize(size) {
      if (size.type == 'fixed') {
        return size.width + 'x' + size.height;
      } else {
        return size.width + ':' + size.height;
      }
    },
    config: function config(size) {
      return stringify_default()({
        size: {
          width: size.width,
          height: size.height,
          type: size.type
        }
      });
    },
    computeWidth: function computeWidth(size) {
      if (size.type === 'fixed') {
        return size.width + 'px';
      } else {
        return 'auto';
      }
    }
  },
  components: {
    previewSettings: PreviewSettings["a" /* default */]
  },
  computed: {
    getSizes: function getSizes() {
      if (this.adformat) {
        var sizes = [];
        var input = JSON.parse(this.adformat.specification).inputs;

        for (var i = 0; i < input.length; i++) {
          if (input[i].type === 'size') {
            for (var v = 0; v < input[i].options.length; v++) {
              if (input[i].options[v].type === 'flexible') {
                sizes.push({
                  width: input[i].options[v].width,
                  type: 'flexible',
                  height: input[i].options[v].height
                });
              } else {
                sizes.push({
                  width: input[i].options[v].width,
                  type: 'fixed',
                  height: input[i].options[v].height
                });
              }
            }
            return sizes;
          }
        }
        if (sizes === []) {
          return null;
        }
      }
    },
    getPlacementUrl: function getPlacementUrl() {
      if (this.adformat) {
        return this.adformat.preview_placement_id;
      }
    },
    getAdDescription: function getAdDescription() {
      if (this.adformat.description) {
        return this.adformat.description;
      } else {
        return JSON.parse(this.adformat.specification).description;
      }
    },
    getAdTimeStamp: function getAdTimeStamp() {
      var d = new Date();
      d.setMinutes(0);
      d.setSeconds(0);
      var ts = d.setMilliseconds(0);
      return ts;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2475b6ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/DemoItem.vue
var DemoItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"demo__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h4'),_vm._v(" "),(_vm.title === 'Description')?_c('div',[_c('br'),_vm._v(" "),(_vm.adformat)?_c('p',{staticClass:"demo__description"},[_vm._v(_vm._s(_vm.getAdDescription))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.title === 'Available Sizes')?_c('div',[_c('br'),_vm._v(" "),(_vm.adformat && _vm.getSizes)?_c('section',_vm._l((_vm.getSizes),function(size){return _c('section',{staticClass:"demo__adview",style:({width: _vm.computeWidth(size)})},[_c('h2',{staticClass:"demo__adtitle"},[_vm._v(_vm._s(_vm.getDisplaySize(size)))]),_vm._v(" "),_c('ins',{staticClass:"parkave-placement",style:('position:relative;display:inline-table;width:'+size.width+'px;height:'+size.height+'px;max-width:100%;'),attrs:{"data-parkave-width":size.width,"data-parkave-height":size.height,"data-parkave-placement":_vm.getPlacementUrl,"data-parkave-timestamp":_vm.getAdTimeStamp,"data-parkave-size":size.type,"data-parkave-config":_vm.config(size)}})])})):_vm._e(),_vm._v(" "),(_vm.adformat && !_vm.getSizes)?_c('h2',{staticClass:"demo__adtitle"},[_vm._v("Out of Page")]):_vm._e(),_vm._v(" "),(_vm.adformat && !_vm.getSizes)?_c('section',{staticClass:"window__preview",staticStyle:{"width":"100%","height":"500px"}},[_c('div',{staticClass:"window__preview__inner"},[_c('preview-settings',{attrs:{"ad":{},"inputs":{}}}),_vm._v(" "),_c('ins',{staticClass:"parkave-placement",staticStyle:{"display":"none"},attrs:{"data-parkave-placement":_vm.getPlacementUrl,"data-parkave-size":"out-of-page","data-parkave-timestamp":_vm.getAdTimeStamp,"data-parkave-config":"{}"}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.title === 'Media Kit Material')?_c('div',[(_vm.adformat)?_c('div',{staticClass:"demo__sub-section",attrs:{"id":"bs-media-kit-container"},domProps:{"innerHTML":_vm._s(_vm.adformat.media_kit)}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.title === 'Design Information')?_c('div',[(_vm.adformat)?_c('div',{staticClass:"demo__sub-section",attrs:{"id":"bs-designer-info-container"},domProps:{"innerHTML":_vm._s(_vm.adformat.designer_info)}}):_vm._e()]):_vm._e()])}
var DemoItem_staticRenderFns = []
var DemoItem_esExports = { render: DemoItem_render, staticRenderFns: DemoItem_staticRenderFns }
/* harmony default export */ var demo_DemoItem = (DemoItem_esExports);
// CONCATENATED MODULE: ./src/components/demo/DemoItem.vue
function DemoItem_injectStyle (ssrContext) {
  __webpack_require__("f+Yk")
}
var DemoItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DemoItem___vue_template_functional__ = false
/* styles */
var DemoItem___vue_styles__ = DemoItem_injectStyle
/* scopeId */
var DemoItem___vue_scopeId__ = "data-v-2475b6ae"
/* moduleIdentifier (server only) */
var DemoItem___vue_module_identifier__ = null
var DemoItem_Component = DemoItem_normalizeComponent(
  DemoItem,
  demo_DemoItem,
  DemoItem___vue_template_functional__,
  DemoItem___vue_styles__,
  DemoItem___vue_scopeId__,
  DemoItem___vue_module_identifier__
)

/* harmony default export */ var components_demo_DemoItem = (DemoItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/demo/DemoListing.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var DemoListing = ({
  name: 'demo-listing',
  props: ['adformat'],
  components: {
    demoItem: components_demo_DemoItem
  },
  data: function data() {
    return {
      demoSections: [{ title: 'Description' }, { title: 'Available Sizes' }, { title: 'Media Kit Material' }, { title: 'Design Information' }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a52fdca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/DemoListing.vue
var DemoListing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"formats__list"},_vm._l((_vm.demoSections),function(item,index){return _c('li',{staticClass:"formats__item demo__item",class:'demo-item-'+index},[_c('demo-item',{attrs:{"title":item.title,"adformat":_vm.adformat}})],1)}))}
var DemoListing_staticRenderFns = []
var DemoListing_esExports = { render: DemoListing_render, staticRenderFns: DemoListing_staticRenderFns }
/* harmony default export */ var demo_DemoListing = (DemoListing_esExports);
// CONCATENATED MODULE: ./src/components/demo/DemoListing.vue
function DemoListing_injectStyle (ssrContext) {
  __webpack_require__("nwCD")
}
var DemoListing_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DemoListing___vue_template_functional__ = false
/* styles */
var DemoListing___vue_styles__ = DemoListing_injectStyle
/* scopeId */
var DemoListing___vue_scopeId__ = "data-v-0a52fdca"
/* moduleIdentifier (server only) */
var DemoListing___vue_module_identifier__ = null
var DemoListing_Component = DemoListing_normalizeComponent(
  DemoListing,
  demo_DemoListing,
  DemoListing___vue_template_functional__,
  DemoListing___vue_styles__,
  DemoListing___vue_scopeId__,
  DemoListing___vue_module_identifier__
)

/* harmony default export */ var components_demo_DemoListing = (DemoListing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Demo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Demo = ({
  name: 'Demo',
  components: {
    demoLinks: components_demo_DemoLinks,
    demoListing: components_demo_DemoListing
  },
  methods: {
    handleScroll: function handleScroll(event) {},
    handleSelection: function handleSelection(index) {
      var scrollHeight = 0;
      var demoitems = document.getElementsByClassName('demo__item');
      for (var i = 0; i < demoitems.length; i++) {
        if (i < index) {
          scrollHeight += demoitems[i].clientHeight;
        }
      }
      document.getElementsByClassName('main-content__main')[0].scroll({
        top: scrollHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  computed: {
    getFormat: function getFormat() {
      var _this = this;

      if (!this.adFormat) {
        var id = this.$route.params.format_id;
        var ads = this.$store.getters['formats/unfiltered'];
        ads.find(function (ad) {
          if (ad.id == id) {
            _this.adFormat = ad;
          }
        });
      }
      return this.adFormat;
    }
  },
  data: function data() {
    return {
      adFormat: null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-015870c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo.vue
var Demo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('section',{staticClass:"main-content__full section"},[_c('header',{staticClass:"section__header"},[(_vm.getFormat)?_c('h1',{staticClass:"section__title"},[_vm._v(_vm._s(_vm.getFormat.name))]):_vm._e(),_vm._v(" "),_vm._m(0,false,false)])]),_vm._v(" "),_c('aside',{staticClass:"main-content__side demo__main--side section"},[_c('demo-links',{staticClass:"section__content categories",on:{"clicked":_vm.handleSelection}})],1),_vm._v(" "),_c('section',{staticClass:"main-content__main demo__main section",on:{"scroll":_vm.handleScroll}},[_c('demo-listing',{staticClass:"section__content",attrs:{"adformat":_vm.getFormat}})],1)])}
var Demo_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section__header__area"},[_c('p',{staticClass:"section__title"})])}]
var Demo_esExports = { render: Demo_render, staticRenderFns: Demo_staticRenderFns }
/* harmony default export */ var components_Demo = (Demo_esExports);
// CONCATENATED MODULE: ./src/components/Demo.vue
function Demo_injectStyle (ssrContext) {
  __webpack_require__("Hpkn")
}
var Demo_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Demo___vue_template_functional__ = false
/* styles */
var Demo___vue_styles__ = Demo_injectStyle
/* scopeId */
var Demo___vue_scopeId__ = "data-v-015870c9"
/* moduleIdentifier (server only) */
var Demo___vue_module_identifier__ = null
var Demo_Component = Demo_normalizeComponent(
  Demo,
  components_Demo,
  Demo___vue_template_functional__,
  Demo___vue_styles__,
  Demo___vue_scopeId__,
  Demo___vue_module_identifier__
)

/* harmony default export */ var src_components_Demo = (Demo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdminCategories.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AdminCategories = ({
  name: 'AdminCategories',
  methods: {
    createCategory: function createCategory() {
      this.creating = true;
      return null;
    },
    editCategory: function editCategory(item) {
      this.editId = item.id;
      this.name = item.name;
      this.description = item.description;
      this.formatslist = item.formats;
      this.editing = true;
      this.sort_id = item.sort;
      return null;
    },
    deleteCategory: function deleteCategory() {
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to delete the selected category?',
        buttonText: 'Delete Category',
        callback: function (params) {
          this.$store.dispatch('categories/delete', this.editId);
          this.cancelCategory();
        }.bind(this)
      });
    },
    saveCategory: function saveCategory() {
      var _this = this;

      var payload = {
        name: this.name,
        description: this.description,
        sort: this.sort_id
      };
      var cat = this;
      if (this.creating && !this.editing) {
        this.$store.dispatch('categories/create', { data: payload,
          callback: function callback(response) {
            cat.cancelCategory();
          } }, this.$snotify);
      } else if (this.editing && !this.creating) {
        this.$store.dispatch('categories/update', { id: this.editId, category: payload, callback: function callback(response) {
            cat.cancelCategory();
          } }, this.$snotify);

        if (this.formatsToDelete.length > 0) {
          this.formatsToDelete.forEach(function (id) {
            _this.categoryFormats.forEach(function (cf) {
              if (cf.category_id === _this.editId && cf.format_id === id) {
                cat.$store.dispatch('categories/formats/delete', cf.id);
              }
            });
          });
        }
        if (this.formatsToAdd.length > 0) {
          this.formatsToAdd.forEach(function (id) {
            cat.$store.dispatch('categories/formats/add', { category_id: _this.editId, format_id: id });
          });
        }
      }
    },
    cancelCategory: function cancelCategory() {
      this.name = '';
      this.description = '';
      this.sort_id = '';

      if (this.editing) {
        this.editing = false;
        this.formatsToAdd = [];
        this.formatsToDelete = [];
      } else if (this.creating) {
        this.creating = false;
      }
      return null;
    },
    addFormat: function addFormat() {
      var _this2 = this;

      var ad = this.adSearch;
      this.getFormats().forEach(function (format) {
        if (format.name === ad) {
          _this2.formatslist.unshift(format);
          _this2.formatsToAdd.push(format.id);
        }
      });
      this.adSearch = '';
      return null;
    },
    deleteFormat: function deleteFormat(id) {
      for (var i = 0; i < this.formatslist.length; i++) {
        if (this.formatslist[i].id === id) {
          this.formatslist.splice(i, 1);
          this.formatsToDelete.push(id);
        }
      }
    },
    getFormats: function getFormats() {
      return this.$store.getters['formats/formats'];
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('categories', ['categories']), Object(vuex_esm["b" /* mapState */])('categories/formats', ['categoryFormats']), {
    isSuperAdmin: function isSuperAdmin() {
      return this.$store.state.me.admin;
    },
    filterFormats: function filterFormats() {
      var rtnArray = [];
      var adsArray = [];
      this.formatslist.forEach(function (format) {
        adsArray.push(format.name);
      });
      this.getFormats().forEach(function (ad) {
        if (!(adsArray.indexOf(ad.name) > -1)) {
          rtnArray.push(ad);
        }
      });
      return rtnArray;
    }
  }),
  data: function data() {
    return {
      creating: false,
      name: '',
      description: '',
      editing: false,
      editId: 0,
      adSearch: '',
      formatslist: {},
      formatsToDelete: [],
      formatsToAdd: [],
      sort_id: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16cf8a7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminCategories.vue
var AdminCategories_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"admin__row"},[(!_vm.creating && !_vm.editing && _vm.isSuperAdmin)?_c('button',{staticClass:"admin__button--primary button button--primary",on:{"click":_vm.createCategory}},[_vm._v("Create Category +")]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"section__content form"},[(_vm.creating || _vm.editing)?_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(0,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input__field",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"input__field",attrs:{"type":"text"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(2,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sort_id),expression:"sort_id"}],staticClass:"input__field",attrs:{"type":"number"},domProps:{"value":(_vm.sort_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sort_id=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item"},[_vm._m(3,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adSearch),expression:"adSearch"}],staticClass:"input__field",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.adSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adSearch=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"admin__category__ul"}},_vm._l((_vm.filterFormats),function(format){return _c('div',[(format.name.toUpperCase().indexOf(_vm.adSearch.toUpperCase()) > -1 && format.name !== _vm.adSearch)?_c('a',{staticClass:"admin__li",attrs:{"href":"#"},on:{"click":function($event){_vm.adSearch = format.name}}},[_vm._v(_vm._s(format.name))]):_vm._e()])}))]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input"},[_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":_vm.addFormat}},[_vm._v("Add Format")])])]),_vm._v(" "),_vm._l((_vm.formatslist),function(ad){return _c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(ad.name))])]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('div',{staticClass:"admin__button button button--remove",on:{"click":function($event){_vm.deleteFormat(ad.id)}}},[_vm._v("Remove")])])])})],2):_vm._e(),_vm._v(" "),(_vm.editing || _vm.creating)?_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item--show-border"},[_c('a',{staticClass:"admin__button--primary section__footer__button button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveCategory($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('a',{staticClass:"admin__button section__footer__button section__footer__button--right button button--secondary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelCategory($event)}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.editing && _vm.isSuperAdmin )?_c('a',{staticClass:"admin__button section__footer__button section__footer__button--right button button--remove",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteCategory($event)}}},[_vm._v("Delete Category")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.editing && !_vm.creating)?_c('fieldset',{staticClass:"form__group"},[_c('h1',{staticClass:"admin__title"},[_vm._v("Categories ("+_vm._s(_vm.categories.length)+")")]),_vm._v(" "),_vm._l((_vm.categories),function(item){return _c('article',{staticClass:"admin__form form__item form__item--show-border",on:{"click":function($event){_vm.editCategory(item)}}},[_c('h2',[_vm._v(_vm._s(item.name))])])})],2):_vm._e()])])}
var AdminCategories_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Name of the Category")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("What should we call it?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Category Description")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("How do you describe it what does this category contain?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Category Sort Id")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is a number id that sorts the categories when they are displayed on the homepage list. The smaller the number the higher on the list it will appear.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Ads in Category")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Which ads are in this category?")])])}]
var AdminCategories_esExports = { render: AdminCategories_render, staticRenderFns: AdminCategories_staticRenderFns }
/* harmony default export */ var admin_AdminCategories = (AdminCategories_esExports);
// CONCATENATED MODULE: ./src/components/admin/AdminCategories.vue
function AdminCategories_injectStyle (ssrContext) {
  __webpack_require__("Oc4r")
}
var AdminCategories_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AdminCategories___vue_template_functional__ = false
/* styles */
var AdminCategories___vue_styles__ = AdminCategories_injectStyle
/* scopeId */
var AdminCategories___vue_scopeId__ = "data-v-16cf8a7e"
/* moduleIdentifier (server only) */
var AdminCategories___vue_module_identifier__ = null
var AdminCategories_Component = AdminCategories_normalizeComponent(
  AdminCategories,
  admin_AdminCategories,
  AdminCategories___vue_template_functional__,
  AdminCategories___vue_styles__,
  AdminCategories___vue_scopeId__,
  AdminCategories___vue_module_identifier__
)

/* harmony default export */ var components_admin_AdminCategories = (AdminCategories_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdminAccounts.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AdminAccounts = ({
  name: 'AdminAccounts',
  data: function data() {
    return {
      account: null,
      mockingId: undefined,
      accountSearch: '',
      charges: null,
      adSearch: '',
      formatslist: [],
      formatsToDelete: [],
      formatsToAdd: []
    };
  },
  beforeMount: function beforeMount() {
    if (localStorage.user_id) {
      this.mockingId = localStorage.user_id;
    }
  },

  methods: {
    searchMatch: function searchMatch(item) {
      var matches = this.accountSearch.match(/^id:\s*(\d+)/);
      if (matches) {
        return item.id.toString().indexOf(matches[1]) > -1;
      } else {
        return item.name.toUpperCase().indexOf(this.accountSearch.toUpperCase()) > -1;
      }
    },
    chargeDate: function chargeDate(date) {
      return this.unixToDate(date);
    },
    issueRefund: function issueRefund(id) {
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to issue a refund?',
        buttonText: 'Issue Refund',
        callback: function (params) {
          var _this = this;

          this.$store.dispatch('accounts/issueRefund', { account_id: this.account.id, charge_id: id, callback: function callback() {
              _this.charges = _this.$store.getters['accounts/charges'].data;
            } }, this.$snotify);
        }.bind(this)
      });
    },
    cancelViewUsers: function cancelViewUsers() {
      this.account = null;
      this.charges = null;
    },
    viewUsers: function viewUsers(id) {
      var _this2 = this;

      var allAccounts = this.accounts;
      allAccounts.forEach(function (acc) {
        if (acc.id === id) {
          _this2.account = acc;
        }
      });
      this.$store.dispatch('accounts/formats/loadCustom', { id: this.account.id }).then(function (formats) {
        _this2.formatslist = formats;
        _this2.$store.dispatch('accounts/loadCharges', { accountId: _this2.account.id,
          callback: function callback() {
            _this2.charges = _this2.$store.getters['accounts/charges'].data;
          } }, _this2.$snotify);
      });
    },
    becomeUser: function becomeUser(id) {
      localStorage.user_id = id;
      this.mockingId = id;
      this.$store.dispatch('reloadMe');
    },
    getRefundStatus: function getRefundStatus(status) {
      if (status) {
        return 'Refunded';
      } else {
        return 'Paid';
      }
    },
    addFormat: function addFormat() {
      var _this3 = this;

      var ad = this.adSearch;
      this.allFormats.forEach(function (format) {
        if (format.name === ad) {
          _this3.formatslist.push(format);
          _this3.$store.dispatch('accounts/formats/add', { format_id: format.id, account_id: _this3.account.id });
          _this3.adSearch = '';
        }
      });
    },
    deleteFormat: function deleteFormat(id) {
      for (var i = 0; i < this.formatslist.length; i++) {
        if (this.formatslist[i].id === id) {
          this.formatslist.splice(i, 1);
          this.$store.dispatch('accounts/formats/delete', { id: id });
        }
      }
    },
    updateAccountTier: function updateAccountTier() {
      this.$store.dispatch('accounts/update', { id: this.account.id, plan_id: this.account.plan_id });
    },
    updateCCRight: function updateCCRight() {
      this.$store.dispatch('accounts/update', { id: this.account.id, cc_image_rights: !this.account.cc_image_rights });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('formats', {
    allFormats: 'allFormats'
  }), Object(vuex_esm["b" /* mapState */])('accounts', {
    accounts: 'all'
  }), {
    getCharges: function getCharges() {
      return this.$store.getters['accounts/charges'].data;
    },
    getFilteredFormats: function getFilteredFormats() {
      var rtnArray = [];
      var adsArray = [];
      this.formatslist.forEach(function (format) {
        adsArray.push(format.name);
      });
      if (!this.allFormats) return;
      this.allFormats.forEach(function (ad) {
        if (!(adsArray.indexOf(ad.name) > -1)) {
          rtnArray.push(ad);
        }
      });
      return rtnArray;
    }
  }),
  watch: {
    getCharges: function getCharges(newVal) {
      if (newVal) {
        this.charges = newVal;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dddce440","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminAccounts.vue
var AdminAccounts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"section__content form"},[_c('h1',{staticClass:"admin__title"},[_vm._v("Accounts ("+_vm._s(_vm.accounts.length)+")")]),_vm._v(" "),(!_vm.account)?_c('fieldset',{staticClass:"form__group"},[_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accountSearch),expression:"accountSearch"}],staticClass:"input__field",attrs:{"placeholder":"Search for an account by name... (Prefix Search with id: to search by id)","type":"text"},domProps:{"value":(_vm.accountSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.accountSearch=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.accounts),function(item){return (_vm.searchMatch(item))?_c('article',{staticClass:"admin__form form__item form__item--show-border",on:{"click":function($event){_vm.viewUsers(item.id)}}},[_c('h2',[_vm._v("("+_vm._s(item.id)+") "+_vm._s(item.name))])]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.account)?_c('fieldset',{staticClass:"form__group"},[_c('div',{staticClass:"admin__userstitle admin__row"},[_c('button',{staticClass:"admin__usersback admin__button button button--secondary",on:{"click":_vm.cancelViewUsers}},[_vm._v("Back")]),_vm._v(" "),(_vm.account)?_c('h2',{staticClass:"admin__subtitle"},[_vm._v("Users of: "),_c('i',[_vm._v(_vm._s(_vm.account.name))])]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"admin__subtitle"},[_vm._v("Number of Users: "),_c('i',[_vm._v(_vm._s(_vm.account.account_users.length))])]),_vm._v(" "),(_vm.account.plan)?_c('h2',{staticClass:"admin__subtitle"},[_vm._v("Plan Type: "),_c('i',[_vm._v(_vm._s(_vm.account.plan.name))])]):_vm._e(),_vm._v(" "),(_vm.account.referred_by_code)?_c('h2',{staticClass:"admin__subtitle"},[_vm._v("Partner Referral: "),_c('i',[_vm._v(_vm._s(_vm.account.referred_by_code))])]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.account.account_users),function(user){return _c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(user.user.name))])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(user.user.email))])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(user.permissions))])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[(user.user_id != _vm.mockingId)?_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":function($event){_vm.becomeUser(user.user_id)}}},[_vm._v("Control User")]):_vm._e()])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('article',{staticClass:"form__item form__item"},[_vm._m(0,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adSearch),expression:"adSearch"}],staticClass:"input__field",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.adSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adSearch=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"admin__category__ul"}},_vm._l((_vm.getFilteredFormats),function(format){return _c('div',[(format.name.toUpperCase().indexOf(_vm.adSearch.toUpperCase()) > -1 && format.name !== _vm.adSearch)?_c('a',{staticClass:"admin__li",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.adSearch = format.name}}},[_vm._v(_vm._s(format.name))]):_vm._e()])}))]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input"},[_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":function($event){$event.preventDefault();_vm.addFormat($event)}}},[_vm._v("Add Format")])])]),_vm._v(" "),_vm._l((_vm.formatslist),function(format){return _c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(format.name))])]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('div',{staticClass:"admin__button button button--remove",on:{"click":function($event){$event.preventDefault();_vm.deleteFormat(format.id)}}},[_vm._v("Remove")])])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('article',{staticClass:"form__item form__item"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_vm._v("\n          "+_vm._s(_vm.account.cc_image_rights ? "Enabled" : "Disabled")+"\n        ")]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input"},[_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":function($event){$event.preventDefault();_vm.updateCCRight($event)}}},[_vm._v("Toggle CC Rights")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('article',{staticClass:"form__item form__item"},[_vm._m(2,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.plan_id),expression:"account.plan_id"}],staticClass:"admin__input input__field form__item__input input",attrs:{"type":"text"},domProps:{"value":(_vm.account.plan_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "plan_id", $event.target.value)}}}),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input"},[_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":function($event){$event.preventDefault();_vm.updateAccountTier($event)}}},[_vm._v("Update")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h1',{staticClass:"admin__title--smaller"},[_vm._v("Previous Transactions")]),_vm._v(" "),_vm._l((_vm.getCharges),function(transaction){return _c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(_vm.chargeDate(transaction.created)))])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("$"+_vm._s((transaction.amount / 100)))])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(_vm.getRefundStatus(transaction.refunded)))])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[(!transaction.refunded)?_c('div',{staticClass:"admin__button button button--tertiary",on:{"click":function($event){_vm.issueRefund(transaction.id)}}},[_vm._v("Issue Refund")]):_vm._e()])])})],2):_vm._e()])])}
var AdminAccounts_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Custom Ad Formats")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Which custom ads are available to this account?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("CC Image Rights")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Should this account only be able to fetch images with creative commons rights from our google search?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Current Plan")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("The current plan id. (WARNING Be careful when using as it ONLY CHANGES PLAN_ID and NO PAYMENT OPTIONS)")])])}]
var AdminAccounts_esExports = { render: AdminAccounts_render, staticRenderFns: AdminAccounts_staticRenderFns }
/* harmony default export */ var admin_AdminAccounts = (AdminAccounts_esExports);
// CONCATENATED MODULE: ./src/components/admin/AdminAccounts.vue
function AdminAccounts_injectStyle (ssrContext) {
  __webpack_require__("iwTE")
}
var AdminAccounts_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AdminAccounts___vue_template_functional__ = false
/* styles */
var AdminAccounts___vue_styles__ = AdminAccounts_injectStyle
/* scopeId */
var AdminAccounts___vue_scopeId__ = "data-v-dddce440"
/* moduleIdentifier (server only) */
var AdminAccounts___vue_module_identifier__ = null
var AdminAccounts_Component = AdminAccounts_normalizeComponent(
  AdminAccounts,
  admin_AdminAccounts,
  AdminAccounts___vue_template_functional__,
  AdminAccounts___vue_styles__,
  AdminAccounts___vue_scopeId__,
  AdminAccounts___vue_module_identifier__
)

/* harmony default export */ var components_admin_AdminAccounts = (AdminAccounts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdminFormats.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var AdminFormats = ({
  name: 'AdminFormats',
  components: {
    'rich-text': components_common_RichText,
    ImageUpload: components_common_ImageUpload,
    SeriesBadge: SeriesBadge["a" /* default */]
  },
  data: function data() {
    return {
      formats: [],
      currentFormat: null,
      mediaKit: '',
      designerInfo: '',
      name: '',
      description: '',
      visible: null,
      premium: null,
      preview_image: null,
      sort: null,
      filter: ''
    };
  },

  methods: {
    deleteFormat: function deleteFormat() {
      this.$modal.show('warning', {
        messageText: 'Are you sure you want to delete the selected format?? BE CAREFUL HERE!!!!!',
        buttonText: 'Delete Format',
        callback: function (params) {
          this.$store.dispatch('formats/delete', this.currentFormat.id);
          this.cancelEditDemoPage();
        }.bind(this)
      });
    },
    isVisible: function isVisible(visible) {
      if (visible) {
        return 'Visible';
      } else {
        return 'Not Visible';
      }
    },
    isPremium: function isPremium(premium) {
      if (premium) {
        return 'Premium';
      } else {
        return 'Normal';
      }
    },
    editDemoPage: function editDemoPage(format) {
      this.currentFormat = format;
      this.mediaKit = format.media_kit;
      this.designerInfo = format.designer_info;
      this.name = format.name;
      this.description = format.description;
      this.visible = format.visible;
      this.premium = format.premium;
      this.preview_image = { sizes: {}, url: format.preview_image };
      this.sort = format.sort;
    },
    cancelEditDemoPage: function cancelEditDemoPage() {
      this.currentFormat = null;
      this.mediaKit = '';
      this.designerInfo = '';
      this.name = '';
      this.description = '';
      this.visible = null;
      this.premium = null;
      this.preview_image = null;
      this.sort = null;
    },
    saveDemoData: function saveDemoData() {
      var demo = this;
      var previewImg = void 0;
      if (this.preview_image.sizes[800]) {
        previewImg = this.preview_image.sizes[800].url;
      } else if (this.preview_image) {
        previewImg = this.preview_image;
      } else {
        previewImg = null;
      }
      var payload = {
        media_kit: this.mediaKit,
        designer_info: this.designerInfo,
        name: this.name,
        description: this.description,
        visible: this.visible,
        premium: this.premium,
        preview_image: previewImg,
        sort: this.sort
      };
      this.$store.dispatch('formats/update', { id: this.currentFormat.id, payload: payload, callback: function callback(response) {
          demo.cancelEditDemoPage();
        } }, this.$snotify);
    },
    refreshAd: function refreshAd(formatId) {
      this.$store.dispatch('advertisements/regenerate', formatId);
    },
    updateMediaKit: function updateMediaKit(newVal) {
      this.mediaKit = newVal;
    },
    updateDesignerInfo: function updateDesignerInfo(newVal) {
      this.designerInfo = newVal;
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('formats', ['allFormats']), {
    filterAllFormats: function filterAllFormats(filter) {
      var _this = this;

      return this.allFormats.filter(function (format) {
        return format.name.toLowerCase().indexOf(_this.filter.toLowerCase()) > -1;
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    if (this.$route.query.id) {
      var format = void 0;
      Object(calls["J" /* getAllFormats */])().then(function (formats) {
        format = formats.filter(function (format) {
          return format.id == _this2.$route.query.id;
        });
        _this2.editDemoPage(format[0]);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e86b8218","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminFormats.vue
var AdminFormats_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"section__content form"},[_c('h1',{staticClass:"admin__title"},[_vm._v("Formats ("+_vm._s(_vm.allFormats.length)+")")]),_vm._v(" "),(!_vm.currentFormat)?_c('fieldset',{staticClass:"form__group"},[_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"input__field",attrs:{"placeholder":"Search for ad formats here...","type":"text"},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.filterAllFormats),function(ad,index){return _c('article',{key:index,staticClass:"form__category form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_c('strong',[_vm._v(_vm._s(ad.name))])])]),_vm._v(" "),_c('label',{attrs:{"for":"form__item__label"}},[_c('SeriesBadge',{attrs:{"series":ad.series,"box":true}})],1),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name form__item__series-right"},[_vm._v(_vm._s(_vm.isVisible(ad.visible)))])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(_vm.isPremium(ad.premium)))])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('div',{staticClass:"button button--secondary",on:{"click":function($event){_vm.editDemoPage(ad)}}},[_vm._v("Edit Format")])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":function($event){_vm.refreshAd(ad.id)}}},[_vm._v("Refresh Ad Code")])])])})],2):_vm._e(),_vm._v(" "),(_vm.currentFormat)?_c('fieldset',{staticClass:"form__group"},[_c('h2',[_vm._v(_vm._s(_vm.currentFormat.name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border series-container"},[_vm._m(0,false,false),_vm._v(" "),_c('SeriesBadge',{attrs:{"series":_vm.currentFormat.series,"box":true}}),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input__field",attrs:{"type":"text","defaultValue":_vm.name},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])],1),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"input__field",attrs:{"type":"text","defaultValue":_vm.description},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(2,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(_vm.isVisible(_vm.visible)))])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[(!_vm.visible)?_c('div',{staticClass:"button button--primary",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v("Make Visible")]):_vm._e(),_vm._v(" "),(_vm.visible)?_c('div',{staticClass:"button button--remove",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._v("Make Invisible")]):_vm._e()])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(3,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(_vm.isPremium(_vm.premium)))])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[(!_vm.premium)?_c('div',{staticClass:"button button--primary",on:{"click":function($event){_vm.premium = !_vm.premium}}},[_vm._v("Make Premium Format")]):_vm._e(),_vm._v(" "),(_vm.premium)?_c('div',{staticClass:"button button--remove",on:{"click":function($event){_vm.premium = !_vm.premium}}},[_vm._v("Make Regular Format")]):_vm._e()])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(4,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sort),expression:"sort"}],staticClass:"input__field",attrs:{"type":"number"},domProps:{"value":(_vm.sort)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sort=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(5,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('rich-text',{attrs:{"id":'mediaKit',"defaultValue":_vm.mediaKit},on:{"input":_vm.updateMediaKit}})],1)]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(6,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('rich-text',{attrs:{"id":'designerInfo',"defaultValue":_vm.designerInfo},on:{"input":_vm.updateDesignerInfo}})],1)]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(7,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('image-upload',{attrs:{"id":'formatPreviewImage',"defaultValue":_vm.preview_image},model:{value:(_vm.preview_image),callback:function ($$v) {_vm.preview_image=$$v},expression:"preview_image"}})],1)]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_c('a',{staticClass:"section__footer__button admin__button--primary button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveDemoData($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('a',{staticClass:"section__footer__button section__footer__button--right button button--secondary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelEditDemoPage($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('a',{staticClass:"admin__button section__footer__button section__footer__button--right button button--remove",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteFormat($event)}}},[_vm._v("Delete Format")])])]):_vm._e()])])}
var AdminFormats_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label series-left"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Name")]),_vm._v(" "),_c('small',{staticClass:"form__item__name"},[_vm._v("This is the ad name that will overwrite the name from Broadstreet.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Description")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is the ad description that will overwrite the description from Broadstreet.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Visibility")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is the ad visibility that will toggle whether the ad can be seen by ParkAve users or not.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Premium Ad Format?")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is the premium ad status that will toggle whether the ad is a premium format that can be used by only Pro users and above.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Category Sort Id")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is a number id that sorts the categories when they are displayed on the homepage list. The smaller the number the higher on the list it will appear.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Media Kit")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Paste in the HTML code or type out the text that will make up the Media Kit for the Demo Page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Design Details")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Paste in the HTML code or type out the text that will make up the Design Details for the Demo Page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Preview Image")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Here you can override the preview image of the format.")])])}]
var AdminFormats_esExports = { render: AdminFormats_render, staticRenderFns: AdminFormats_staticRenderFns }
/* harmony default export */ var admin_AdminFormats = (AdminFormats_esExports);
// CONCATENATED MODULE: ./src/components/admin/AdminFormats.vue
function AdminFormats_injectStyle (ssrContext) {
  __webpack_require__("/Sy6")
}
var AdminFormats_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AdminFormats___vue_template_functional__ = false
/* styles */
var AdminFormats___vue_styles__ = AdminFormats_injectStyle
/* scopeId */
var AdminFormats___vue_scopeId__ = "data-v-e86b8218"
/* moduleIdentifier (server only) */
var AdminFormats___vue_module_identifier__ = null
var AdminFormats_Component = AdminFormats_normalizeComponent(
  AdminFormats,
  admin_AdminFormats,
  AdminFormats___vue_template_functional__,
  AdminFormats___vue_styles__,
  AdminFormats___vue_scopeId__,
  AdminFormats___vue_module_identifier__
)

/* harmony default export */ var components_admin_AdminFormats = (AdminFormats_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdminCoupons.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var AdminCoupons = ({
  name: 'AdminCoupons',
  components: {
    SelectInput: components_configurator_SelectInput,
    Boolean: components_configurator_Boolean
  },
  data: function data() {
    return {
      currentCoupon: null,
      creating: false,
      name: null,
      description: null,
      expiration_date: null,
      single_use: null,
      plan_id: null,
      amount_discounted: null
    };
  },

  methods: {
    createCoupon: function createCoupon() {
      this.creating = true;
    },
    setSingleUse: function setSingleUse(val) {
      if (this.currentCoupon) {
        this.single_use = val;
        if (!val) {
          this.used = false;
        } else {
          this.used = this.currentCoupon.used;
        }
      }
    },
    editCouponPage: function editCouponPage(coupon) {
      this.currentCoupon = coupon;
      this.name = coupon.name;
      this.description = coupon.description;
      this.expiration_date = coupon.expiration_date;
      this.single_use = coupon.single_use;
      this.plan_id = coupon.plan_id;
      this.amount_discounted = coupon.amount_discounted;
      this.used = coupon.used;
    },
    cancelSaveCoupon: function cancelSaveCoupon() {
      this.creating = false;
      this.currentCoupon = null;
      this.name = null;
      this.description = null;
      this.expiration_date = null;
      this.single_use = null;
      this.plan_id = null;
      this.amount_discounted = null;
    },
    getExpirationDate: function getExpirationDate(date) {
      if (new Date(date).getTime() < new Date().getTime()) {
        return 'Expired';
      }
      return date;
    },
    deleteCoupon: function deleteCoupon() {
      if (this.currentCoupon) {
        this.$store.dispatch('coupons/delete', this.currentCoupon.id);
      }
      this.cancelSaveCoupon();
    },
    saveCoupon: function saveCoupon() {
      var payload = {
        name: this.name,
        description: this.description,
        expiration_date: this.expiration_date,
        single_use: this.single_use,
        plan_id: this.plan_id,
        amount_discounted: this.amount_discounted,
        used: this.used
      };
      if (this.creating) {
        this.$store.dispatch('coupons/create', payload);
      } else {
        this.$store.dispatch('coupons/update', { id: this.currentCoupon.id, payload: payload });
      }
      this.cancelSaveCoupon();
    },
    deliverCoupon: function deliverCoupon(id) {
      this.$modal.show('userinput', {
        modalTitle: 'Deliver Coupon',
        messageText: 'Enter the email of the user you want to deliver this coupon to:',
        fieldType: 'email',
        fieldPlaceholder: 'example@parkave.com',
        buttonText: 'Deliver Coupon',
        callback: function callback(value) {
          this.$modal.hide('userinput');
          this.$store.dispatch('coupons/deliver', { id: id, email: value });
        }
      });
    },
    setPlanId: function setPlanId(value) {
      this.plan_id = value;
    },
    onCopy: function onCopy() {
      var rootVM = window.rootVM;
      rootVM.$snotify.success('Copied');
    },
    onError: function onError(e) {},
    generateCouponLink: function generateCouponLink(coupon) {
      return location.origin + '/?coupon=' + coupon.token;
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('coupons', ['coupons']), Object(vuex_esm["b" /* mapState */])(['plans']), Object(vuex_esm["b" /* mapState */])('accounts', {
    accounts: 'all'
  }), {
    planOptions: function planOptions() {
      var arry = [];
      if (this.plans.length) {
        this.plans.forEach(function (plan) {
          arry.push({ label: plan.name + ' ($' + plan.price / 100 + ')', value: plan.id });
        });
      }
      return arry;
    },
    getUsedString: function getUsedString() {
      if (this.currentCoupon) {
        if (this.currentCoupon.used) {
          return 'Used';
        } else {
          return 'Not Used';
        }
      }
    },
    accountsInCoupon: function accountsInCoupon() {
      var _this = this;

      if (!this.creating) {
        if (this.accounts[0] && this.accounts[0].id) {
          return this.accounts.filter(function (acct) {
            return acct.coupon_id == _this.currentCoupon.id;
          });
        }
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2716fd0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminCoupons.vue
var AdminCoupons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"admin__row"},[(!_vm.currentCoupon && !_vm.creating)?_c('button',{staticClass:"admin__button--primary button button--primary",on:{"click":_vm.createCoupon}},[_vm._v("Create Coupon +")]):_vm._e()]),_vm._v(" "),_c('h1',{staticClass:"admin__title"},[_vm._v("Coupons ("+_vm._s(_vm.coupons.length)+")")]),_vm._v(" "),_c('form',{staticClass:"section__content form"},[(_vm.currentCoupon || _vm.creating)?_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(0,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input__field",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"input__field",attrs:{"type":"text"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(2,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expiration_date),expression:"expiration_date"}],staticClass:"input__field",attrs:{"type":"date"},domProps:{"value":(_vm.expiration_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.expiration_date=$event.target.value}}})])]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(3,false,false),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(_vm.getUsedString))]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Was this coupon used already?")])]),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input input__boolean"},[_c('boolean',{attrs:{"defaultValue":_vm.single_use,"id":0},on:{"input":_vm.setSingleUse}})],1)]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(4,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('select-input',{staticStyle:{"padding":"0","height":"100px"},attrs:{"defaultValue":_vm.plan_id,"options":_vm.planOptions},on:{"input":_vm.setPlanId}})],1)]),_vm._v(" "),_c('article',{staticClass:"form__item form__item--show-border"},[_vm._m(5,false,false),_vm._v(" "),_c('section',{staticClass:"admin__input form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount_discounted),expression:"amount_discounted"}],staticClass:"input__field",attrs:{"type":"number"},domProps:{"value":(_vm.amount_discounted)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount_discounted=$event.target.value}}})])]),_vm._v(" "),(!_vm.creating)?_c('h4',{staticClass:"window__title"},[_vm._v("Active Accounts Using this Coupon ("+_vm._s(_vm.accountsInCoupon ? _vm.accountsInCoupon.length : '')+")")]):_vm._e(),_vm._v(" "),_vm._l((_vm.accountsInCoupon),function(account){return (!_vm.creating)?_c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(account.name))])])]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.currentCoupon || _vm.creating)?_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item form__item--show-border"},[_c('a',{staticClass:"admin__button--primary section__footer__button button button--primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveCoupon($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('a',{staticClass:"admin__button section__footer__button section__footer__button--right button button--secondary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelSaveCoupon($event)}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.creating && _vm.currentCoupon)?_c('a',{staticClass:"admin__button section__footer__button section__footer__button--right button button--remove",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteCoupon($event)}}},[_vm._v("Delete Coupon")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.currentCoupon && !_vm.creating)?_c('fieldset',{staticClass:"form__group"},_vm._l((_vm.coupons),function(coupon){return _c('article',{staticClass:"form__category form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_c('strong',[_vm._v(_vm._s(coupon.name))])])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Expires: "+_vm._s(_vm.getExpirationDate(coupon.expiration_date)))])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('p',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.generateCouponLink(coupon)),expression:"generateCouponLink(coupon)",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"export__link link link--small"},[_vm._v("Copy Link to Clipboard")])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('div',{staticClass:"button button--secondary",on:{"click":function($event){_vm.editCouponPage(coupon)}}},[_vm._v("Edit Coupon")])]),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('div',{staticClass:"admin__button--primary button button--primary",on:{"click":function($event){_vm.deliverCoupon(coupon.id)}}},[_vm._v("Deliver Coupon")])])])})):_vm._e()])])}
var AdminCoupons_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Name of the Coupon")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("What should we call it?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Coupon Description")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("How do you describe it what does this coupon do?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Coupon Expiration Date")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is the expiration date of the coupon. After this date the coupon will no longer be able to be used.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Single Use?")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("Can this coupon only be used by one user one time?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Plan Selection")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is the plan that the coupon must be used with.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Amount Discounted")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is a number of the amount of money to be taken off of the price enter in US dollars.")])])}]
var AdminCoupons_esExports = { render: AdminCoupons_render, staticRenderFns: AdminCoupons_staticRenderFns }
/* harmony default export */ var admin_AdminCoupons = (AdminCoupons_esExports);
// CONCATENATED MODULE: ./src/components/admin/AdminCoupons.vue
function AdminCoupons_injectStyle (ssrContext) {
  __webpack_require__("znRp")
}
var AdminCoupons_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AdminCoupons___vue_template_functional__ = false
/* styles */
var AdminCoupons___vue_styles__ = AdminCoupons_injectStyle
/* scopeId */
var AdminCoupons___vue_scopeId__ = "data-v-2716fd0c"
/* moduleIdentifier (server only) */
var AdminCoupons___vue_module_identifier__ = null
var AdminCoupons_Component = AdminCoupons_normalizeComponent(
  AdminCoupons,
  admin_AdminCoupons,
  AdminCoupons___vue_template_functional__,
  AdminCoupons___vue_styles__,
  AdminCoupons___vue_scopeId__,
  AdminCoupons___vue_module_identifier__
)

/* harmony default export */ var components_admin_AdminCoupons = (AdminCoupons_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdminUsers.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AdminUsers = ({
  name: 'AdminUsers',
  components: {
    Boolean: components_configurator_Boolean
  },
  data: function data() {
    return {
      userSearch: ''
    };
  },

  methods: {
    searchMatch: function searchMatch(item) {
      return item.email.toUpperCase().indexOf(this.userSearch.toUpperCase()) > -1 || item.name.toUpperCase().indexOf(this.userSearch.toUpperCase()) > -1;
    },
    toggleFormatAdmin: function toggleFormatAdmin(user_id, value) {
      this.$store.dispatch('users/update', { userId: user_id, payload: { format_admin: value } });
    },
    toggleAdmin: function toggleAdmin(user_id, value) {
      if (user_id == this.me.id) return;
      this.$store.dispatch('users/update', { userId: user_id, payload: { admin: value } });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('users', { users: 'all' }), Object(vuex_esm["b" /* mapState */])(['me']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddaed672","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminUsers.vue
var AdminUsers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"section__content form"},[_c('h1',{staticClass:"admin__title"},[_vm._v("Users ("+_vm._s(_vm.users.length)+")")]),_vm._v(" "),_c('fieldset',{staticClass:"form__group"},[_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userSearch),expression:"userSearch"}],staticClass:"input__field",attrs:{"placeholder":"Search for a user by name or email...)","type":"text"},domProps:{"value":(_vm.userSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userSearch=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.users),function(item){return (_vm.searchMatch(item))?_c('article',{staticClass:"form__item form__item--show-border"},[_c('label',{staticClass:"form__item__label"},[_c('h2',{staticClass:"form__item__name"},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.id == _vm.me.id ? "(You)" : ""))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(item.email))])]),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('small',[_vm._v("Admin?")]),_vm._v(" "),_c('boolean',{attrs:{"defaultValue":item.admin,"id":(item.id + '_admin')},on:{"input":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.toggleAdmin.apply(void 0, [ item.id ].concat( argsArray ))}}})],1),_vm._v(" "),_c('label',{staticClass:"form__item__label"},[_c('small',[_vm._v("Format Admin?")]),_vm._v(" "),_c('boolean',{attrs:{"defaultValue":item.format_admin,"id":(item.id + '_format_admin')},on:{"input":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.toggleFormatAdmin.apply(void 0, [ item.id ].concat( argsArray ))}}})],1)]):_vm._e()})],2)])])}
var AdminUsers_staticRenderFns = []
var AdminUsers_esExports = { render: AdminUsers_render, staticRenderFns: AdminUsers_staticRenderFns }
/* harmony default export */ var admin_AdminUsers = (AdminUsers_esExports);
// CONCATENATED MODULE: ./src/components/admin/AdminUsers.vue
function AdminUsers_injectStyle (ssrContext) {
  __webpack_require__("MIgk")
}
var AdminUsers_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AdminUsers___vue_template_functional__ = false
/* styles */
var AdminUsers___vue_styles__ = AdminUsers_injectStyle
/* scopeId */
var AdminUsers___vue_scopeId__ = "data-v-ddaed672"
/* moduleIdentifier (server only) */
var AdminUsers___vue_module_identifier__ = null
var AdminUsers_Component = AdminUsers_normalizeComponent(
  AdminUsers,
  admin_AdminUsers,
  AdminUsers___vue_template_functional__,
  AdminUsers___vue_styles__,
  AdminUsers___vue_scopeId__,
  AdminUsers___vue_module_identifier__
)

/* harmony default export */ var components_admin_AdminUsers = (AdminUsers_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Administrator.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Administrator = ({
  name: 'Administrator',
  components: {
    'admin-categories': components_admin_AdminCategories,
    'admin-accounts': components_admin_AdminAccounts,
    'admin-formats': components_admin_AdminFormats,
    'admin-coupons': components_admin_AdminCoupons,
    'admin-users': components_admin_AdminUsers
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    src_store.dispatch('loadMe').then(function () {
      if (src_store.state.me.admin || src_store.state.me.format_admin) {
        next();
      } else {
        next(from.fullPath);
      }
    }).catch(function () {
      next({ name: 'Home', query: { redirect_to: from.fullPath } });
    });
  },
  mounted: function mounted() {
    if (this.$route.hash.slice(1)) {
      this.current = 'admin-' + this.$route.hash.slice(1);
    }

    this.$store.dispatch('formats/loadAll');
    this.$store.dispatch('coupons/load');
    this.me = this.$store.state.me;
    if (this.me.admin) {
      this.$store.dispatch('accounts/loadAll');
      this.$store.dispatch('users/loadAll');
    }
  },
  data: function data() {
    return {
      current: 'admin-categories',
      me: {}
    };
  },

  computed: {
    currentDisplay: function currentDisplay() {
      return this.current;
    }
  },
  methods: {
    checkCurrent: function checkCurrent(tab) {
      if (this.current === tab) {
        location.reload();
      } else {
        this.current = tab;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13badfb1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrator.vue
var Administrator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('nav',{staticClass:"tabs"},[(_vm.me.admin || _vm.me.format_admin)?_c('router-link',{staticClass:"tabs__tab tab",class:{'tab--active': _vm.currentDisplay === 'admin-categories'},attrs:{"to":"#categories"},nativeOn:{"click":function($event){_vm.checkCurrent('admin-categories')}}},[_vm._v("Categories")]):_vm._e(),_vm._v(" "),(_vm.me.admin)?_c('router-link',{staticClass:"tabs__tab tab",class:{'tab--active': _vm.currentDisplay === 'admin-accounts'},attrs:{"to":"#accounts"},nativeOn:{"click":function($event){_vm.checkCurrent('admin-accounts')}}},[_vm._v("Accounts")]):_vm._e(),_vm._v(" "),(_vm.me.admin || _vm.me.format_admin)?_c('router-link',{staticClass:"tabs__tab tab",class:{'tab--active': _vm.currentDisplay === 'admin-formats'},attrs:{"to":"#formats"},nativeOn:{"click":function($event){_vm.checkCurrent('admin-formats')}}},[_vm._v("Formats")]):_vm._e(),_vm._v(" "),(_vm.me.admin)?_c('router-link',{staticClass:"tabs__tab tab",class:{'tab--active': _vm.currentDisplay === 'admin-coupons'},attrs:{"to":"#coupons"},nativeOn:{"click":function($event){_vm.checkCurrent('admin-coupons')}}},[_vm._v("Coupons")]):_vm._e(),_vm._v(" "),(_vm.me.admin)?_c('router-link',{staticClass:"tabs__tab tab",class:{'tab--active': _vm.currentDisplay === 'admin-users'},attrs:{"to":"#users"},nativeOn:{"click":function($event){_vm.checkCurrent('admin-users')}}},[_vm._v("Users")]):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"main-content main-content--white-background"},[_c('section',{staticClass:"main-content__full section"},[_c(_vm.currentDisplay,{tag:"component"})],1)])])}
var Administrator_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h1',{staticClass:"header__title"},[_vm._v("ParkAve Administrator Controls")]),_vm._v(" "),_c('section',{staticClass:"header__area"})])}]
var Administrator_esExports = { render: Administrator_render, staticRenderFns: Administrator_staticRenderFns }
/* harmony default export */ var components_Administrator = (Administrator_esExports);
// CONCATENATED MODULE: ./src/components/Administrator.vue
function Administrator_injectStyle (ssrContext) {
  __webpack_require__("bxs2")
}
var Administrator_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Administrator___vue_template_functional__ = false
/* styles */
var Administrator___vue_styles__ = Administrator_injectStyle
/* scopeId */
var Administrator___vue_scopeId__ = "data-v-13badfb1"
/* moduleIdentifier (server only) */
var Administrator___vue_module_identifier__ = null
var Administrator_Component = Administrator_normalizeComponent(
  Administrator,
  components_Administrator,
  Administrator___vue_template_functional__,
  Administrator___vue_styles__,
  Administrator___vue_scopeId__,
  Administrator___vue_module_identifier__
)

/* harmony default export */ var src_components_Administrator = (Administrator_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EnterpriseForm.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var EnterpriseForm = ({
  name: 'EnterpriseForm',
  mounted: function mounted() {
    var formScript = document.createElement('script');
    formScript.setAttribute('src', '//js.hsforms.net/forms/shell.js');
    formScript.setAttribute('charset', 'utf-8');
    formScript.setAttribute('type', 'text/javascript');
    document.getElementById('enterprise__form').appendChild(formScript);
    setTimeout(function () {
      var formScript2 = document.createElement('script');
      formScript2.innerHTML = 'hbspt.forms.create({\n' + '        portalId: "2898305",\n' + '        formId: "a8e9721b-9b62-4eca-8201-ecf6fc059acd"\n' + '      });';
      document.getElementById('enterprise__form').appendChild(formScript2);
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33484176","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnterpriseForm.vue
var EnterpriseForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var EnterpriseForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"enterprise__image",attrs:{"src":"/static/images/logo-parkave-black.svg","alt":"ParkAve"}}),_vm._v(" "),_c('div',{staticClass:"enterprise__title"},[_vm._v("Account Quote Form")]),_vm._v(" "),_c('div',{attrs:{"id":"enterprise__form"}})])}]
var EnterpriseForm_esExports = { render: EnterpriseForm_render, staticRenderFns: EnterpriseForm_staticRenderFns }
/* harmony default export */ var components_EnterpriseForm = (EnterpriseForm_esExports);
// CONCATENATED MODULE: ./src/components/EnterpriseForm.vue
function EnterpriseForm_injectStyle (ssrContext) {
  __webpack_require__("89J7")
}
var EnterpriseForm_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EnterpriseForm___vue_template_functional__ = false
/* styles */
var EnterpriseForm___vue_styles__ = EnterpriseForm_injectStyle
/* scopeId */
var EnterpriseForm___vue_scopeId__ = "data-v-33484176"
/* moduleIdentifier (server only) */
var EnterpriseForm___vue_module_identifier__ = null
var EnterpriseForm_Component = EnterpriseForm_normalizeComponent(
  EnterpriseForm,
  components_EnterpriseForm,
  EnterpriseForm___vue_template_functional__,
  EnterpriseForm___vue_styles__,
  EnterpriseForm___vue_scopeId__,
  EnterpriseForm___vue_module_identifier__
)

/* harmony default export */ var src_components_EnterpriseForm = (EnterpriseForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ClientPreview.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ClientPreview = ({
  name: 'ClientPreview',
  data: function data() {
    return {
      placement_id: '',
      format: {},
      format_id: 0
    };
  },

  components: {
    PreviewSettings: PreviewSettings["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    var s = document.createElement('script');
    s.src = 'https://cdn.getparkave.com/go-sell.js';
    document.body.insertBefore(s, document.body.firstChild);

    if (this.$route.query) {
      this.placement_id = this.$route.query.placement_id;
      this.format_id = this.$route.query.format_id;

      src_store.dispatch('formats/load').then(function (formats) {
        formats.forEach(function (format) {
          if (format.id == _this.format_id) {
            _this.format = format;
          }
        });
      });
    }
  },

  methods: {
    getDisplaySize: function getDisplaySize(size) {
      if (size.type == 'fixed') {
        return size.width + 'x' + size.height;
      } else {
        return size.width + ':' + size.height;
      }
    },
    config: function config(size) {
      return stringify_default()({
        size: {
          width: size.width,
          height: size.height,
          type: size.type
        }
      });
    },
    computeWidth: function computeWidth(size) {
      if (size.type === 'fixed') {
        return size.width + 'px';
      } else {
        return 'auto';
      }
    },
    getAdCode: function getAdCode(size) {
      var parkaveTag = '<!--\n' + '+-+-+-+-+-+-+-+ +-+-+-+-+ +-+-+-+-+-+ \n' + '|P|a|r|k|A|v|e| |W|i|n|s| |S|a|l|e|s| \n' + '+-+-+-+-+-+-+-+ +-+-+-+-+ +-+-+-+-+-+ \n' + 'Thank you for using ParkAve. Only modify this code if ' + 'you feel comfortable doing so. \n Email questions to: \n' + 'parkave-help@broadstreetads.com \n' + '--> \n';
      var gosell = '<scr' + 'ipt src="https://cdn.getparkave.com/go-sell.js"></scr' + 'ipt>';
      var rtnString = '<ins class="parkave-placement" style="position:relative;display:inline-table;width:' + size.width + 'px;height:' + size.height + 'px;max-width:100%;" ' + 'data-parkave-width=\'' + size.width + '\' ' + 'data-parkave-height=\'' + size.height + '\' ' + 'data-parkave-placement=\'' + this.placement_id + '\' ' + 'data-parkave-timestamp=\'' + this.getAdTimeStamp + '\' ' + 'data-parkave-size=\'' + size.type + '\' ' + 'data-parkave-config=\'' + this.config(size) + '\' ' + 'data-parkave-click-tracker=\'%%CLICK_URL_UNESC%%\'>' + gosell + '</ins>';
      return parkaveTag + rtnString;
    }
  },
  computed: {
    getSizes: function getSizes() {
      if (this.format.id) {
        var sizes = [];
        var input = JSON.parse(this.format.specification).inputs;
        for (var i = 0; i < input.length; i++) {
          if (input[i].type === 'size') {
            for (var v = 0; v < input[i].options.length; v++) {
              if (input[i].options[v].type === 'flexible') {
                sizes.push({
                  width: input[i].options[v].width,
                  type: 'flexible',
                  height: input[i].options[v].height
                });
              } else {
                sizes.push({
                  width: input[i].options[v].width,
                  type: 'fixed',
                  height: input[i].options[v].height
                });
              }
            }
            return sizes;
          }
        }
        if (sizes === []) {
          return null;
        }
      }
      return {};
    },
    getAdTimeStamp: function getAdTimeStamp() {
      var d = new Date();
      d.setMinutes(0);
      d.setSeconds(0);
      var ts = d.setMilliseconds(0);
      return ts;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9e2f51e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientPreview.vue
var ClientPreview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.format && _vm.getSizes)?_c('section',_vm._l((_vm.getSizes),function(size){return _c('section',{staticClass:"demo__adview",staticStyle:{"margin":"200px auto"},style:({width: _vm.computeWidth(size)})},[_c('h2',{staticClass:"demo__adtitle",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.getDisplaySize(size))+" - Preview")]),_vm._v(" "),_c('ins',{staticClass:"parkave-placement",style:('position:relative;display:inline-table;width:'+size.width+'px;height:'+size.height+'px;max-width:100%;'),attrs:{"data-parkave-width":size.width,"data-parkave-height":size.height,"data-parkave-placement":_vm.placement_id,"data-parkave-timestamp":_vm.getAdTimeStamp,"data-parkave-size":size.type,"data-parkave-config":_vm.config(size)}}),_vm._v(" "),_c('h2',{staticClass:"demo__adtitle",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.getDisplaySize(size))+" - Code")]),_vm._v(" "),_c('div',{staticClass:"export__input export__input--client input"},[_c('textarea',{ref:"code",refInFor:true,staticClass:"input__field--dark input__field",attrs:{"readonly":""},domProps:{"value":_vm.getAdCode(size)}})])])})):_vm._e(),_vm._v(" "),(_vm.format && !_vm.getSizes)?_c('h2',{staticClass:"demo__adtitle",staticStyle:{"color":"white"}},[_vm._v("Out of Page")]):_vm._e(),_vm._v(" "),(_vm.format && !_vm.getSizes)?_c('section',{staticClass:"window__preview",staticStyle:{"width":"100%","height":"500px"}},[_c('div',{staticClass:"window__preview__inner"},[_c('preview-settings',{attrs:{"ad":{},"inputs":{}}}),_vm._v(" "),_c('ins',{staticClass:"parkave-placement",staticStyle:{"display":"none"},attrs:{"data-parkave-placement":_vm.placement_id,"data-parkave-size":"out-of-page","data-parkave-timestamp":_vm.getAdTimeStamp,"data-parkave-config":"{}"}})],1)]):_vm._e()])}
var ClientPreview_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"section__header"},[_c('h1',{staticClass:"section__title",staticStyle:{"margin":"60px 20px"}},[_vm._v("Client Preview")])])}]
var ClientPreview_esExports = { render: ClientPreview_render, staticRenderFns: ClientPreview_staticRenderFns }
/* harmony default export */ var components_ClientPreview = (ClientPreview_esExports);
// CONCATENATED MODULE: ./src/components/ClientPreview.vue
function ClientPreview_injectStyle (ssrContext) {
  __webpack_require__("GsNN")
}
var ClientPreview_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ClientPreview___vue_template_functional__ = false
/* styles */
var ClientPreview___vue_styles__ = ClientPreview_injectStyle
/* scopeId */
var ClientPreview___vue_scopeId__ = "data-v-f9e2f51e"
/* moduleIdentifier (server only) */
var ClientPreview___vue_module_identifier__ = null
var ClientPreview_Component = ClientPreview_normalizeComponent(
  ClientPreview,
  components_ClientPreview,
  ClientPreview___vue_template_functional__,
  ClientPreview___vue_styles__,
  ClientPreview___vue_scopeId__,
  ClientPreview___vue_module_identifier__
)

/* harmony default export */ var src_components_ClientPreview = (ClientPreview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SelfServeUpdates.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var SelfServeUpdates_configLocalStorageKey = 'parkave_config';

/* harmony default export */ var SelfServeUpdates = ({
  name: 'SelfServeUpdates',
  components: {
    Item: components_configurator_Item,
    ArrayItem: components_configurator_ArrayItem,
    SizeInput: components_configurator_SizeInput
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (src_store.state.me.id) return next();
    src_store.dispatch('loadMe').then(function (me) {
      if (me.admin || me.format_admin) {
        return src_store.dispatch('formats/loadAll').then(next);
      } else {
        return next();
      }
    });
  },
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var formatsInterval;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.$store.dispatch('advertisements/loadSingle', _this.$route.params.advertisement_id);

            case 2:
              _context2.next = 4;
              return _this.$store.dispatch('loadUpdateFields');

            case 4:

              _this.getConfigFromLocalStorage = function () {
                return JSON.parse(localStorage.getItem(SelfServeUpdates_configLocalStorageKey));
              };

              _this.shouldUseLocalStorage = function () {
                return _this.$route.params.format_id && !_this.$route.params.advertisement_id;
              };

              _this.writeConfigToLocalStorage = function (config) {
                localStorage.setItem(SelfServeUpdates_configLocalStorageKey, stringify_default()(config));
              };

              formatsInterval = setInterval(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var _this2 = this;

                var key, value, values, config, thisConfig, format_id;
                return regenerator_default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (this.$store.getters['formats/unfiltered'].length) {
                          clearInterval(formatsInterval);

                          this.format = this.$store.getters['formats/unfiltered'].filter(function (format) {
                            return parseInt(_this2.$route.params.format_id) === format.id;
                          })[0];

                          if (!this.ad.update_rule_id) {
                            this.$router.push('/');
                          }

                          try {
                            if (!this.format && this.$store.getters.isFormatAdmin) {
                              this.format = this.$store.state.formats.allFormats.filter(function (format) {
                                return parseInt(_this2.$route.params.format_id) === format.id;
                              })[0];
                            }
                            this.fields = JSON.parse(this.format.specification).inputs;

                            for (key in this.fields) {
                              value = this.fields[key];
                              values = this.ad ? this.ad.json : {};


                              if (value.type == 'object') {
                                this.$set(this.settings, value.name, {});
                              }

                              values = JSON.parse(values);

                              if (values && value.name in values) {
                                this.$set(this.settings, value.name, values[value.name]);
                              } else if (value.default) {
                                this.$set(this.settings, value.name, value.default);
                              }

                              this.$set(this.settings, 'name', this.ad.name);
                            }
                          } catch (e) {
                            console.log('error parsing fields', e);
                          }

                          this.loadedConfigDefaults = true;

                          if (!localStorage.getItem(SelfServeUpdates_configLocalStorageKey)) this.writeConfigToLocalStorage({});

                          config = this.getConfigFromLocalStorage();
                          thisConfig = null;


                          if (this.shouldUseLocalStorage()) {
                            format_id = this.$route.params.format_id;


                            if (format_id in config) {
                              thisConfig = config[format_id];
                            }

                            if (thisConfig) this.$set(this, 'settings', thisConfig);
                          }
                        }

                      case 1:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              })).bind(_this), 100);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  methods: {
    sizeItem: function sizeItem() {
      for (var key in this.fields) {
        if (this.fields[key].type == 'size') {
          return this.fields[key];
        }
      }
      return null;
    },
    save: function save(e, insert) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var error, payload, finish;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e.preventDefault();

                error = function error(type) {
                  responseNotification({}, { error: 'Please enter a ' + type }, {}, { timeout: 2000 });
                };

                if (!(!_this3.settings.first_name || _this3.settings.first_name.length < 3)) {
                  _context3.next = 5;
                  break;
                }

                error('first name.');return _context3.abrupt('return');

              case 5:
                if (!(!_this3.settings.last_name || _this3.settings.last_name.length < 3)) {
                  _context3.next = 8;
                  break;
                }

                error('last name.');return _context3.abrupt('return');

              case 8:
                if (!(!_this3.settings.email || _this3.settings.email.length < 3 || !_this3.is_email_valid(_this3.settings.email))) {
                  _context3.next = 11;
                  break;
                }

                error('valid email.');return _context3.abrupt('return');

              case 11:
                if (_this3.settings.title) {
                  _context3.next = 14;
                  break;
                }

                error('title.');return _context3.abrupt('return');

              case 14:
                if (!(!_this3.settings.description || _this3.settings.description.length < 3)) {
                  _context3.next = 17;
                  break;
                }

                error('description.');return _context3.abrupt('return');

              case 17:
                if (_this3.settings.image) {
                  _context3.next = 20;
                  break;
                }

                error('image.');return _context3.abrupt('return');

              case 20:
                if (!(!_this3.settings.link || _this3.settings.link.length < 3)) {
                  _context3.next = 23;
                  break;
                }

                error('destination link.');return _context3.abrupt('return');

              case 23:
                if (_this3.settings.scheduled_time) {
                  _context3.next = 26;
                  break;
                }

                error('proper time slot for the ad to run.');return _context3.abrupt('return');

              case 26:

                responseNotification({}, { info: 'Creating ad...' }, {}, { timeout: 4000 });

                payload = {};


                _this3.update_fields.forEach(function (field) {
                  payload[field.name] = _this3.settings[field.name];
                });

                payload.image = _this3.settings['image'].url;
                payload.meta = _this3.settings['image'];
                payload.advertisement_id = _this3.ad.id;
                payload.timezone = window.timezone;

                finish = function finish() {
                  src_store.dispatch('createUpdate', { data: payload, cb: function cb(response) {
                      if (!response.errors) {
                        _this3.$router.push('/update_success');
                      }
                    } });

                  var config = _this3.getConfigFromLocalStorage();

                  if (_this3.shouldUseLocalStorage()) {
                    var format_id = _this3.$route.params.format_id;

                    if (format_id in config) {
                      var newConfig = lodash_default.a.omit(config, [format_id]);

                      _this3.writeConfigToLocalStorage(newConfig);
                    }
                  }
                };

                finish();

              case 35:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getFormName: function getFormName(type, index) {
      return type + '-' + index;
    },
    onChangeTime: function onChangeTime(binding, newVal) {
      var _newVal$data = newVal.data,
          HH = _newVal$data.HH,
          mm = _newVal$data.mm,
          ss = _newVal$data.ss;

      this.settings[binding] = { HH: HH, mm: mm, ss: ss };
    },
    onPreviewData: function onPreviewData(preview) {
      if (preview.scale) {
        this.$set(this.preview, 'scale', preview.scale);
      }
    },
    is_email_valid: function is_email_valid(email) {
      var re = /(\w(=?@)\w+\.{1}[a-zA-Z]{2,})/i;
      return !!re.test(email);
    }
  },
  watch: {
    sidebarActive: {
      handler: function handler() {
        this.$refs.preview.generatePreview();
      }
    },
    settings: {
      deep: true,
      handler: function handler(newVal) {
        var config = this.getConfigFromLocalStorage();

        if (this.shouldUseLocalStorage() && this.loadedConfigDefaults) {
          var format_id = this.$route.params.format_id;

          config[format_id] = newVal;
          this.writeConfigToLocalStorage(config);
        }
      }
    }
  },
  data: function data() {
    return {
      sidebarActive: true,
      format: {},
      fields: [],
      settings: {},
      meta: {},
      preview: {
        srcdoc: '',
        length: 0,
        scale: 100
      },
      isUpdateable: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['update_fields']), Object(vuex_esm["b" /* mapState */])('advertisements', {
    ad: 'single_ad'
  }), {
    getSize: function getSize() {
      var size = this.settings['size'];
      if (size && size.type == 'fixed') {
        return size.width + 'x' + size.height;
      } else if (size) {
        return size.width + ':' + size.height;
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7917f876","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelfServeUpdates.vue
var SelfServeUpdates_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"breadcrumb-dark"},[_vm._m(0,false,false),_vm._v(" "),(_vm.sidebarActive)?_c('div',{staticClass:"breadcrumb-dark__select-preview select-preview",attrs:{"data-v-config-step":"4"}},[_c('label',{staticClass:"select-preview__label"},[_vm._v("Display size: ")]),_vm._v(" "),_c('p',{staticClass:"size__display"},[_vm._v(_vm._s(_vm.getSize))])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"main-content main-content--white-background",class:{'main-content--full-width': _vm.sidebarActive}},[_c('section',{staticClass:"main-content__full section",class:{'section--sidebar': _vm.sidebarActive}},[_c('form',{staticClass:"section__content section__content--form form"},[_c('fieldset',{staticClass:"form__group"},[_c('article',{staticClass:"form__item"},[_vm._m(1,false,false),_vm._v(" "),_c('section',{staticClass:"form__item__input input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings.name),expression:"settings.name"}],staticClass:"input__field",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":(_vm.settings.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings, "name", $event.target.value)}}})])]),_vm._v(" "),_vm._l((_vm.update_fields),function(field,index){return _c('article',{staticClass:"form__item"},[_c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v(_vm._s(field.description))])]),_vm._v(" "),(!field.array)?_c('item',{attrs:{"id":_vm.getFormName(field.type, index),"defaultValue":_vm.settings[field.name],"item":field},model:{value:(_vm.settings[field.name]),callback:function ($$v) {_vm.$set(_vm.settings, field.name, $$v)},expression:"settings[field.name]"}}):_vm._e(),_vm._v(" "),(field.array)?_c('array-item',{attrs:{"id":_vm.getFormName(field.type, index),"defaultValue":_vm.settings[field.name],"item":field},model:{value:(_vm.settings[field.name]),callback:function ($$v) {_vm.$set(_vm.settings, field.name, $$v)},expression:"settings[field.name]"}}):_vm._e()],1)})],2)]),_vm._v(" "),_c('section',{staticClass:"section__content section__content--preview"},[_c('article',{staticClass:"section__content__preview preview"},[(!_vm.sidebarActive)?_c('header',{staticClass:"preview__header"},[_c('h1',{staticClass:"preview__title"},[_vm._v("Preview")])]):_vm._e(),_vm._v(" "),_c('preview-settings',{ref:"preview",attrs:{"data-v-config-step":"3","ad":_vm.ad,"inputs":_vm.settings},on:{"preview-data":_vm.onPreviewData}}),_vm._v(" "),(!_vm.sidebarActive)?_c('footer',{staticClass:"preview__footer"},[_c('ul',{staticClass:"preview__details details"},[_c('li',{staticClass:"details__item"},[_vm._v("\n                                Preview Size: "),_c('strong',{staticClass:"details__item__value"},[_vm._v(_vm._s(_vm.preview.length)+" Bytes")])]),_vm._v(" "),_c('li',{staticClass:"details__item details__item--preview detail__item__select-preview"},[_c('div',{staticClass:"select-preview select-preview--light select-preview--small"},[_c('label',{staticClass:"select-preview__label"},[_vm._v("Preview size")]),_vm._v(" "),(_vm.sizeItem())?_c('size-input',{attrs:{"selectClass":"select-preview__select","defaultValue":_vm.settings['size'],"options":_vm.sizeItem().options},model:{value:(_vm.settings['size']),callback:function ($$v) {_vm.$set(_vm.settings, 'size', $$v)},expression:"settings['size']"}}):_vm._e()],1)])])]):_vm._e()],1),_vm._v(" "),(!_vm.sidebarActive)?_c('hr',{staticClass:"seperator"}):_vm._e(),_vm._v(" "),_c('footer',{staticClass:"section__footer"},[(_vm.sidebarActive)?_c('ul',{staticClass:"details"},[_c('li',{staticClass:"details__item"},[(_vm.preview.scale < 100)?_c('span',[_c('strong',{staticClass:"details__item__value"},[_vm._v("Note:")]),_vm._v(" Scaled down for preview")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"section__footer__button section__footer__button--right button button--secondary button--ghost",class:{ 'button--disabled': !_vm.settings.name || (_vm.settings.name && _vm.settings.name.length < 3) },attrs:{"href":"#"},on:{"click":function($event){_vm.save($event, false)}}},[_vm._v("Submit for Approval")])])])])])])}
var SelfServeUpdates_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumb-dark__list"},[_c('li',{staticClass:"breadcrumb-dark__level"},[_c('span',{staticClass:"breadcrumb-dark__link"},[_vm._v("Self Serve Updates by ParkAve")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__item__label"},[_c('h1',{staticClass:"form__item__name"},[_vm._v("Advertisement Name")]),_vm._v(" "),_c('small',{staticClass:"form__item__description"},[_vm._v("This is the advertisement chosen for self serve. This cannot be changed.")])])}]
var SelfServeUpdates_esExports = { render: SelfServeUpdates_render, staticRenderFns: SelfServeUpdates_staticRenderFns }
/* harmony default export */ var components_SelfServeUpdates = (SelfServeUpdates_esExports);
// CONCATENATED MODULE: ./src/components/SelfServeUpdates.vue
function SelfServeUpdates_injectStyle (ssrContext) {
  __webpack_require__("qr1n")
}
var SelfServeUpdates_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SelfServeUpdates___vue_template_functional__ = false
/* styles */
var SelfServeUpdates___vue_styles__ = SelfServeUpdates_injectStyle
/* scopeId */
var SelfServeUpdates___vue_scopeId__ = "data-v-7917f876"
/* moduleIdentifier (server only) */
var SelfServeUpdates___vue_module_identifier__ = null
var SelfServeUpdates_Component = SelfServeUpdates_normalizeComponent(
  SelfServeUpdates,
  components_SelfServeUpdates,
  SelfServeUpdates___vue_template_functional__,
  SelfServeUpdates___vue_styles__,
  SelfServeUpdates___vue_scopeId__,
  SelfServeUpdates___vue_module_identifier__
)

/* harmony default export */ var src_components_SelfServeUpdates = (SelfServeUpdates_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UpdateSuccess.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UpdateSuccess = ({
  name: 'UpdateSuccess'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e96c9bc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdateSuccess.vue
var UpdateSuccess_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var UpdateSuccess_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Thank you! We will send an email to let you know when your post will go live.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Powered By ParkAve & Broadstreet")])])}]
var UpdateSuccess_esExports = { render: UpdateSuccess_render, staticRenderFns: UpdateSuccess_staticRenderFns }
/* harmony default export */ var components_UpdateSuccess = (UpdateSuccess_esExports);
// CONCATENATED MODULE: ./src/components/UpdateSuccess.vue
function UpdateSuccess_injectStyle (ssrContext) {
  __webpack_require__("aEm7")
}
var UpdateSuccess_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var UpdateSuccess___vue_template_functional__ = false
/* styles */
var UpdateSuccess___vue_styles__ = UpdateSuccess_injectStyle
/* scopeId */
var UpdateSuccess___vue_scopeId__ = "data-v-e96c9bc6"
/* moduleIdentifier (server only) */
var UpdateSuccess___vue_module_identifier__ = null
var UpdateSuccess_Component = UpdateSuccess_normalizeComponent(
  UpdateSuccess,
  components_UpdateSuccess,
  UpdateSuccess___vue_template_functional__,
  UpdateSuccess___vue_styles__,
  UpdateSuccess___vue_scopeId__,
  UpdateSuccess___vue_module_identifier__
)

/* harmony default export */ var src_components_UpdateSuccess = (UpdateSuccess_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c66748a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var NotFound_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('h1',{staticClass:"section__title notfound__title"},[_vm._v("You seem to have found yourself on the wrong street looking for something that does not exist.")])])}]
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/components/NotFound.vue
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = null
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  __vue_script__,
  NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var components_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js

















vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_Home
  }, {
    path: '/categories',
    name: 'Categories',
    component: src_components_Categories
  }, {
    path: '/categories/:id',
    name: 'Category',
    component: src_components_Category
  }, {
    path: '/configuration/:format_id',
    name: 'Configuration',
    component: src_components_Configuration
  }, {
    path: '/configuration/:format_id/:id',
    name: 'Configuration',
    component: src_components_Configuration
  }, {
    path: '/ads',
    name: 'Ads',
    component: src_components_Ads
  }, {
    path: '/demo/:format_id',
    name: 'Demo',
    component: src_components_Demo
  }, {
    path: '/profile',
    name: 'Profile',
    component: src_components_Profile
  }, {
    path: '/insert-creative',
    name: 'Insert Creative',
    component: src_components_InsertCreative
  }, {
    path: '/admin',
    name: 'Administrator',
    component: src_components_Administrator
  }, {
    path: '/quote',
    name: 'EnterpriseForm',
    component: src_components_EnterpriseForm
  }, {
    path: '/clientpreview',
    name: 'Client Preview',
    component: src_components_ClientPreview
  }, {
    path: '/updates/:format_id/:advertisement_id',
    name: 'Self Serve Updates',
    component: src_components_SelfServeUpdates
  }, {
    path: '/update_success',
    name: 'UpdateSuccess',
    component: src_components_UpdateSuccess
  }, {
    path: '/pricing',
    name: 'Pricing',
    component: src_components_Home
  }, {
    path: '*',
    name: 'Default/Not Found',
    component: components_NotFound
  }]
}));
// CONCATENATED MODULE: ./src/store/users.js


/** VUEX module for user management **/





/* harmony default export */ var users = ({
  namespaced: true,
  state: {
    favorites: [],
    all: []
  },
  mutations: {
    setFavorites: function setFavorites(state, value) {
      state.favorites = value;
    },
    setUsers: function setUsers(state, value) {
      state.all = value;
    }
  },
  actions: {
    loadAll: function loadAll(_ref) {
      var commit = _ref.commit;

      Object(calls["E" /* fetchAllUsers */])().then(function (users) {
        commit('setUsers', users);
      });
    },
    addFavorite: function addFavorite(context, _ref2) {
      var format_id = _ref2.format_id;

      Object(calls["o" /* createFavorites */])(format_id).then(function (response) {
        context.dispatch('loadFavorites');
      });
    },
    hubspotNewUser: function hubspotNewUser(context) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var email, name;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                email = context.rootState.me.email;
                name = context.rootState.me.name;
                _context.next = 4;
                return Object(calls["_13" /* signupHubspotNotification */])(email, name);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    removeFavorite: function removeFavorite(context, _ref3) {
      var id = _ref3.id;

      Object(calls["y" /* deleteFavorites */])(id).then(function (response) {
        context.dispatch('loadFavorites');
      });
    },
    loadFavorites: function loadFavorites(_ref4) {
      var commit = _ref4.commit;

      Object(calls["_0" /* loadFavorites */])().then(function (favorites) {
        commit('setFavorites', favorites);
      });
    },
    updatePassword: function updatePassword(context, payload) {
      Object(calls["_20" /* updatePassword */])(payload).then(function (result) {
        responseNotification(context, result, 'Password updated!');
      }).catch(function (result) {
        responseNotification(context, { error: 'Password update failed!' });
      });
    },
    updateBasicDetails: function updateBasicDetails(context, _ref5) {
      var userId = _ref5.userId,
          payload = _ref5.payload;

      Object(calls["_16" /* updateBasicDetails */])(userId, payload).then(function (result) {
        if (result.status == 422) {
          responseNotification(context, { error: 'This email is already taken by another user.' });
        } else {
          responseNotification(context, result, 'Basic Details Updated!');
          context.dispatch('loadMe', {}, { root: true });
          context.dispatch('accounts/loadOwned', {}, { root: true });
        }
      });
    },
    update: function update(context, _ref6) {
      var userId = _ref6.userId,
          payload = _ref6.payload;

      Object(calls["_24" /* updateUser */])(userId, payload).then(function (result) {
        responseNotification(context, result, 'User Details Updated!');
        context.dispatch('users/loadAll', {}, { root: true });
      });
    },
    sendForgotPassword: function sendForgotPassword(context, _ref7) {
      var email = _ref7.email,
          callback = _ref7.callback;

      Object(calls["_9" /* sendForgotPassword */])(email).then(function (response) {
        if (response.error) {
          responseNotification(context, response);
        } else {
          responseNotification(context, response, 'Check your email for password result instructions.');
          if (callback) callback();
        }
      });
    },
    verifyPassword: function verifyPassword(context, _ref8) {
      var token = _ref8.token;

      Object(calls["_27" /* verifyPassword */])(token).then(function (response) {
        if (!response.error) {
          delete localStorage.password_token;
          responseNotification(context, response, 'User Logged In!');
          router.push('/profile');
          location.reload();
        } else {
          responseNotification(context, response);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/coupons.js
/** VUEX module for coupon management **/




/* harmony default export */ var coupons = ({
  namespaced: true,
  state: {
    coupons: []
  },
  mutations: {
    setCoupons: function setCoupons(state, coupons) {
      state.coupons = coupons;
    }
  },
  actions: {
    load: function load(_ref) {
      var commit = _ref.commit;

      return Object(calls["N" /* getCoupons */])().then(function (coupons) {
        commit('setCoupons', coupons);
        return coupons;
      });
    },
    create: function create(context, payload) {
      Object(calls["n" /* createCoupon */])(payload).then(function (response) {
        responseNotification(context, response, 'Coupon Created!');
        context.dispatch('load');
      });
    },
    update: function update(context, _ref2) {
      var id = _ref2.id,
          payload = _ref2.payload;

      Object(calls["_18" /* updateCoupon */])(id, payload).then(function (response) {
        responseNotification(context, response, 'Coupon updated!');
        context.dispatch('load');
      });
    },
    delete: function _delete(context, id) {
      Object(calls["x" /* deleteCoupon */])(id).then(function (response) {
        responseNotification(context, response, 'Coupon deleted!');
        context.dispatch('load');
      });
    },
    deliver: function deliver(context, _ref3) {
      var id = _ref3.id,
          email = _ref3.email;

      Object(calls["B" /* deliverCoupon */])(id, email).then(function (response) {
        if (!response.error) {
          responseNotification(context, response, 'Coupon delivered!');
        }
      });
    },
    getActive: function getActive(context, token) {
      return Object(calls["G" /* getActiveCoupon */])(token).then(function (coupon) {
        return coupon;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/updates.js
/** VUEX module for user management **/





/* harmony default export */ var updates = ({
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    confirm: function confirm(context, _ref) {
      var token = _ref.token;

      Object(calls["g" /* confirmUpdate */])(token).then(function (response) {
        if (!response.error) {
          delete localStorage.update_confirmation;
          responseNotification(context, response, 'Confirmed Advertisement Successfully!');
          router.push('/');
        } else {
          responseNotification(context, response);
        }
      });
    },
    approve: function approve(context, _ref2) {
      var token = _ref2.token;

      Object(calls["c" /* approveUpdate */])(token).then(function (response) {
        if (!response.error) {
          delete localStorage.update_request_approval;
          responseNotification(context, response, 'Approved Advertisement Successfully!');
          router.push('/');
        } else {
          responseNotification(context, response);
        }
      });
    },
    deny: function deny(context, _ref3) {
      var token = _ref3.token;

      Object(calls["C" /* denyUpdate */])(token).then(function (response) {
        if (!response.error) {
          delete localStorage.update_request_denial;
          responseNotification(context, response, 'Denied Advertisement Successfully!');
          router.push('/');
        } else {
          responseNotification(context, response);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store.js




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);












var store_store = new vuex_esm["a" /* default */].Store({
  modules: {
    accounts: accounts,
    advertisements: advertisements,
    categories: categories,
    formats: store_formats,
    users: users,
    coupons: coupons,
    updates: updates
  },
  state: {
    loadOptions: {},
    me: {},
    plans: [],
    account: {},
    planChosen: false,
    adminMocking: null,
    preferences: {},
    updateable_fields: [],
    updateable_settings: {},
    update_fields: [],
    temp_update_fields: [],
    scheduled: [],
    limited_update_rule: {}
  },
  getters: {
    isFormatAdmin: function isFormatAdmin(state) {
      return state.me.admin || state.me.format_admin;
    }
  },
  mutations: {
    setPlans: function setPlans(state, plans) {
      state.plans = plans;
    },
    setMe: function setMe(state, me) {
      state.me = me;
    },
    setConfig: function setConfig(state, config) {
      state.config = config;
    },
    choosePlan: function choosePlan(state, plan) {
      state.account.plan = plan;
      state.planChosen = plan;
    },
    setAccount: function setAccount(state, value) {
      localStorage.account_id = value.id;
      if (value.plan) state.planChosen = value.plan;
      state.account = value;
    },
    setAdminDeMocker: function setAdminDeMocker(state) {
      state.adminMocking = localStorage.user_id && localStorage.user_id > 0;
    },
    setPreferences: function setPreferences(state, value) {
      if (value.length) {
        value.forEach(function (val) {
          state.preferences[val.name] = val.value;
        });
      }
    },
    setUpdateRuleFields: function setUpdateRuleFields(state, value) {
      state.temp_update_fields = value;
    },
    setUpdateRuleSettings: function setUpdateRuleSettings(state, value) {
      state.temp_update_fields.forEach(function (field) {
        state.updateable_settings[field.name] = value[field.name];
      });
      state.updateable_fields = state.temp_update_fields;
    },
    setUpdateFields: function setUpdateFields(state, value) {
      state.update_fields = value;
    },
    setScheduled: function setScheduled(state, value) {
      state.scheduled = value;
    },
    setUpdateRuleLimited: function setUpdateRuleLimited(state, value) {
      state.limited_update_rule = value;
    }
  },
  actions: {
    loadScheduled: function loadScheduled(_ref, id) {
      var commit = _ref.commit;

      return Object(calls["T" /* getScheduled */])(id).then(function (times) {
        return commit('setScheduled', times);
      });
    },
    loadUpdateRuleFields: function loadUpdateRuleFields(_ref2) {
      var commit = _ref2.commit;

      return Object(calls["X" /* getUpdateRuleFields */])().then(function (fields) {
        commit('setUpdateRuleFields', fields);
        return fields;
      });
    },
    loadUpdateRuleLimited: function loadUpdateRuleLimited(_ref3, id) {
      var commit = _ref3.commit;

      return Object(calls["_2" /* loadUpdateRuleLimited */])(id).then(function (update_rule) {
        return commit('setUpdateRuleLimited', update_rule);
      });
    },
    createReferral: function createReferral(context, _ref4) {
      var email = _ref4.email;

      Object(calls["p" /* createReferral */])(email).then(function (response) {
        if (response.errors) {
          responseNotification(context, { error: response.errors }, {});
        } else {
          responseNotification(context, {}, 'Successfully Sent Referral');
        }
      });
    },
    confirmReferral: function confirmReferral(context, _ref5) {
      var token = _ref5.token;

      Object(calls["f" /* confirmReferral */])(token);
    },
    createUpdate: function createUpdate(context, _ref6) {
      var data = _ref6.data,
          cb = _ref6.cb;

      Object(calls["q" /* createUpdate */])(data).then(function (response) {
        if (response.errors) {
          responseNotification(context, { error: response.errors }, {});
        }
        if (cb) cb(response);
      });
    },
    loadUpdateFields: function loadUpdateFields(_ref7) {
      var commit = _ref7.commit;

      Object(calls["V" /* getUpdateFields */])().then(function (fields) {
        return commit('setUpdateFields', fields);
      });
    },
    updateUpdateRule: function updateUpdateRule(context, _ref8) {
      var id = _ref8.id,
          payload = _ref8.payload;

      Object(calls["_23" /* updateUpdateRule */])(id, payload);
    },
    createUpdateRule: function createUpdateRule(_ref9, payload) {
      var _this = this;

      var commit = _ref9.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var rtnVal;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                rtnVal = void 0;
                _context.next = 3;
                return Object(calls["r" /* createUpdateRule */])(payload).then(function (id) {
                  rtnVal = id;
                });

              case 3:
                return _context.abrupt('return', rtnVal);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getUpdateRule: function getUpdateRule(_ref10, id) {
      var commit = _ref10.commit;

      return Object(calls["W" /* getUpdateRule */])(id).then(function (response) {
        commit('setUpdateRuleSettings', response);
        return response;
      });
    },
    setAccount: function setAccount(_ref11, account) {
      var dispatch = _ref11.dispatch,
          commit = _ref11.commit;

      commit('setAccount', account);
      dispatch('advertisements/load');
      dispatch('formats/load');
    },
    reloadMe: function reloadMe(_ref12) {
      var dispatch = _ref12.dispatch,
          commit = _ref12.commit;

      dispatch('loadMe').then(function () {
        return dispatch('accounts/loadOwned');
      }).then(function () {
        return dispatch('advertisements/load');
      }).then(function () {
        return dispatch('loadAdminDeMocker');
      });
    },
    loadAdminDeMocker: function loadAdminDeMocker(_ref13) {
      var commit = _ref13.commit;

      commit('setAdminDeMocker');
    },
    loadMe: function loadMe(_ref14) {
      var commit = _ref14.commit;

      return Object(calls["_5" /* me */])().then(function (me) {
        commit('setMe', me);
        return me;
      });
    },
    loadConfig: function loadConfig(_ref15) {
      var commit = _ref15.commit;

      return Object(calls["e" /* config */])().then(function (config) {
        commit('setConfig', config);
        return config;
      });
    },
    loadPreferences: function loadPreferences(_ref16) {
      var commit = _ref16.commit;

      Object(calls["R" /* getPreferences */])().then(function (userPreferences) {
        return commit('setPreferences', userPreferences);
      });
    },
    loadPlans: function loadPlans(_ref17) {
      var commit = _ref17.commit;

      Object(calls["Q" /* getPlans */])().then(function (plans) {
        return commit('setPlans', plans);
      });
    },
    cancelAccount: function cancelAccount(context) {
      Object(calls["d" /* cancelAccount */])().then(calls["_4" /* logout */]).catch(function (result) {
        responseNotification(store_store, { error: 'Something went wrong!' });
      });
    },
    login: function login(context, payload) {
      var email = payload.email,
          password = payload.password;


      Object(calls["_3" /* login */])(email, password).then(function (result) {
        if (!result.error) {
          location.reload();
        } else {
          responseNotification(context, result);
          context.dispatch('setAccount', 0);
        }
      }).catch(function (e) {
        console.log('e', e);
        responseNotification(context, { error: 'Login failure!' });
      });
    },
    updatePreferences: function updatePreferences(context, _ref18) {
      var userId = _ref18.userId,
          payload = _ref18.payload;

      Object(calls["_21" /* updatePreferences */])(userId, payload).then(function () {
        context.dispatch('loadMe');
        context.dispatch('loadPreferences');
      });
    },
    inviteUser: function inviteUser(context, userEmail) {
      Object(calls["Y" /* inviteUser */])(userEmail).then(function (response) {
        responseNotification(context, response, 'User Invited!');
        context.dispatch('accounts/loadOwned');
      });
    },
    addUserToAccount: function addUserToAccount(context, _ref19) {
      var _this2 = this;

      var token = _ref19.token;

      Object(calls["b" /* addUserToAccount */])(token).then(function (response) {
        responseNotification(context, response, 'You joined an account!');
        delete localStorage.account_token;
        context.dispatch('accounts/loadOwned').then(function (account) {
          var account_found = _this2.getters['accounts/owned'].find(function (acct) {
            return acct.id == response.account_id;
          });
          if (account_found) {
            context.dispatch('setAccount', account_found);
          }
        });
      });
    },
    verifySignUp: function verifySignUp(context, _ref20) {
      var _this3 = this;

      var token = _ref20.token;

      Object(calls["_28" /* verifySignUp */])(token).then(function (response) {
        if (!response.error) {
          delete localStorage.signup_token;
          responseNotification(context, response, 'Email Confirmed Successfully!');
          if (!_this3.state.me.id) {
            location.reload();
          }
        } else {
          responseNotification(context, response);
        }
      });
    }
  }
});

/* harmony default export */ var src_store = (store_store);
// EXTERNAL MODULE: ./src/lib/api/client.js
var client = __webpack_require__("OAu2");

// EXTERNAL MODULE: ./src/lib/util.js
var util = __webpack_require__("CPGk");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/lib/oauth.js







function oauthLogin() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "google";
  var signup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  doPopup(client["a" /* apiURL */] + 'auth/' + provider, function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(loginToken) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              Object(calls["_10" /* setAuthToken */])(loginToken);

              if (!signup) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return src_store.dispatch('loadMe');

            case 4:
              _context.next = 6;
              return src_store.dispatch('users/hubspotNewUser');

            case 6:
              location.reload();
              if (window.afterCompleteSignUpModal) {
                src_store.dispatch('accounts/loadOwned');
                src_store.dispatch('loadMe');
                window.afterCompleteSignUpModal();
              } else {
                location.reload();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }());
}

function doPopup(url, onCallback) {
  window.open(url);

  window.addEventListener('message', function (event) {
    if (Object(util["isApiBaseUrl"])(event.origin)) {
      onCallback(event.data);
    }
  }, false);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/SignIn.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email



/* harmony default export */ var SignIn = ({
  name: 'SignInModal',
  methods: {
    hide: function hide() {
      this.$modal.hide('sign-in');
    },
    submit: function submit() {
      var _this = this;

      this.error = null;
      var email = this.email,
          password = this.password;


      if (this.forgotPassword) {
        src_store.dispatch('users/sendForgotPassword', { email: email,
          callback: function callback() {
            _this.hide();
          } });
      } else {
        src_store.dispatch('login', { email: email, password: password });
      }
    },
    toggleForgotPassword: function toggleForgotPassword() {
      this.forgotPassword = !this.forgotPassword;
    },
    googleSignIn: function googleSignIn(e) {
      e.preventDefault();
      oauthLogin('google');
    }
  },
  data: function data() {
    var obj = {
      email: '',
      password: '',
      apiError: false,
      validEmail: false,
      forgotPassword: false,
      error: null
    };

    return obj;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000938ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SignIn.vue
var SignIn_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sign-in"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.forgotPassword ? "Forgot Password" : "Sign In"))])]),_vm._v(" "),(!_vm.forgotPassword)?_c('section',{staticClass:"window__content",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.submit($event)}}},[(_vm.error)?_c('p',{staticClass:"message error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"window__input input input--flow",staticStyle:{"margin-bottom":"1em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input__field",attrs:{"type":"email","placeholder":"What’s your e-mail address?"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"window__input input input--flow",staticStyle:{"margin-bottom":"1em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input__field",attrs:{"type":"password","placeholder":"What's your password?"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('a',{staticStyle:{"text-align":"center"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleForgotPassword($event)}}},[_vm._v("Forgot your password?")])])]):_vm._e(),_vm._v(" "),(_vm.forgotPassword)?_c('section',{staticClass:"window__content",staticStyle:{"padding":"66px 0px"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.submit($event)}}},[(_vm.error)?_c('p',{staticClass:"message error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"window__input input input--flow",staticStyle:{"margin-bottom":"1em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input__field",attrs:{"type":"email","placeholder":"What’s your e-mail address?"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleForgotPassword($event)}}},[_vm._v("Sign in")])])]):_vm._e(),_vm._v(" "),_c('footer',[_c('a',{staticClass:"window__button button button--primary button--expand",class:{ 'button--disabled': _vm.forgotPassword ? !_vm.email : (!_vm.email || !_vm.password) },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[_vm._v("\n      "+_vm._s(_vm.forgotPassword ? "Recover Password" : "Sign In")+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"window__button button button--google--blue button--tertiary button--expand",on:{"click":function($event){$event.preventDefault();_vm.googleSignIn($event)}}},[_vm._v("Sign in With Google")])])])}
var SignIn_staticRenderFns = []
var SignIn_esExports = { render: SignIn_render, staticRenderFns: SignIn_staticRenderFns }
/* harmony default export */ var modals_SignIn = (SignIn_esExports);
// CONCATENATED MODULE: ./src/components/modals/SignIn.vue
var SignIn_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SignIn___vue_template_functional__ = false
/* styles */
var SignIn___vue_styles__ = null
/* scopeId */
var SignIn___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SignIn___vue_module_identifier__ = null
var SignIn_Component = SignIn_normalizeComponent(
  SignIn,
  modals_SignIn,
  SignIn___vue_template_functional__,
  SignIn___vue_styles__,
  SignIn___vue_scopeId__,
  SignIn___vue_module_identifier__
)

/* harmony default export */ var components_modals_SignIn = (SignIn_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/SignUp.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var SignUp_gradePassword = function gradePassword(password) {
  var score = 0;

  var grades = ['very weak', 'weak', 'ok', 'strong', 'very strong', 'very strong'];
  var colors = ['#8B0000', '#FF0000', '#CCCC00', '#83db4c', '#25a11a', '#25a11a'];

  var hasNumbers = /\d/.test(password);
  var hasLowerCase = /[a-z]/.test(password);
  var hasUpperCase = /[A-Z]/.test(password);
  var hasSpecialCharacter = /[^a-z\d]+/i.test(password);
  var hasLength = password.length >= 8;

  if (hasNumbers) ++score;
  if (hasLowerCase) ++score;
  if (hasUpperCase) ++score;
  if (hasSpecialCharacter) ++score;
  if (hasLength) ++score;

  return {
    name: grades[score],
    color: colors[score]
  };
};

var getSignUpState = function getSignUpState() {
  return {
    step: 1,
    email: '',
    name: '',
    password: '',
    confirmPassword: '',
    confirmationCode: '',
    validPassword: false,
    apiError: false,
    validEmail: false,
    emailTaken: false,
    checkingEmailAvailable: false,
    activationCode: '',
    activationCodeError: false,
    pristine: true,
    email_signin: null,
    password_signin: null
  };
};

/* harmony default export */ var SignUp = ({
  name: 'SignUpModal',
  mounted: function mounted() {},

  components: {
    SignIn: components_modals_SignIn,
    Password: components_common_Password
  },
  data: function data() {
    return getSignUpState();
  },

  methods: {
    assignParams: function assignParams(event) {
      if (event.params && event.params.email) {
        this.email = event.params.email;
      }
    },
    hide: function hide() {
      var obj = getSignUpState();
      for (var key in obj) {
        this[key] = obj[key];
      }this.$modal.hide('sign-up');
    },
    submitStepOne: function submitStepOne() {
      if (this.validEmail) {
        this.step = 2;
        this.pristine = true;

        setTimeout(function () {
          this.$refs.name.focus();
        }.bind(this), 10);
      }
    },
    submitStepTwo: function submitStepTwo() {
      if (this.name) {
        this.step = 3;
        this.pristine = true;

        setTimeout(function () {
          this.$refs.password.$refs.input.focus();
        }.bind(this), 10);
      }
    },
    submitStepThree: function submitStepThree() {
      if (this.validPassword && this.password == this.confirmPassword) {
        Object(calls["_12" /* signup */])(this.email, this.password, this.name).then(function (data) {
          this.step = 'confirm';
          this.pristine = true;
          this.userId = data.id;
          /*setTimeout(function(){
            this.$refs.confirm.focus();
          }.bind(this), 100);*/
        }.bind(this));
      }
    },
    submitConfirm: function submitConfirm() {},
    submitStep: function submitStep() {
      if (this.step == 1) {
        this.submitStepOne();
      } else if (this.step == 2) {
        this.submitStepTwo();
      } else if (this.step == 3) {
        this.submitStepThree();
      } else if (this.step == 'confirm') {
        this.submitConfirm();
      }
    },
    submit: function submit() {
      var email_signin = this.email_signin,
          password_signin = this.password_signin;

      src_store.dispatch('login', { email: email_signin, password: password_signin });
    }
  },
  watch: {
    email: EmailField,
    password: function password(newVal, oldVal) {
      this.pristine = false;

      var grade = SignUp_gradePassword(newVal);

      this.passwordGrade = grade.name;
      this.passwordColor = grade.color;

      if (grade.name == 'very strong' || grade.name == 'strong') {
        this.validPassword = true;
      } else {
        this.validPassword = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae65e54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SignUp.vue
var SignUp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"sign-up","height":"auto","width":480,"pivotX":0,"pivotY":.15},on:{"before-open":_vm.assignParams}},[_c('aside',{staticClass:"window sign-up"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v("Create your account")]),_vm._v(" "),(_vm.step == 1 || _vm.step == 2 || _vm.step == 3)?_c('p',{staticClass:"window__description"},[_vm._v("\n        Step "+_vm._s(_vm.step)+" of 3\n      ")]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"window__content",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.submitStep($event)}}},[(_vm.step === 1 && (_vm.emailTaken || _vm.checkingEmailAvailable))?_c('div',{staticStyle:{"clear":"both","padding":"0 0 1.5em 0","line-height":"1.5em","text-align":"center"}},[(_vm.emailTaken)?_c('p',[_vm._v("Sorry, that email address has already been chosen")]):_vm._e(),_vm._v(" "),(_vm.checkingEmailAvailable)?_c('p',[_vm._v("Checking email address availability...")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.step === 1)?_c('div',{staticClass:"window__input input input--flow",class:{ 'input--success': _vm.validEmail, 'input--error': !_vm.pristine && !_vm.validEmail }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input__field",attrs:{"type":"email","placeholder":"What’s your e-mail address?"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',{staticClass:"window__input input input--flow",class:{ 'input--success': _vm.name, 'input--error': !_vm.pristine && !_vm.name }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],ref:"name",staticClass:"input__field",attrs:{"type":"text","placeholder":"What’s your first and last name?"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('div',{staticClass:"input--flow window__input"},[_c('p',{staticStyle:{"margin-bottom":"1em","line-height":"1.5em"}},[_vm._v("Hint: use numbers, uppercase/lowercase letters, and special characters to make a strong password.")]),_vm._v(" "),_c('password',{ref:"password",staticClass:"window__input input--flow",attrs:{"placeholder":"Choose a password","match":null},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('password',{staticClass:"window__input input--flow",attrs:{"placeholder":"Confirm password","match":_vm.password},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1):_vm._e(),_vm._v(" "),(_vm.step === 'confirm')?_c('div',[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v("Now Sign in to the account")])]),_vm._v(" "),_c('section',{staticClass:"window__content",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.submit($event)}}},[_c('div',{staticClass:"window__input input input--flow",staticStyle:{"margin-bottom":"1em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email_signin),expression:"email_signin"}],staticClass:"input__field",attrs:{"type":"email","placeholder":"What’s your e-mail address?"},domProps:{"value":(_vm.email_signin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email_signin=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"window__input input input--flow",staticStyle:{"margin-bottom":"1em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_signin),expression:"password_signin"}],staticClass:"input__field",attrs:{"type":"password","placeholder":"What's your password?"},domProps:{"value":(_vm.password_signin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_signin=$event.target.value}}})]),_vm._v(" "),_c('a',{staticClass:"window__button button button--primary",class:{ 'button--disabled': (!_vm.email_signin || !_vm.password_signin) },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[_vm._v("\n            Sign In\n          ")])])]):_vm._e()]),_vm._v(" "),(_vm.step !== 'confirm')?_c('footer',{staticClass:"window__footer"},[(_vm.step != 'confirm')?_c('a',{staticClass:"window__button button button--primary button--large",class:{ 'button--disabled': (_vm.step == 1 && !_vm.validEmail) || (_vm.step == 2 && !_vm.name) || (_vm.step == 3 && (!_vm.validPassword || _vm.password != _vm.confirmPassword)) },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.submitStep($event)}}},[_vm._v("Next")]):_vm._e(),_vm._v(" "),(_vm.step == 'confirm')?_c('a',{staticClass:"window__button button button--primary button--large",class:{ 'button--disabled': !_vm.confirmationCode },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.submitStep($event)}}},[_vm._v("Confirm")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"window__link link link--secondary",on:{"click":_vm.hide}},[_vm._v("Cancel")])]):_vm._e()])])}
var SignUp_staticRenderFns = []
var SignUp_esExports = { render: SignUp_render, staticRenderFns: SignUp_staticRenderFns }
/* harmony default export */ var modals_SignUp = (SignUp_esExports);
// CONCATENATED MODULE: ./src/components/modals/SignUp.vue
var SignUp_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SignUp___vue_template_functional__ = false
/* styles */
var SignUp___vue_styles__ = null
/* scopeId */
var SignUp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SignUp___vue_module_identifier__ = null
var SignUp_Component = SignUp_normalizeComponent(
  SignUp,
  modals_SignUp,
  SignUp___vue_template_functional__,
  SignUp___vue_styles__,
  SignUp___vue_scopeId__,
  SignUp___vue_module_identifier__
)

/* harmony default export */ var components_modals_SignUp = (SignUp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/Video.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Video = ({
  name: 'Video',
  data: function data() {
    return {
      title: 'Parkave',
      video_url: 'https://www.youtube.com/embed/QBTH4aF9vJ0',
      windowWidth: window.innerWidth
    };
  },

  computed: {
    browserWidth: function browserWidth() {
      return document.body.offsetWidth;
    }
  },
  methods: {
    assignParams: function assignParams(event) {
      this.title = event.params.title;
      this.video_url = event.params.video;
    },
    hide: function hide() {
      this.$modal.hide('video');
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.windowWidth = window.innerWidth;
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5330efca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Video.vue
var Video_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"video","height":"auto","pivotX":_vm.windowWidth > 620 ? 0 : 0.5,"pivotY":.15},on:{"before-open":_vm.assignParams}},[_c('aside',{staticClass:"window window--full-width"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('section',{staticClass:"window__content"},[_c('iframe',{staticClass:"video__player",attrs:{"src":_vm.video_url,"width":_vm.windowWidth > 621 ? 500 : 350,"height":"300px","allowfullscreen":"","frameborder":"0"}})]),_vm._v(" "),_c('footer',{staticClass:"window__footer"},[_c('div',{staticClass:"button button--secondary button--expand",on:{"click":_vm.hide}},[_vm._v("Close Video")])])])])}
var Video_staticRenderFns = []
var Video_esExports = { render: Video_render, staticRenderFns: Video_staticRenderFns }
/* harmony default export */ var modals_Video = (Video_esExports);
// CONCATENATED MODULE: ./src/components/modals/Video.vue
function Video_injectStyle (ssrContext) {
  __webpack_require__("xHUm")
}
var Video_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Video___vue_template_functional__ = false
/* styles */
var Video___vue_styles__ = Video_injectStyle
/* scopeId */
var Video___vue_scopeId__ = "data-v-5330efca"
/* moduleIdentifier (server only) */
var Video___vue_module_identifier__ = null
var Video_Component = Video_normalizeComponent(
  Video,
  modals_Video,
  Video___vue_template_functional__,
  Video___vue_styles__,
  Video___vue_scopeId__,
  Video___vue_module_identifier__
)

/* harmony default export */ var components_modals_Video = (Video_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/FormatDetail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var FormatDetail = ({
  name: 'FormatDetailModal',
  methods: {
    fetchFormat: function fetchFormat(event) {
      this.format = this.$store.getters['formats/formats'].filter(function (format) {
        return parseInt(event.params.id, 10) === format.id;
      })[0];
    },
    beforeClose: function beforeClose(event) {
      this.previousTourStep();
    },
    previousTourStep: function previousTourStep() {
      if (this.$tours['long_tour'].currentStep === 6) {
        this.$tours['long_tour'].previousStep();
      }
    },
    hide: function hide() {
      this.previousTourStep();
      this.$modal.hide('format-detail');
    },
    useFormat: function useFormat() {
      if (this.$tours['long_tour'].currentStep === 6) {
        this.$tours['long_tour'].nextStep();
      }
      this.$modal.hide('format-detail');
      this.$router.push({
        path: '/configuration/' + this.format.id
      });
    }
  },
  data: function data() {
    return {
      format: {
        title: null
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6846e0e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/FormatDetail.vue
var FormatDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"format-detail","height":"auto","width":480,"pivotX":0,"pivotY":.15},on:{"before-open":_vm.fetchFormat,"before-close":_vm.beforeClose}},[_c('aside',{staticClass:"window format-detail"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_c('strong',{staticClass:"window__title__strong"},[_vm._v(_vm._s(_vm.format.name))])]),_c('br'),_vm._v(" "),(_vm.format.premium)?_c('h2',{staticClass:"window__description"},[_c('strong',[_c('i',[_vm._v("Premium Ad Format")])])]):_vm._e()]),_vm._v(" "),_c('footer',{staticClass:"window__footer"},[_c('span',{staticClass:"window__button button button--primary button--large",attrs:{"data-v-long-step":"6"},on:{"click":_vm.useFormat}},[_vm._v("Use format")]),_vm._v(" "),_c('span',{staticClass:"window__link link link--secondary",on:{"click":_vm.hide}},[_vm._v("Cancel")])])])])}
var FormatDetail_staticRenderFns = []
var FormatDetail_esExports = { render: FormatDetail_render, staticRenderFns: FormatDetail_staticRenderFns }
/* harmony default export */ var modals_FormatDetail = (FormatDetail_esExports);
// CONCATENATED MODULE: ./src/components/modals/FormatDetail.vue
var FormatDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FormatDetail___vue_template_functional__ = false
/* styles */
var FormatDetail___vue_styles__ = null
/* scopeId */
var FormatDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FormatDetail___vue_module_identifier__ = null
var FormatDetail_Component = FormatDetail_normalizeComponent(
  FormatDetail,
  modals_FormatDetail,
  FormatDetail___vue_template_functional__,
  FormatDetail___vue_styles__,
  FormatDetail___vue_scopeId__,
  FormatDetail___vue_module_identifier__
)

/* harmony default export */ var components_modals_FormatDetail = (FormatDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/Warning.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Warning = ({
  name: 'Warning',
  methods: {
    assignParams: function assignParams(event) {
      this.callback = event.params.callback;
      this.messageText = event.params.messageText;
      this.buttonText = event.params.buttonText;
    },
    hide: function hide() {
      this.$modal.hide('warning');
    },
    confirm: function confirm() {
      this.$modal.hide('warning');
      this.callback();
    }
  },

  data: function data() {
    return {
      messageText: null,
      buttonText: null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bfd6d08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Warning.vue
var Warning_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"warning","height":"auto","width":480,"pivotX":0,"pivotY":.15},on:{"before-open":_vm.assignParams}},[_c('aside',{staticClass:"window warning-message"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',{staticClass:"window__description"},[_vm._v("\n        "+_vm._s(_vm.messageText)+"\n      ")])]),_vm._v(" "),_c('footer',{staticClass:"window__footer"},[_c('span',{staticClass:"window__button button button--remove button--large",on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.buttonText))]),_vm._v(" "),_c('span',{staticClass:"window__link link link--secondary",on:{"click":_vm.hide}},[_vm._v("Cancel")])])])])}
var Warning_staticRenderFns = []
var Warning_esExports = { render: Warning_render, staticRenderFns: Warning_staticRenderFns }
/* harmony default export */ var modals_Warning = (Warning_esExports);
// CONCATENATED MODULE: ./src/components/modals/Warning.vue
var Warning_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Warning___vue_template_functional__ = false
/* styles */
var Warning___vue_styles__ = null
/* scopeId */
var Warning___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Warning___vue_module_identifier__ = null
var Warning_Component = Warning_normalizeComponent(
  Warning,
  modals_Warning,
  Warning___vue_template_functional__,
  Warning___vue_styles__,
  Warning___vue_scopeId__,
  Warning___vue_module_identifier__
)

/* harmony default export */ var components_modals_Warning = (Warning_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/Pricing.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Pricing = ({
  name: 'Pricing',
  methods: {
    hide: function hide() {
      this.$modal.hide('pricing');
      this.$modal.show('payment-options');
    },
    highlightPlan: function highlightPlan(planName) {
      this.highlighted = planName;
    },
    clearHighlight: function clearHighlight() {
      this.highlighted = null;
    },
    choosePlan: function choosePlan(plan) {
      this.$modal.hide('pricing');
      if (plan.id != 1) {
        this.$modal.show('payment-options', plan);
      }
    },
    togglePlanTerm: function togglePlanTerm() {
      if (this.planTerm == 'month') {
        this.planTerm = 'year';
      } else {
        this.planTerm = 'month';
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['plans', 'planChosen']), {
    getMonthlyPlans: function getMonthlyPlans() {
      var _this = this;

      return this.plans.filter(function (plan) {
        return plan.term == 'month' && plan.id > _this.planChosen.id && plan.short_name !== 'enterprise-monthly';
      });
    },
    getYearlyPlans: function getYearlyPlans() {
      var _this2 = this;

      return this.plans.filter(function (plan) {
        return plan.term == 'year' && plan.id > _this2.planChosen.id && plan.short_name !== 'enterprise-yearly';
      });
    }
  }),
  data: function data() {
    return {
      hoverListener: false,
      highlighted: null,
      planTerm: 'month'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620c434c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Pricing.vue
var Pricing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticStyle:{"overflow-y":"scroll"},attrs:{"name":"pricing","height":"auto","width":850,"pivotX":0,"pivotY":.15}},[_c('aside',{staticClass:"window window--large choose-plan"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v("Choose a plan")])]),_vm._v(" "),_c('div',{staticClass:"button button--secondary button--expand",on:{"click":_vm.togglePlanTerm}},[_vm._v("Toggle Payment Term")]),_vm._v(" "),_c('section',{staticClass:"window__content pricing"},[(_vm.planTerm == 'month')?_c('ul',{staticClass:"pricing__list"},_vm._l((_vm.getMonthlyPlans),function(plan){return _c('li',{staticClass:"pricing__item"},[_c('article',{staticClass:"plan",on:{"click":function($event){_vm.choosePlan(plan)}}},[_c('header',{staticClass:"plan__header"},[_c('h1',{staticClass:"plan__type"},[_vm._v(_vm._s(plan.name))]),_vm._v(" "),_c('h2',{staticClass:"plan__price"},[_c('span',{staticClass:"plan__price__value"},[_c('span',{staticClass:"plan__price__currency"},[_vm._v("$")]),_vm._v(_vm._s(plan.price / 100)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"plan__price__frequency"},[_vm._v("/ month ")])])]),_vm._v(" "),_c('ul',{staticClass:"plan__properties plan__properties--expanded"},_vm._l((plan.properties),function(property){return _c('li',{staticClass:"plan__property"},[_vm._v("\n                "+_vm._s(property)+"\n              ")])}))])])})):_vm._e(),_vm._v(" "),(_vm.planTerm == 'year')?_c('ul',{staticClass:"pricing__list"},_vm._l((_vm.getYearlyPlans),function(plan){return _c('li',{staticClass:"pricing__item"},[_c('article',{staticClass:"plan",on:{"click":function($event){_vm.choosePlan(plan)}}},[_c('header',{staticClass:"plan__header"},[_c('h1',{staticClass:"plan__type"},[_vm._v(_vm._s(plan.name))]),_vm._v(" "),_c('h2',{staticClass:"plan__price"},[_c('span',{staticClass:"plan__price__value"},[_c('span',{staticClass:"plan__price__currency"},[_vm._v("$")]),_vm._v(_vm._s(plan.price / 100)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"plan__price__frequency"},[_vm._v("/ year")])])]),_vm._v(" "),_c('ul',{staticClass:"plan__properties"},_vm._l((plan.properties),function(property){return _c('li',{staticClass:"plan__property"},[_vm._v("\n                "+_vm._s(property)+"\n              ")])}))])])})):_vm._e()]),_vm._v(" "),_c('router-link',{staticClass:"link link--small pricing__link",attrs:{"to":"/quote"},nativeOn:{"click":function($event){_vm.$modal.hide('pricing')}}},[_vm._v("Need more than 10 Users? Apply for an Enterprise Account!")])],1)])}
var Pricing_staticRenderFns = []
var Pricing_esExports = { render: Pricing_render, staticRenderFns: Pricing_staticRenderFns }
/* harmony default export */ var modals_Pricing = (Pricing_esExports);
// CONCATENATED MODULE: ./src/components/modals/Pricing.vue
var Pricing_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Pricing___vue_template_functional__ = false
/* styles */
var Pricing___vue_styles__ = null
/* scopeId */
var Pricing___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Pricing___vue_module_identifier__ = null
var Pricing_Component = Pricing_normalizeComponent(
  Pricing,
  modals_Pricing,
  Pricing___vue_template_functional__,
  Pricing___vue_styles__,
  Pricing___vue_scopeId__,
  Pricing___vue_module_identifier__
)

/* harmony default export */ var components_modals_Pricing = (Pricing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/PaymentOptions.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var PaymentOptions = ({
  name: 'PaymentOptions',
  components: {
    CreditCardForm: components_common_CreditCardForm
  },
  mounted: function mounted() {
    var _this = this;

    this.bus.$on('creditCardEntered', function () {
      _this.billing.dirty = true;
    });

    src_store.subscribe(function (mutation, state) {
      if (state.me.name) this.name = state.me.name;
      if (state.account.id) {
        if (this.coupon) {
          this.billing = _.extend(this.billing, {
            id: state.account.id,
            last4: state.account.card_last_4,
            cardType: state.account.card_type,
            exp: [state.account.card_exp_month, state.account.card_exp_year].join('/')
          });
        } else {
          this.billing = _.extend(this.billing, {
            id: state.account.id,
            plan: state.account.plan,
            plan_id: state.account.plan_id,
            last4: state.account.card_last_4,
            cardType: state.account.card_type,
            exp: [state.account.card_exp_month, state.account.card_exp_year].join('/')
          });
        }
      }
    }.bind(this));

    this.bus.$on('cardValidated', function (token) {
      _this.billing.token = token;
      _this.executeUpdatingAccount();
    });
  },
  data: function data() {
    return {
      bus: new vue_esm["a" /* default */](),
      plan: {},
      billing: {
        plan: {},
        plan_id: null,
        token: null,
        dirty: false,
        last4: null,
        cardType: null,
        newCard: false,
        coupon: null,
        coupon_id: null
      },
      coupon: null
    };
  },

  methods: {
    executeUpdatingAccount: function executeUpdatingAccount() {
      var _this2 = this;

      if (this.coupon && !this.coupon.used && !this.isCouponExpired) {
        this.billing.coupon_id = this.coupon.id;
        this.billing.coupon = this.coupon;
      }

      src_store.dispatch('accounts/update', this.billing).then(function () {
        _this2.$router.push(_this2.$route.path);
        if (_this2.coupon) {
          delete localStorage.coupon_token;
        }
        FS.event('Signed Up', {
          plan_name_str: _this2.billing.plan.name,
          plan_id: _this2.billing.plan_id,
          coupon_code_str: _this2.coupon.token,
          amount_discounted: _this2.coupon.amount_discounted
        });

        if (_this2.isProduction()) {
          var image = document.createElement('img');
          var script = document.createElement('script');
          script.src = 'https://www.dwin1.com/19038.js';
          script.defer = 'defer';
          script.type = 'text/javascript';
          image.src = 'https://www.shareasale.com/sale.cfm?tracking=' + _this2.billing.id + 'p' + _this2.billing.plan_id + 'c' + _this2.billing.coupon_id + '&amount=' + (_this2.billing.plan.price / 100 - _this2.coupon.amount_discounted).toFixed(2) + '&merchantID=97774&transtype=sale';
          image.width = '1';
          image.height = '1';

          document.body.appendChild(image);
          document.body.appendChild(script);
        }
      });
      this.hide();

      setTimeout(function () {
        src_store.dispatch('accounts/loadOwned');
        if (window.afterCompleteBillingModal) window.afterCompleteBillingModal();
      }, 100);
    },
    removeCoupon: function removeCoupon() {
      localStorage.removeItem('coupon_token');
      this.$modal.hide('payment-options');
    },
    assignParams: function assignParams(event) {
      var _this3 = this;

      if (!event.params.id) {
        if (event.params.coupon) {
          Object(calls["Q" /* getPlans */])().then(function (plans) {
            _this3.plan = plans.find(function (plan) {
              return plan.id == event.params.coupon.plan_id;
            });
            _this3.billing.plan = _this3.plan;
            _this3.billing.plan_id = _this3.plan.id;
          });

          this.coupon = event.params.coupon;
        } else {
          Object(calls["Q" /* getPlans */])().then(function (plans) {
            setTimeout(function () {
              _this3.plan = plans.find(function (plan) {
                return plan.short_name == event.params;
              });
              _this3.billing.plan = _this3.plan;
              _this3.billing.plan_id = _this3.plan.id;
            }, 1000);
          });
        }
      } else {
        this.plan = event.params;
        this.billing.plan = this.plan;
        this.billing.plan_id = this.plan.id;
      }
    },
    hide: function hide() {
      this.$modal.hide('payment-options');
    },
    save: function save() {
      if (this.needsCard()) {
        this.bus.$emit('billingFormSaved');
      } else {
        this.executeUpdatingAccount();
      }
    },
    updateCard: function updateCard(e) {
      e.preventDefault();

      this.billing.newCard = true;
    },
    cancelUpdateCard: function cancelUpdateCard(e) {
      e.preventDefault();

      this.billing.newCard = false;
    },
    needsCard: function needsCard() {
      return !this.billing.id || this.billing.newCard || !this.billing.cardType;
    }
  },
  computed: {
    isCouponExpired: function isCouponExpired() {
      return new Date(this.coupon.expiration_date).getTime() < new Date().getTime();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d1ebcb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PaymentOptions.vue
var PaymentOptions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"payment-options","height":"auto","width":600,"pivotX":0,"pivotY":.15},on:{"before-open":_vm.assignParams}},[_c('aside',{staticClass:"window payment-options"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v("Payment options")]),_vm._v(" "),_c('p',{staticClass:"window__description window__description--active"},[(_vm.coupon && !_vm.coupon.used && !_vm.isCouponExpired)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("Active Coupon")]):_vm._e(),_vm._v(" "),(_vm.coupon && _vm.coupon.used && !_vm.isCouponExpired)?_c('span',[_vm._v("Coupon has been used already "),_c('br'),_vm._v(" You can still sign up at regular price below")]):_vm._e(),_vm._v(" "),(_vm.coupon && !_vm.coupon.used && _vm.isCouponExpired)?_c('span',[_vm._v("Coupon Expired")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"window__description"},[_vm._v("\n        "+_vm._s(_vm.plan.name)+" Plan "),_c('br'),_vm._v(" "),_c('span',{class:{'window__description--strikethrough': _vm.coupon && !_vm.coupon.used && !_vm.isCouponExpired}},[_vm._v("($"+_vm._s(_vm.plan.price / 100)+" billed "+_vm._s(_vm.plan.term)+"ly)")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.coupon && !_vm.coupon.used && !_vm.isCouponExpired)?_c('span',[_vm._v("($"+_vm._s((_vm.plan.price / 100) - _vm.coupon.amount_discounted)+" billed "+_vm._s(_vm.plan.term)+"ly)")]):_vm._e()])]),_vm._v(" "),_c('section',{staticClass:"window__content"},[_c('section',{staticClass:"card-select"},[_c('section',{staticClass:"card-select__panels"},[(_vm.needsCard())?_c('credit-card-form',{staticStyle:{"margin":"1em"},attrs:{"bus":_vm.bus}}):_vm._e(),_vm._v(" "),(_vm.billing.newCard && _vm.billing.last4)?_c('a',{staticClass:"button button--secondary add-card-btn",attrs:{"href":"#"},on:{"click":_vm.cancelUpdateCard}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.billing.id && !_vm.billing.newCard && _vm.billing.cardType)?_c('div',{staticStyle:{"min-width":"450px","text-align":"right"}},[_c('span',{staticStyle:{"margin-right":"1em","display":"inline-block"}},[_vm._v(_vm._s(_vm.billing.cardType)+" ending in "+_vm._s(_vm.billing.last4)+" and expiring on "+_vm._s(_vm.billing.exp))]),_vm._v(" "),_c('a',{staticClass:"button button--secondary",staticStyle:{"display":"inline-block"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.updateCard($event)}}},[_vm._v("Update")])]):_vm._e()],1)])]),_vm._v(" "),_c('footer',{staticClass:"window__footer"},[_c('a',{staticClass:"window__button button button--primary button--large",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.save($event)}}},[_vm._v(_vm._s(_vm.needsCard() ? "Add Card" : "Confirm"))]),_vm._v(" "),_c('small',{staticClass:"form__item__description clickable",on:{"click":_vm.removeCoupon}},[_vm._v("Don't show again")]),_vm._v(" "),_c('figure',{staticClass:"secure"},[_c('figcaption',{staticClass:"secure__label"},[_vm._v("Connection is private")])])])])])}
var PaymentOptions_staticRenderFns = []
var PaymentOptions_esExports = { render: PaymentOptions_render, staticRenderFns: PaymentOptions_staticRenderFns }
/* harmony default export */ var modals_PaymentOptions = (PaymentOptions_esExports);
// CONCATENATED MODULE: ./src/components/modals/PaymentOptions.vue
function PaymentOptions_injectStyle (ssrContext) {
  __webpack_require__("LxJn")
}
var PaymentOptions_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PaymentOptions___vue_template_functional__ = false
/* styles */
var PaymentOptions___vue_styles__ = PaymentOptions_injectStyle
/* scopeId */
var PaymentOptions___vue_scopeId__ = "data-v-75d1ebcb"
/* moduleIdentifier (server only) */
var PaymentOptions___vue_module_identifier__ = null
var PaymentOptions_Component = PaymentOptions_normalizeComponent(
  PaymentOptions,
  modals_PaymentOptions,
  PaymentOptions___vue_template_functional__,
  PaymentOptions___vue_styles__,
  PaymentOptions___vue_scopeId__,
  PaymentOptions___vue_module_identifier__
)

/* harmony default export */ var components_modals_PaymentOptions = (PaymentOptions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/ExportAd.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var ExportAd_util = __webpack_require__("CPGk");

/* harmony default export */ var ExportAd = ({
  name: 'ExportAdModal',
  props: ['code', 'share_url', 'banner'],

  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.windowWidth = window.innerWidth;
    };
  },

  methods: {
    assignParams: function assignParams(event) {
      this.banner = event.params;
      this.banner.inputs = this.inputs = this.banner.json;
      this.banner.code = window.ParkAve.getTag(this.banner);
      if (this.banner.share_code) {
        this.banner.share_url = ExportAd_util.baseUrl('/configuration/' + this.banner.format_id + '/' + this.banner.id + '/?share_code=' + this.banner.share_code || '');
      }

      this.zip_url = ExportAd_util.apiBaseUrl('/advertisements/' + this.banner.id + '/zip?id=' + this.banner.id);

      this.share_url = this.banner.share_url;
      this.code = this.banner.code;
      this.name = this.banner.name;
      this.formatName = this.banner.format_id;
    },
    hide: function hide() {
      this.$modal.hide('export-ad');
    },
    onCopy: function onCopy() {
      var rootVM = window.rootVM;
      rootVM.$snotify.success('Copied');
    },
    onError: function onError(e) {},
    shareAd: function shareAd() {
      var share_url = this.share_url;
      this.$modal.show('userinput', {
        modalTitle: 'Share Advertisement',
        messageText: 'Enter the email of the user you want to share this ad with: ',
        fieldType: 'email',
        fieldPlaceholder: 'example@parkave.com',
        buttonText: 'Share Ad',
        callback: function callback(value) {
          this.$modal.hide('userinput');
          store.dispatch('advertisements/share', { email: value, url: share_url });
        }
      });
    },
    upgradeAccount: function upgradeAccount() {
      this.hide();
      this.$modal.show('pricing', this.plans);
    },
    publicPreview: function publicPreview() {
      this.hide();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['plans']), {
    getFormatId: function getFormatId() {
      if (this.banner) {
        return this.banner.format_id;
      } else {
        return null;
      }
    },
    getPlacementId: function getPlacementId() {
      if (this.banner) {
        return this.banner.placement_id;
      } else {
        return null;
      }
    },
    isFormatUpdateable: function isFormatUpdateable() {
      var format = void 0;
      var formats = this.$store.getters['formats/formats'];
      for (var i = 0; i < formats.length; i++) {
        if (formats[i].id == this.banner.format_id) {
          format = formats[i];
        }
      }
      return format.updateable;
    },
    getformatName: function getformatName() {
      var formats = this.$store.getters['formats/formats'];
      for (var i = 0; i < formats.length; i++) {
        if (formats[i].id == this.formatName) {
          this.formatName = formats[i].name;
        }
      }
      return this.formatName;
    },
    isInPageAd: function isInPageAd() {
      if (this.inputs.size) {
        return true;
      } else {
        return false;
      }
    }
  }),
  data: function data() {
    var obj = {
      inputs: {},
      name: '',
      formatName: '',
      windowWidth: window.innerWidth
    };
    return obj;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d64c9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ExportAd.vue
var ExportAd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"export-ad","height":"auto","width":880,"pivotX":_vm.windowWidth > 970 ? 0 : 0.5,"pivotY":.15},on:{"before-open":_vm.assignParams}},[_c('aside',{staticClass:"window window--large window--padding-less export-ad"},[_c('section',{staticClass:"window__content window__content--two-columns"},[_c('aside',{staticClass:"window__side"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v("Export creative")]),_vm._v(" "),_c('h2',{staticClass:"window__description"},[_c('span',{staticClass:"window__description__prefix"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" - "+_vm._s(_vm.getformatName))])]),_vm._v(" "),_c('section',{staticClass:"export"},[_c('select',{staticClass:"export__select select",staticStyle:{"display":"none"}},[_c('option',{staticClass:"select__option",attrs:{"value":""}},[_vm._v("Fixed (300x250)")]),_vm._v(" "),_c('option',{staticClass:"select__option",attrs:{"value":""}},[_vm._v("Fixed (300x600)")]),_vm._v(" "),_c('option',{staticClass:"select__option",attrs:{"value":""}},[_vm._v("Fixed (728x90)")]),_vm._v(" "),_c('option',{staticClass:"select__option",attrs:{"value":""}},[_vm._v("Fixed (800x600)")]),_vm._v(" "),_c('option',{staticClass:"select__option",attrs:{"value":""}},[_vm._v("Fixed (970x250)")]),_vm._v(" "),_c('option',{staticClass:"select__option",attrs:{"value":""}},[_vm._v("Flexible (4:1)")])]),_vm._v(" "),(_vm.isInPageAd)?_c('div',[_c('router-link',{staticClass:"export__link link link--small",attrs:{"to":{ path: '/clientpreview', query: { format_id: _vm.getFormatId, placement_id: _vm.getPlacementId }}},nativeOn:{"click":function($event){_vm.publicPreview($event)}}},[_vm._v("Client Preview Page")]),_vm._v(" | "),_c('a',{staticClass:"export__link link link--small",attrs:{"href":_vm.zip_url,"target":"_blank"}},[_vm._v("Download as Zip")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"export__input input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],ref:"code",staticClass:"export__input__field input__field",attrs:{"readonly":""},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})]),_vm._v(" "),_c('a',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.code),expression:"code",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"export__link link link--small",attrs:{"href":"#"}},[_vm._v("Copy Embed Code to Clipboard")]),_vm._v(" "),(_vm.share_url && _vm.banner && !_vm.banner.update_rule_id && !_vm.isFormatUpdateable)?_c('div',[_c('div',{staticClass:"export__input input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.share_url),expression:"share_url"}],ref:"share",staticClass:"export__input__field export__share__field input__field",attrs:{"readonly":""},domProps:{"value":(_vm.share_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.share_url=$event.target.value}}})]),_vm._v(" "),_c('a',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.share_url),expression:"share_url",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"export__link link link--small",attrs:{"href":"#"}},[_vm._v("Copy Share and Edit Link to Clipboard")]),_vm._v(" "),_c('a',{staticClass:"export__button button button--ghost",attrs:{"href":"#"},on:{"click":_vm.shareAd}},[_vm._v("Share Ad via Email")])]):_vm._e(),_vm._v(" "),(!_vm.share_url && _vm.banner && !_vm.banner.update_rule_id)?_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"export__input input"},[_c('div',{staticClass:"window__description"},[_vm._v("Want to share the ad? "),_c('br'),_vm._v(" "),_c('a',{staticClass:"export__link link",attrs:{"href":"#"},on:{"click":_vm.upgradeAccount}},[_vm._v("Upgrade your account")]),_vm._v(" Allow other users to edit your ad via a share link!")])])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"export__button button button--primary button--expand",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.hide($event)}}},[_vm._v("I'm done here")])])]),_vm._v(" "),_c('section',{staticClass:"window__preview"},[_c('div',{staticClass:"window__preview__inner"},[_c('preview-settings',{attrs:{"ad":_vm.banner,"inputs":_vm.inputs}})],1)])])])])}
var ExportAd_staticRenderFns = []
var ExportAd_esExports = { render: ExportAd_render, staticRenderFns: ExportAd_staticRenderFns }
/* harmony default export */ var modals_ExportAd = (ExportAd_esExports);
// CONCATENATED MODULE: ./src/components/modals/ExportAd.vue
var ExportAd_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExportAd___vue_template_functional__ = false
/* styles */
var ExportAd___vue_styles__ = null
/* scopeId */
var ExportAd___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExportAd___vue_module_identifier__ = null
var ExportAd_Component = ExportAd_normalizeComponent(
  ExportAd,
  modals_ExportAd,
  ExportAd___vue_template_functional__,
  ExportAd___vue_styles__,
  ExportAd___vue_scopeId__,
  ExportAd___vue_module_identifier__
)

/* harmony default export */ var components_modals_ExportAd = (ExportAd_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/UserInput.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UserInput = ({
  name: 'UserInput',
  methods: {
    assignParams: function assignParams(event) {
      this.callback = event.params.callback;
      this.messageText = event.params.messageText;
      this.buttonText = event.params.buttonText;
      this.fieldType = event.fieldType;
      this.fieldPlaceholder = event.params.fieldPlaceholder;
      this.modalTitle = event.params.modalTitle;
    },
    hide: function hide() {
      this.$modal.hide('userinput');
    },
    confirm: function confirm() {
      this.$modal.hide('userinput');
      this.callback(this.fieldValue);
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.windowWidth = window.innerWidth;
    };
  },
  data: function data() {
    return {
      messageText: null,
      buttonText: null,
      fieldType: null,
      fieldPlaceholder: null,
      modalTitle: null,
      fieldValue: '',
      windowWidth: window.innerWidth
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af032682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/UserInput.vue
var UserInput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"userinput","height":"auto","width":480,"pivotX":_vm.windowWidth > 550 ? 0 : 0.5,"pivotY":.15},on:{"before-open":_vm.assignParams}},[_c('aside',{staticClass:"window warning-message"},[_c('header',{staticClass:"window__header"},[_c('h1',{staticClass:"window__title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('p',{staticClass:"window__description"},[_vm._v("\n        "+_vm._s(_vm.messageText)+"\n      ")])]),_vm._v(" "),_c('section',{staticClass:"window__content"},[_c('div',{staticClass:"window__input input input--flow"},[((_vm.fieldType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],staticClass:"input__field",attrs:{"placeholder":_vm.fieldPlaceholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.fieldValue)?_vm._i(_vm.fieldValue,null)>-1:(_vm.fieldValue)},on:{"change":function($event){var $$a=_vm.fieldValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.fieldValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.fieldValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.fieldValue=$$c}}}}):((_vm.fieldType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],staticClass:"input__field",attrs:{"placeholder":_vm.fieldPlaceholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.fieldValue,null)},on:{"change":function($event){_vm.fieldValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],staticClass:"input__field",attrs:{"placeholder":_vm.fieldPlaceholder,"type":_vm.fieldType},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}})])]),_vm._v(" "),_c('footer',{staticClass:"window__footer"},[_c('span',{staticClass:"window__button button button--primary button--large",on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.buttonText))]),_vm._v(" "),_c('span',{staticClass:"window__link link link--secondary",on:{"click":_vm.hide}},[_vm._v("Cancel")])])])])}
var UserInput_staticRenderFns = []
var UserInput_esExports = { render: UserInput_render, staticRenderFns: UserInput_staticRenderFns }
/* harmony default export */ var modals_UserInput = (UserInput_esExports);
// CONCATENATED MODULE: ./src/components/modals/UserInput.vue
var UserInput_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var UserInput___vue_template_functional__ = false
/* styles */
var UserInput___vue_styles__ = null
/* scopeId */
var UserInput___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserInput___vue_module_identifier__ = null
var UserInput_Component = UserInput_normalizeComponent(
  UserInput,
  modals_UserInput,
  UserInput___vue_template_functional__,
  UserInput___vue_styles__,
  UserInput___vue_scopeId__,
  UserInput___vue_module_identifier__
)

/* harmony default export */ var components_modals_UserInput = (UserInput_Component.exports);

// EXTERNAL MODULE: ./src/assets/logo-parkave-light.png
var logo_parkave_light = __webpack_require__("OnRi");
var logo_parkave_light_default = /*#__PURE__*/__webpack_require__.n(logo_parkave_light);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/Intersection.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var hideModal = function hideModal() {
  this.$modal.hide('intersection');
};

/* harmony default export */ var Intersection = ({
  name: 'Intersection',
  components: {
    signIn: components_modals_SignIn
  },
  methods: {
    hide: function hide() {
      hideModal.call(this);
    },
    showSignIn: function showSignIn() {
      hideModal.call(this);
      this.$modal.show('sign-in');
    },
    showSignUp: function showSignUp() {
      hideModal.call(this);
      this.gtag_click();
      this.$modal.show('sign-up');
    },
    doGoogleSignUp: function doGoogleSignUp(e) {
      e.preventDefault();
      this.gtag_click();
      oauthLogin('google', true);
    },
    gtag_click: function gtag_click(url) {
      var callback = function callback() {
        if (typeof url != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
        'send_to': 'AW-1005669616/Xdc2CPya6eMBEPCZxd8D',
        'event_callback': callback
      });
      return false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.windowWidth = window.innerWidth;
    };
  },
  data: function data() {
    return {
      image: logo_parkave_light_default.a,
      windowWidth: window.innerWidth
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aad573a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Intersection.vue
var Intersection_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"intersection","height":"auto","width":850,"pivotX":_vm.windowWidth > 900 ? 0 : 0.5,"pivotY":.15}},[_c('section',{staticClass:"intersection intersection__twocolumns"},[_c('div',{staticClass:"close-button",on:{"click":_vm.hide}}),_vm._v(" "),_c('aside',{staticClass:"window window__content window__content--dark"},[_c('header',{staticClass:"window__header"},[_c('figure',{staticClass:"intersection__logo"},[_c('img',{staticClass:"intersection__logo__source",attrs:{"src":_vm.image}})]),_vm._v(" "),_c('h1',{staticClass:"window__title"},[_vm._v("Sell something new")]),_vm._v(" "),_c('p',{staticClass:"window__description"},[_vm._v("\n          Built for digital advertising salespeople. High impact and low cost display advertising that will impress your clients and boost renewals.\n        ")])]),_vm._v(" "),_c('footer',[_c('a',{staticClass:"window__button button button--primary button--expand",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showSignUp($event)}}},[_vm._v("Don't have an account? Sign up")]),_vm._v(" "),_c('a',{staticClass:"window__button button button--tertiary button--expand button--google",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.doGoogleSignUp($event)}}},[_vm._v("Sign Up with Google")])])]),_vm._v(" "),_c('aside',{staticClass:"window window__content"},[_c('sign-in')],1)])])}
var Intersection_staticRenderFns = []
var Intersection_esExports = { render: Intersection_render, staticRenderFns: Intersection_staticRenderFns }
/* harmony default export */ var modals_Intersection = (Intersection_esExports);
// CONCATENATED MODULE: ./src/components/modals/Intersection.vue
var Intersection_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Intersection___vue_template_functional__ = false
/* styles */
var Intersection___vue_styles__ = null
/* scopeId */
var Intersection___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Intersection___vue_module_identifier__ = null
var Intersection_Component = Intersection_normalizeComponent(
  Intersection,
  modals_Intersection,
  Intersection___vue_template_functional__,
  Intersection___vue_styles__,
  Intersection___vue_scopeId__,
  Intersection___vue_module_identifier__
)

/* harmony default export */ var components_modals_Intersection = (Intersection_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var App = ({
  name: 'app',
  components: {
    SignUpModal: components_modals_SignUp,
    FormatDetailModal: components_modals_FormatDetail,
    WarningModal: components_modals_Warning,
    PricingModal: components_modals_Pricing,
    PaymentOptionsModal: components_modals_PaymentOptions,
    ExportAdModal: components_modals_ExportAd,
    IntersectionModal: components_modals_Intersection,
    UserInputModal: components_modals_UserInput,
    VideoModal: components_modals_Video
  },
  created: function created() {
    window.rootVM = this;
    Object(integration["a" /* allowBoostrapCall */])();
    var matches = location.hash.match(/p=([\w\.\/\%]+)/);
    if (matches) {
      var p = decodeURIComponent(matches[1]);
      p = p.split('/');
      this.$router.push('/configuration/' + p[1] + '/' + p[2]);
    }
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key == "Escape" || evt.key == "Esc";
      } else {
        isEscape = evt.keyCode == 27;
      }
      if (isEscape) {
        Object(integration["b" /* close */])();
      }
    };
  },

  methods: {
    show: function show(name) {
      this.$modal.show(name);
    },
    onStopHomeTour: function onStopHomeTour() {
      var payload = {
        name: 'home_tour',
        value: 'finished'
      };
      if (this.$tours['home_tour'].currentStep === this.$tours['home_tour'].steps.length - 1) {
        this.updatePreferences(payload);
      }
    },
    onStopConfigTour: function onStopConfigTour() {
      var payload = {
        name: 'ad_creation_tour',
        value: 'finished'
      };
      if (this.$tours['config_tour'].currentStep === this.$tours['config_tour'].steps.length - 1) {
        this.updatePreferences(payload);
      }
    },
    updatePreferences: function updatePreferences(payload) {
      this.$store.dispatch('updatePreferences', { userId: this.$store.state.me.id, payload: payload });
    },
    addUserToAccount: function addUserToAccount() {
      this.$store.dispatch('addUserToAccount', { token: localStorage.account_token });
    }
  },
  data: function data() {
    return {
      homeCallbacks: {
        onStop: this.onStopHomeTour
      },
      configCallbacks: {
        onStop: this.onStopConfigTour
      },
      home_tour_steps: [{
        target: '[data-v-home-step="0"]',
        content: 'Welcome to ParkAve! <br> Let\'s take a quick tour.'
      }, {
        target: '[data-v-home-step="1"]',
        content: 'ParkAve is all about easy-to-create banner formats that advertisers love.',
        params: {
          placement: 'bottom'
        }
      }, {
        target: '[data-v-home-step="3"]',
        content: 'Click here to build a creative ...',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-home-step="4"]',
        content: '... and click here to see an example of that creative.',
        params: {
          placement: 'bottom'
        }
      }, {
        target: '[data-v-home-step="5"]',
        content: 'All of your ads are saved and viewable here.',
        params: {
          placement: 'bottom'
        }
      }],
      config_tour_steps: [{
        target: '[data-v-config-step="0"]',
        content: 'This is where you can configure your creative.',
        params: {
          placement: 'bottom'
        }
      }, {
        target: '[data-v-config-step="1"]',
        content: 'Change the content of the creative by customizing these fields.',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-config-step="3"]',
        content: 'This is a live preview of your creative — it updates while you\'re editing.',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-config-step="4"]',
        content: 'You can preview the ad in different sizes here.',
        params: {
          placement: 'bottom'
        }
      }],
      long_tour_steps: [{
        target: '[data-v-long-step="0"]',
        content: 'Welcome to ParkAve! <br> Let\'s show you around!'
      }, {
        target: '[data-v-long-step="1"]',
        content: 'ParkAve has a massive list of <br> innovative ad formats to choose from.',
        params: {
          placement: 'bottom'
        }
      }, {
        target: '[data-v-long-step="2"]',
        content: 'You can access your account settings and <br> switch between your accounts from this <br> dropdown menu.',
        params: {
          placement: 'bottom'
        }
      }, {
        target: '[data-v-long-step="3"]',
        content: 'Here is one of the ad formats <br> you have the ability of creating.',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-long-step="4"]',
        content: 'The <strong>View Demo</strong> button shows useful <br> information and a media kit for the format.',
        params: {
          placement: 'bottom'
        }
      }, {
        target: '[data-v-long-step="5"]',
        content: 'Click Here to start <br> creating a format and to continue the tour!',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-long-step="6"]',
        content: 'Keep Going!',
        params: {
          placement: 'right'
        }
      }, {
        target: '[data-v-long-step="7"]',
        content: 'This is the config <br> where you can customize the ad to your liking',
        params: {
          placement: 'bottom'
        }
      }, {
        target: '[data-v-long-step="8"]',
        content: 'These are the custom fields <br> you can use to change the ad.',
        params: {
          placement: 'top'
        }
      }]
    };
  },

  beforeCreate: function beforeCreate() {
    if (this.$route.query.invite) {
      localStorage.account_token = this.$route.query.invite;
    }
    if (this.$route.query.signup_token) {
      localStorage.signup_token = this.$route.query.signup_token;
    }
    if (this.$route.query.password) {
      localStorage.password_token = this.$route.query.password;
    }
    if (this.$route.query.coupon) {
      localStorage.coupon_token = this.$route.query.coupon;
    }
    if (this.$route.query.update_confirmation) {
      localStorage.update_confirmation = this.$route.query.update_confirmation;
    }
    if (this.$route.query.update_request_approval) {
      localStorage.update_request_approval = this.$route.query.update_request_approval;
    }
    if (this.$route.query.update_request_denial) {
      localStorage.update_request_denial = this.$route.query.update_request_denial;
    }
    if (this.$route.query.referral) {
      localStorage.parkave_referral_code = this.$route.query.referral;
    }
    if (this.$route.query.partner) {
      localStorage.parkave_partner_code = this.$route.query.partner;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.auto_signup) {
      var email = this.$route.query.auto_signup;
      router.replace(extends_default()({}, router.currentRoute, {
        query: {
          auto_signup: undefined
        }
      }));
      this.$modal.show('sign-up', { email: email });
    }
    if (localStorage.account_token || this.$route.query.invite) {
      if (!localStorage.token) {
        this.$modal.show('intersection');
      }
    }
    if (localStorage.parkave_referral_code) {
      router.replace(extends_default()({}, router.currentRoute, {
        query: {
          parkave_referral_code: undefined
        }
      }));
      if (!localStorage.token) {
        this.$modal.show('intersection');
      }
    }
    if (localStorage.signup_token) {
      this.$store.dispatch('verifySignUp', { token: localStorage.signup_token });
    }
    if (localStorage.password_token) {
      this.$store.dispatch('users/verifyPassword', { token: localStorage.password_token });
    }
    if (localStorage.update_confirmation) {
      this.$store.dispatch('updates/confirm', { token: localStorage.update_confirmation });
    }
    if (localStorage.update_request_approval) {
      this.$store.dispatch('updates/approve', { token: localStorage.update_request_approval });
    }
    if (localStorage.update_request_denial) {
      this.$store.dispatch('updates/deny', { token: localStorage.update_request_denial });
    }
    if (this.$route.query.register) {
      if (localStorage.account_id && localStorage.token) {
        this.$modal.show('payment-options', this.$route.query.register);
      } else {
        this.$modal.show('intersection');
      }
    }
    if (this.$route.path == '/pricing') {
      if (localStorage.account_id && localStorage.token) {
        this.$modal.show('pricing');
      } else {
        this.$modal.show('intersection');
      }
    }
    if (localStorage.coupon_token) {
      if (!localStorage.account_id) {
        this.$modal.show('intersection');
      } else {
        this.$store.dispatch('coupons/getActive', localStorage.coupon_token).then(function (coupon) {
          // Remove coupon from localstorage if the coupon doesn't exist
          if (!coupon) {
            localStorage.removeItem('coupon_token');
            _this.$modal.hide('payment-options');
          }
        });
      }
    }
  },

  computed: {
    user_id: function user_id() {
      return this.$store.state.me.id;
    },
    darkMode: function darkMode() {
      return this.$route.name !== 'Demo' && this.$route.name !== 'EnterpriseForm' && this.$route.name !== 'UpdateSuccess';
    },
    account: function account() {
      return this.$store.state.account.id;
    }
  },
  watch: {
    'user_id': {
      handler: function handler(newVal) {
        if (newVal) {
          // check if userid is available
          if (localStorage.account_token) {
            this.addUserToAccount();
          }
        }
      },

      immediate: true // make this watch function is called when component created
    },
    'account': {
      handler: function handler(newVal) {
        var _this2 = this;

        if (this.$route.query.register) {
          this.$modal.hide('payment-options');
          this.$modal.hide('intersection');
          if (localStorage.account_id && localStorage.token) {
            this.$modal.show('payment-options', this.$route.query.register);
          } else {
            this.$modal.show('intersection');
          }
        }
        if (this.$route.path == '/pricing') {
          this.$modal.hide('pricing');
          this.$modal.hide('intersection');
          if (localStorage.account_id && localStorage.token) {
            this.$modal.show('pricing');
          } else {
            this.$modal.show('intersection');
          }
        }
        if (localStorage.coupon_token) {
          // this.$modal.hide('payment-options');
          // this.$modal.hide('intersection');
          if (localStorage.account_id && localStorage.token) {
            this.$modal.hide('intersection');
            this.$store.dispatch('coupons/getActive', localStorage.coupon_token).then(function (coupon) {
              _this2.$modal.show('payment-options', { coupon: coupon });
            });
          } else {
            this.$modal.show('intersection');
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c66b23b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ standalone: _vm.isAppStandalone() },attrs:{"id":"app"}},[_c('sign-up-modal'),_vm._v(" "),_c('video-modal'),_vm._v(" "),_c('format-detail-modal'),_vm._v(" "),_c('warning-modal'),_vm._v(" "),_c('pricing-modal'),_vm._v(" "),_c('intersection-modal'),_vm._v(" "),_c('payment-options-modal'),_vm._v(" "),_c('export-ad-modal'),_vm._v(" "),_c('user-input-modal'),_vm._v(" "),_c('vue-snotify'),_vm._v(" "),_c('main',{class:{'main-view': _vm.darkMode,'main-view--dark-mode': _vm.darkMode},attrs:{"role":"main"}},[_c('main-navigation'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('main-footer')],1),_vm._v(" "),_c('v-tour',{staticStyle:{"z-index":"10000","position":"relative"},attrs:{"name":"long_tour","steps":_vm.long_tour_steps}}),_vm._v(" "),_c('v-tour',{attrs:{"name":"home_tour","steps":_vm.home_tour_steps,"callbacks":_vm.homeCallbacks}}),_vm._v(" "),_c('v-tour',{staticStyle:{"z-index":"10000","position":"relative"},attrs:{"name":"config_tour","steps":_vm.config_tour_steps,"callbacks":_vm.configCallbacks}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("mmEW")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-js-modal/dist/index.js
var dist = __webpack_require__("rifk");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/@sentry/vue/esm/index.js + 39 modules
var esm = __webpack_require__("B3+F");

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/index.js + 20 modules
var tracing_esm = __webpack_require__("D3zA");

// EXTERNAL MODULE: ./node_modules/vue-snotify/vue-snotify.esm.js
var vue_snotify_esm = __webpack_require__("HgYs");

// EXTERNAL MODULE: ./node_modules/vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("wvfG");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// EXTERNAL MODULE: ./node_modules/vue-tour/dist/vue-tour.umd.js
var vue_tour_umd = __webpack_require__("pvO8");
var vue_tour_umd_default = /*#__PURE__*/__webpack_require__.n(vue_tour_umd);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__webpack_require__("iq7p");

vue_esm["a" /* default */].use(vue_tour_umd_default.a);

__webpack_require__("Ulv0");
__webpack_require__("cX0o");
//require('./../../parkave-integration/src/lib/parkave')

vue_esm["a" /* default */].use(dist_default.a);

var snotifyOptions = {
  toast: {
    position: vue_snotify_esm["a" /* SnotifyPosition */].rightTop
  }
};

vue_esm["a" /* default */].use(vue_snotify_esm["b" /* default */], snotifyOptions);
vue_esm["a" /* default */].use(vue_clipboard_default.a);

vue_esm["a" /* default */].config.productionTip = false;

src_store.dispatch('loadConfig').then(function (config) {
  console.log('Got config', config);
  window.parkave_config = config;
});

src_store.dispatch('loadMe').then(function (me) {
  // helpscout
  if (me.confirmed == false) {
    var rootVM = window.rootVM;
    rootVM.$snotify.info('You email hasn\'t been confirmed! Click here to resend the welcome email.', {
      timeout: 4000,
      buttons: [{
        text: 'Close',
        bold: true
      }, {
        text: 'Resend',
        bold: true,
        action: function action() {
          Object(calls["_12" /* signup */])(me.email, null, null).then(function (response) {
            if (!response.error) {
              rootVM.$snotify.success('Email sent.');
            } else {
              rootVM.$snotify.error(response.error);
            }
          });
        }
      }],
      showProgressBar: false,
      closeOnClick: true
    });
  }

  if (!me.id) return;
  src_store.dispatch('accounts/loadOwned').then(function (account) {
    if (!account) return;

    if (localStorage.parkave_partner_code && !account.referred_by_code) {
      var payload = {
        referred_by_code: localStorage.parkave_partner_code,
        id: account.id,
        skipSuccessMessage: true
      };
      src_store.dispatch('accounts/update', payload);
      localStorage.removeItem('parkave_partner_code');
    }
    if (account.plan.show_beacon_docs && window.innerWidth > 600) {
      window.Beacon('init', '4aa33787-aa7b-406f-89f8-b764dfd6ad3b');
    }
    var mode = 'neutral';
    var messagingEnabled = false;
    if (!account.plan.is_supported) {
      mode = 'selfService';
    } else if (account.plan.is_supported) {
      mode = 'askFirst';
      messagingEnabled = true;
    }
    if (me.email && window.Beacon && window.innerWidth > 600) {
      window.Beacon("identify", {
        name: me.name,
        email: me.email,
        account: account.name,
        plan: account.plan.name
      });
      // This is an example script - don't forget to change it!
      FS.identify(me.id, {
        displayName: me.name,
        email: me.email,
        plan_name_str: account.plan.name,
        plan_id: account.plan.id,
        account_name_str: account.name,
        account_id: account.id
      });
      window.Beacon('config', {
        labels: {
          messageConfirmationText: 'You’ll receive an email reply shortly.'
        },
        messagingEnabled: messagingEnabled,
        color: '#ffffff', // Blue: 0051FF
        mode: mode
      });
    }

    if (account.has_selected_formats) {
      src_store.dispatch('formats/loadSelected');
    }
    src_store.dispatch('advertisements/load');
    src_store.dispatch('loadPreferences');
    src_store.dispatch('users/loadFavorites');
  });
});

src_store.dispatch('categories/load');
src_store.dispatch('formats/load');
src_store.dispatch('categories/formats/load');
src_store.dispatch('loadPlans');
src_store.dispatch('loadAdminDeMocker');

window.store = src_store;

esm["a" /* init */]({
  Vue: vue_esm["a" /* default */],
  dsn: 'https://66d3f06722d04dd2baa091e1a4b7a389@o989201.ingest.sentry.io/5983300'
  // integrations: [
  //   new Integrations.BrowserTracing({
  //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
  //     tracingOrigins: ['localhost', 'app.getparkave.com', /^\//],
  //   }),
  // ],
  // // Set tracesSampleRate to 1.0 to capture 100%
  // // of transactions for performance monitoring.
  // // We recommend adjusting this value in production
  // tracesSampleRate: 1.0
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  render: function render(h) {
    return h(src_App);
  },
  store: src_store,
  router: router,
  template: '<App/>',
  components: { App: src_App },
  data: {
    ParkAve: ParkAve
  }
}).$mount('#app');

/*new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  data: {
    ParkAve
  }
})*/



/***/ }),

/***/ "OAu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_http_otro__ = __webpack_require__("F10C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_http_otro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_http_otro__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_http_otro__, "response")) __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_http_otro__["response"]; });


var apiURL = "https://api.getparkave.com/" || '/';
window.parkave_api_url = apiURL;


var clientConfig = {
  host: apiURL,
  transforms: [function (args) {
    var token = localStorage.getItem('token');
    var user = localStorage.getItem('user_id');
    var account = localStorage.getItem('account_id');

    if (token) {
      args.headers.authorization = token;
      if (user) {
        args.headers['x-user-id-override'] = user;
      }
    }

    if (account) {
      args.headers['x-account-id'] = account;
    }

    return args;
  }]
};

var http = Object(__WEBPACK_IMPORTED_MODULE_0_http_otro__["client"])(clientConfig);


window.http = http;
/* harmony default export */ __webpack_exports__["b"] = (http);

/***/ }),

/***/ "Oc4r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OnRi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-parkave-light.417bd14.png";

/***/ }),

/***/ "QcU8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sy47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["_5"] = me;
/* harmony export (immutable) */ __webpack_exports__["e"] = config;
/* harmony export (immutable) */ __webpack_exports__["_3"] = login;
/* harmony export (immutable) */ __webpack_exports__["Q"] = getPlans;
/* harmony export (immutable) */ __webpack_exports__["_10"] = setAuthToken;
/* harmony export (immutable) */ __webpack_exports__["_4"] = logout;
/* harmony export (immutable) */ __webpack_exports__["_25"] = uploadFile;
/* harmony export (immutable) */ __webpack_exports__["_26"] = uploadRemoteFile;
/* harmony export (immutable) */ __webpack_exports__["d"] = cancelAccount;
/* harmony export (immutable) */ __webpack_exports__["Y"] = inviteUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = addUserToAccount;
/* harmony export (immutable) */ __webpack_exports__["N"] = getCoupons;
/* harmony export (immutable) */ __webpack_exports__["n"] = createCoupon;
/* harmony export (immutable) */ __webpack_exports__["_18"] = updateCoupon;
/* harmony export (immutable) */ __webpack_exports__["x"] = deleteCoupon;
/* harmony export (immutable) */ __webpack_exports__["B"] = deliverCoupon;
/* harmony export (immutable) */ __webpack_exports__["G"] = getActiveCoupon;
/* harmony export (immutable) */ __webpack_exports__["_21"] = updatePreferences;
/* harmony export (immutable) */ __webpack_exports__["R"] = getPreferences;
/* harmony export (immutable) */ __webpack_exports__["E"] = fetchAllUsers;
/* harmony export (immutable) */ __webpack_exports__["o"] = createFavorites;
/* harmony export (immutable) */ __webpack_exports__["y"] = deleteFavorites;
/* harmony export (immutable) */ __webpack_exports__["_0"] = loadFavorites;
/* harmony export (immutable) */ __webpack_exports__["_12"] = signup;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return signupHubspotNotification; });
/* harmony export (immutable) */ __webpack_exports__["D"] = emailAvailable;
/* harmony export (immutable) */ __webpack_exports__["_16"] = updateBasicDetails;
/* harmony export (immutable) */ __webpack_exports__["_24"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["_20"] = updatePassword;
/* harmony export (immutable) */ __webpack_exports__["_9"] = sendForgotPassword;
/* harmony export (immutable) */ __webpack_exports__["_27"] = verifyPassword;
/* harmony export (immutable) */ __webpack_exports__["_28"] = verifySignUp;
/* harmony export (immutable) */ __webpack_exports__["_7"] = removeUserFromAccount;
/* harmony export (immutable) */ __webpack_exports__["_14"] = toggleUserPermissions;
/* harmony export (immutable) */ __webpack_exports__["j"] = createAccountFormat;
/* harmony export (immutable) */ __webpack_exports__["t"] = deleteAccountFormat;
/* harmony export (immutable) */ __webpack_exports__["k"] = createAccountSelectedFormat;
/* harmony export (immutable) */ __webpack_exports__["u"] = deleteAccountSelectedFormat;
/* harmony export (immutable) */ __webpack_exports__["L"] = getCategoryFormats;
/* harmony export (immutable) */ __webpack_exports__["A"] = deleteFormatFromCategory;
/* harmony export (immutable) */ __webpack_exports__["a"] = addFormatToCategory;
/* harmony export (immutable) */ __webpack_exports__["S"] = getPreview;
/* harmony export (immutable) */ __webpack_exports__["P"] = getFormats;
/* harmony export (immutable) */ __webpack_exports__["_19"] = updateFormat;
/* harmony export (immutable) */ __webpack_exports__["J"] = getAllFormats;
/* harmony export (immutable) */ __webpack_exports__["U"] = getSelectedFormats;
/* harmony export (immutable) */ __webpack_exports__["z"] = deleteFormat;
/* harmony export (immutable) */ __webpack_exports__["_22"] = updateSortFormats;
/* harmony export (immutable) */ __webpack_exports__["K"] = getCategories;
/* harmony export (immutable) */ __webpack_exports__["m"] = createCategory;
/* harmony export (immutable) */ __webpack_exports__["_17"] = updateCategory;
/* harmony export (immutable) */ __webpack_exports__["w"] = deleteCategory;
/* harmony export (immutable) */ __webpack_exports__["H"] = getAds;
/* harmony export (immutable) */ __webpack_exports__["l"] = createAd;
/* harmony export (immutable) */ __webpack_exports__["_15"] = updateAd;
/* harmony export (immutable) */ __webpack_exports__["h"] = copyAd;
/* harmony export (immutable) */ __webpack_exports__["v"] = deleteAd;
/* harmony export (immutable) */ __webpack_exports__["_11"] = shareAd;
/* harmony export (immutable) */ __webpack_exports__["_6"] = regenerateAdvertisementsCode;
/* harmony export (immutable) */ __webpack_exports__["_1"] = loadSingleAd;
/* harmony export (immutable) */ __webpack_exports__["O"] = getCustomFormats;
/* harmony export (immutable) */ __webpack_exports__["i"] = createAccount;
/* harmony export (immutable) */ __webpack_exports__["Z"] = issueRefund;
/* harmony export (immutable) */ __webpack_exports__["M"] = getCharges;
/* harmony export (immutable) */ __webpack_exports__["_8"] = saveAccountInfo;
/* harmony export (immutable) */ __webpack_exports__["F"] = getAccounts;
/* harmony export (immutable) */ __webpack_exports__["I"] = getAllAccounts;
/* harmony export (immutable) */ __webpack_exports__["s"] = deleteAccount;
/* harmony export (immutable) */ __webpack_exports__["X"] = getUpdateRuleFields;
/* harmony export (immutable) */ __webpack_exports__["_23"] = updateUpdateRule;
/* harmony export (immutable) */ __webpack_exports__["r"] = createUpdateRule;
/* harmony export (immutable) */ __webpack_exports__["W"] = getUpdateRule;
/* harmony export (immutable) */ __webpack_exports__["V"] = getUpdateFields;
/* harmony export (immutable) */ __webpack_exports__["q"] = createUpdate;
/* harmony export (immutable) */ __webpack_exports__["g"] = confirmUpdate;
/* harmony export (immutable) */ __webpack_exports__["c"] = approveUpdate;
/* harmony export (immutable) */ __webpack_exports__["C"] = denyUpdate;
/* harmony export (immutable) */ __webpack_exports__["T"] = getScheduled;
/* harmony export (immutable) */ __webpack_exports__["_2"] = loadUpdateRuleLimited;
/* harmony export (immutable) */ __webpack_exports__["p"] = createReferral;
/* harmony export (immutable) */ __webpack_exports__["f"] = confirmReferral;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__("OAu2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_http_otro__ = __webpack_require__("F10C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_http_otro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_http_otro__);






function me() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('sessions/me').then(function (res) {
    if (res.status != 403) return res.json();
    return {};
  });
}

function config() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('/setup').then(function (res) {
    if (res.status != 403) return res.json();
    return {};
  });
}

function login(email, password) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('sessions/login', { email: email, password: password }).then(function (res) {
    if (res.status == 200) {
      return updateToken(res);
    }
  });
}

function getPlans() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('plans').then(function (res) {
    return res.json();
  });
}

function setAuthToken(token) {
  localStorage.setItem('token', token);
}

function updateToken(res) {
  var token = res.headers.get('authorization');
  if (token) {
    setAuthToken(token);
  }

  return res.json();
}

function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('account_id');
  location.href = "/";
}

function uploadFile(base64, file) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('uploads', base64, { headers: { 'Content-Type': 'application/octet-stream', 'X-File-Name': file.name, 'X-File-Type': file.type } });
}

function uploadRemoteFile(fileURL, extType) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('uploads/remote', { fileUrl: fileURL, ext: extType });
}

function cancelAccount() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('cancel').then(function (res) {
      if (res.status == 200) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function inviteUser(email) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('invites', { email: email }));
}

function addUserToAccount(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('invites/verify', { token: token }));
}

/** 'coupons' api calls **/

function getCoupons() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('coupons'));
}

function createCoupon(payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('coupons', payload));
}

function updateCoupon(id, payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('coupons/' + id, payload));
}

function deleteCoupon(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('coupons/' + id));
}

function deliverCoupon(id, email) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('coupons/deliver', { id: id, email: email }));
}

function getActiveCoupon(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('coupons/active', { token: token }));
}

/** 'preferences' api calls **/

function updatePreferences(userId, payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('preferences/' + userId, payload));
}

function getPreferences() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('preferences'));
}

/** 'users' api calls **/

function fetchAllUsers() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('users'));
}

function createFavorites(format_id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('favorites', { format_id: format_id }));
}

function deleteFavorites(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('favorites/' + id));
}

function loadFavorites() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('favorites'));
}

function signup(email, password, name) {
  /* Hubspot Lead Form */
  var data = {
    'submittedAt': new Date().getTime().toString(),
    'fields': [{
      'objectTypeId': '0-1',
      'name': 'email',
      'value': email
    }, {
      'objectTypeId': '0-1',
      'name': 'first_and_last_name',
      'value': name
    }]
    //"0-2/domain"
  };try {
    __WEBPACK_IMPORTED_MODULE_4_http_otro__["client"]({ host: 'https://api.hsforms.com', headers: { contentType: 'application/json' } }).post('/submissions/v3/integration/submit/2898305/4ba490b5-a6f7-48e3-ad37-041c23b70944', data);
  } catch (e) {
    console.log(e);
  }
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('users', { email: email, password: password, name: name }));
}

var signupHubspotNotification = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(email, name) {
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            /* Hubspot Lead Form */
            data = {
              'submittedAt': new Date().getTime().toString(),
              'fields': [{
                'objectTypeId': '0-1',
                'name': 'email',
                'value': email
              }, {
                'objectTypeId': '0-1',
                'name': 'first_and_last_name',
                'value': name
              }]
              //"0-2/domain"
            };
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4_http_otro__["client"]({ host: 'https://api.hsforms.com', headers: { contentType: 'application/json' } }).post('/submissions/v3/integration/submit/2898305/4ba490b5-a6f7-48e3-ad37-041c23b70944', data);

          case 4:
            _context.next = 9;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context['catch'](1);

            console.log(_context.t0);

          case 9:
            return _context.abrupt('return', true);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 6]]);
  }));

  return function signupHubspotNotification(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

function emailAvailable(email) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('users/email_check', { email: email }));
}

function updateBasicDetails(userId, payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('users/update', payload).then(function (res) {
    if (res.ok) {
      return updateToken(res);
    } else {
      return res;
    }
  }).then(function (json) {
    return json;
  });
}

function updateUser(userId, payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('users/' + userId, payload);
}

function updatePassword(_ref2) {
  var userId = _ref2.userId,
      currentPassword = _ref2.currentPassword,
      newPassword = _ref2.newPassword,
      hasPassword = _ref2.hasPassword;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!hasPassword) {
      __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('users/update', { password: newPassword }).then(function (res) {
        return updateToken(res);
      }).then(resolve).catch(reject);
    } else {
      __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('users/new_password_verification', { password: currentPassword }).then(function (res) {
        if (res.status == 200) {
          __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('users/update', { password: newPassword }).then(function (res) {
            return updateToken(res);
          }).then(resolve).catch(reject);
        } else {
          reject();
        }
      });
    }
  });
}

function sendForgotPassword(email) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('users/password_token', { email: email }));
}

function verifyPassword(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('users/verify_password', { token: token }).then(function (res) {
    if (res.status == 200) {
      return updateToken(res);
    }
  });
}

function verifySignUp(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('users/verify', { token: token }).then(function (res) {
    if (res.status == 200) {
      return updateToken(res);
    } else {
      delete localStorage.signup_token;
      return res.json();
    }
  });
}

/** 'account_users' api calls **/

function removeUserFromAccount(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('account_users/' + id));
}

function toggleUserPermissions(id, permissions) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('account_users/' + id, { permissions: permissions }));
}

/** 'account_formats' api calls **/

function createAccountFormat(format_id, account_id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('account_formats', { format_id: format_id, account_id: account_id }));
}

function deleteAccountFormat(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('account_formats/' + id));
}

/** 'account_selected_formats' api calls **/

function createAccountSelectedFormat(format_id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('account_selected_formats', { format_id: format_id }));
}

function deleteAccountSelectedFormat(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('account_selected_formats/' + id));
}

/** 'category_formats' api calls **/

function getCategoryFormats() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('category_formats'));
}

function deleteFormatFromCategory(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('category_formats/' + id));
}

function addFormatToCategory(payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('category_formats', payload));
}

/** 'formats' api calls **/

function getPreview(formatId, input) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('formats/' + formatId + '/preview', input);
}

function getFormats() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('formats'));
}

function updateFormat(id, payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('formats/' + id, payload));
}

function getAllFormats() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('formats/all'));
}

function getSelectedFormats() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('formats/selected'));
}

function deleteFormat(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('formats/' + id));
}

function updateSortFormats(format_ids) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('formats/update_sort', { format_ids: format_ids }));
}

/** 'categories' api calls **/

function getCategories() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('categories'));
}

function createCategory(payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('categories', payload));
}

function updateCategory(id, category) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('categories/' + id, category));
}

function deleteCategory(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('categories/' + id));
}

/** 'advertisements' api calls **/

function getAds() {
  var params = {};
  var m = void 0;
  if (m = location.href.match(/share_code=(.+)/)) {
    // \w+
    params.share_code = m[1];
  }
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('advertisements', params));
}

function createAd(payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('advertisements', payload));
}

function updateAd(id, ad) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('advertisements/' + id, ad));
}

function copyAd(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('advertisements/' + id + '/copy', { id: id }));
}

function deleteAd(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('advertisements/' + id));
}

function shareAd(email, url) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('advertisements/share', { email: email, url: url });
}

function regenerateAdvertisementsCode(formatId) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('advertisements/' + formatId + '/regenerate'));
}

function loadSingleAd(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('advertisements/' + id));
}

/** 'account' api calls **/

function getCustomFormats(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('accounts/' + id + '/formats', { id: id }));
}

function createAccount(name) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('accounts', { name: name }));
}

function issueRefund(accountId, chargeId) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('/accounts/' + accountId + '/refund', { account_id: accountId, charge_id: chargeId }));
}

function getCharges(accountId) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('accounts/' + accountId + '/charges', { id: accountId }));
}

function saveAccountInfo(_ref3) {
  var account = _ref3.account;

  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('accounts/' + account.id, account));
}

function getAccounts() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('accounts'));
}

function getAllAccounts() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('accounts/all'));
}

function deleteAccount(accountId) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('accounts/' + accountId));
}

function getUpdateRuleFields() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('update_rules/fields'));
}

function updateUpdateRule(id, payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].put('update_rules/' + id, payload));
}

function createUpdateRule(payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('update_rules', payload));
}

function getUpdateRule(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('update_rules/' + id));
}

function getUpdateFields() {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('updates/fields'));
}

function createUpdate(payload) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('updates', payload));
}

function confirmUpdate(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('updates/confirm', { token: token }));
}

function approveUpdate(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('updates/approve', { token: token }));
}

function denyUpdate(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].del('updates/deny', { token: token }));
}

function getScheduled(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('updates/scheduled', { advertisement_id: id }));
}

function loadUpdateRuleLimited(id) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].get('update_rules/limited', { id: id }));
}

function createReferral(email) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('referrals', { email: email }));
}

function confirmReferral(token) {
  return __WEBPACK_IMPORTED_MODULE_3__client__["c" /* response */].json(__WEBPACK_IMPORTED_MODULE_3__client__["b" /* default */].post('referrals/confirm', { token: token }));
}

/***/ }),

/***/ "T+hK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ulv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/components/common/SeriesBadge.vue + 2 modules
var SeriesBadge = __webpack_require__("GFam");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/FormatItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var FormatItem = ({
  name: 'format-item',
  components: {
    SeriesBadge: SeriesBadge["a" /* default */]
  },
  props: ['index', 'premium', 'title', 'id', 'categoryId', 'preview_icon', 'formatdata', 'preview_image', 'description', 'series'],
  methods: {
    showFormatDetail: function showFormatDetail() {
      this.$router.push({
        path: '/configuration/' + this.id
      });
      /*
      this.$modal.show('format-detail', {id: this.id})
      setTimeout(() => {
        if (this.$tours['long_tour'].currentStep === 5) {
          this.$tours['long_tour'].nextStep();
        }
      }, 10)
      */
    },
    viewDemo: function viewDemo() {
      var route = this.$router.resolve({ path: '/demo/' + this.id });
      window.open(route.href, '_blank');
    },
    previewImage: function previewImage() {
      return this.preview_image || 'data:image/svg+xml;base64,' + btoa(this.preview_icon);
    },
    toggleFavorite: function toggleFavorite() {
      if (this.me.id) {
        if (this.formatIsFavorited) {
          this.unfavorite();
        } else {
          this.favorite();
        }
      } else {
        this.$modal.show('intersection');
      }
    },
    favorite: function favorite() {
      this.$store.dispatch('users/addFavorite', { format_id: this.id });
    },
    unfavorite: function unfavorite() {
      this.$store.dispatch('users/removeFavorite', { id: this.favorited.id });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('users', ['favorites']), Object(vuex_esm["b" /* mapState */])(['me']), {
    userIsAdmin: function userIsAdmin() {
      return this.me.admin;
    },
    getSizes: function getSizes() {
      var sizes = [];
      var input = JSON.parse(this.formatdata).inputs;
      for (var i = 0; i < input.length; i++) {
        if (input[i].type === 'size') {
          for (var v = 0; v < input[i].options.length; v++) {
            if (input[i].options[v].type === 'flexible') {
              sizes.push(input[i].options[v].width + ':' + input[i].options[v].height);
            } else {
              sizes.push(input[i].options[v].width + 'x' + input[i].options[v].height);
            }
          }
          return sizes.join(', ');
        }
      }
      return 'One Size Fits All';
    },
    getDescription: function getDescription() {
      if (this.description === '' || this.description == null) {
        var format = JSON.parse(this.formatdata);
        this.displayDescription = (format.description || 'No description provided').substring(0, 275);
      } else {
        this.displayDescription = this.description;
      }

      return this.displayDescription;
    },
    getDemoStep: function getDemoStep() {
      if (this.index === 0) {
        return 4;
      } else {
        return null;
      }
    },
    getUseStep: function getUseStep() {
      if (this.index === 0) {
        return 5;
      } else {
        return null;
      }
    },
    getDemoStepHome: function getDemoStepHome() {
      if (this.index === 0) {
        return 4;
      } else {
        return null;
      }
    },
    getUseStepHome: function getUseStepHome() {
      if (this.index === 0) {
        return 3;
      } else {
        return null;
      }
    },
    formatIsFavorited: function formatIsFavorited() {
      var _this = this;

      var rtnVal = false;
      if (this.favorites.length) {
        this.favorites.forEach(function (favorite) {
          if (favorite.format_id == _this.id) {
            _this.favorited = favorite;
            rtnVal = true;
          }
        });
      }
      return rtnVal;
    }
  }),
  data: function data() {
    return {
      displayDescription: null,
      favorited: null
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cf7dc36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormatItem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"format"},[_c('div',{staticClass:"format__heart",class:{'format__heart--active': _vm.formatIsFavorited},on:{"click":_vm.toggleFavorite}}),_vm._v(" "),(_vm.userIsAdmin)?_c('router-link',{staticClass:"button button--tertiary format__button__adminedit",attrs:{"to":{path: '/admin#formats', query: {id: _vm.id}}}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),_c('figure',{staticClass:"format__image",on:{"click":_vm.showFormatDetail}},[_c('img',{staticClass:"format__image__source",attrs:{"src":_vm.previewImage()}})]),_vm._v(" "),_c('div',{staticClass:"format__content"},[_c('header',{staticClass:"format__header"},[_c('h1',{staticClass:"format__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.premium)?_c('button',{staticClass:"button button--primary format__button__premium"},[_vm._v("Pro only")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"format__text"},[_vm._v(_vm._s(_vm.getDescription)+"…")]),_c('p'),_c('div',{staticClass:"format__buttons"},[_c('span',{staticClass:"format__button button button--primary button--expand",attrs:{"data-v-home-step":_vm.getUseStepHome},on:{"click":_vm.showFormatDetail}},[_vm._v("Create One")]),_vm._v(" "),_c('span',{staticClass:"format__button button button--tertiary button--expand",attrs:{"data-v-home-step":_vm.getDemoStepHome},on:{"click":_vm.viewDemo}},[_vm._v("View Media Kit & Samples")])]),_vm._v(" "),_c('footer',{staticClass:"format__footer"},[_c('SeriesBadge',{attrs:{"series":_vm.series,"box":true}}),_vm._v(" "),_c('div',{staticClass:"format__size__container"},[_c('h2',{staticClass:"format__sizes"},[_vm._v("Supported Sizes")]),_vm._v(" "),_c('p',{staticClass:"format__formats"},[_vm._v(_vm._s(_vm.getSizes))])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_FormatItem = (esExports);
// CONCATENATED MODULE: ./src/components/common/FormatItem.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FormatItem,
  common_FormatItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_FormatItem = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/lib/integration.js
var integration = __webpack_require__("rqOl");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/BannerItem.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var BannerItem = ({
  name: 'banner-item',
  props: ['title', 'id', 'formatId', 'size', 'link', 'banner'],
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('advertisements', ['ads']), {
    bannerImage: function bannerImage() {
      if (this.banner.preview && this.banner.preview.url) {
        return this.banner.preview.url;
      } else {
        // 'data:image/svg+xml;base64,'
        return this.previewImage();
      }
    },
    getCurrentSizes: function getCurrentSizes() {
      if (this.size.type === 'flexible') {
        return this.size.type.substring(0, 1).toUpperCase().concat(this.size.type.substring(1)) + ': ' + this.size.width + ':' + this.size.height;
      } else {
        return this.size.type.substring(0, 1).toUpperCase().concat(this.size.type.substring(1)) + ': ' + this.size.width + 'x' + this.size.height;
      }
    }
  }),
  methods: {
    showModal: function showModal() {
      var _this = this;

      var advert = this.ads.filter(function (ad) {
        return _this.id == ad.id;
      })[0];
      this.$parent.showModal(advert);
    },
    useNow: function useNow() {
      console.log('banner', stringify_default()(this.banner));
      this.banner.inputs = this.banner.json;
      Object(integration["c" /* passback */])(this.banner);
    },
    previewImage: function previewImage() {
      var formats = this.$store.getters['formats/formats'];
      var previewImage = void 0;
      var currentFormatId = this.formatId;
      formats.forEach(function (format) {
        if (format.id === currentFormatId) {
          previewImage = format.preview_image;
        }
      });
      return previewImage;
    },
    copyAd: function copyAd() {
      this.$emit('copied', this.id);
    },
    deleteAd: function deleteAd() {
      this.$emit('deleted', this.id);
    }
  },
  data: function data() {
    return {
      value: null
    };
  },

  watch: {
    value: function value(newVal) {
      this.$emit('input', newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-046f9e0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BannerItem.vue
var BannerItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"banner"},[_c('figure',{staticClass:"banner__image"},[_c('img',{staticClass:"banner__image__source",attrs:{"src":_vm.bannerImage}}),_vm._v(" "),_c('figcaption',{staticClass:"banner__image__caption"},[_c('div',{staticClass:"banner__image__options"},[_c('a',{staticClass:"banner__image__copy",on:{"click":_vm.copyAd}}),_vm._v(" "),_c('a',{staticClass:"banner__image__trash",on:{"click":_vm.deleteAd}})]),_vm._v(" "),_c('router-link',{staticClass:"banner__image__view",attrs:{"to":_vm.link}},[_c('span',[_vm._v("Edit")])]),_vm._v(" "),(!_vm.isAppStandalone())?_c('a',{staticClass:"banner__image__use",attrs:{"href":"#"},on:{"click":_vm.useNow}},[_c('span',[_vm._v("Use Now")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"banner__image__export",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showModal($event)}}},[_c('span',[_vm._v("Get Code")])])],1)]),_vm._v(" "),_c('header',{staticClass:"banner__header"},[_c('h1',{staticClass:"banner__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('section',{staticClass:"banner__section"},[(_vm.size)?_c('p',{staticClass:"banner__currentsize"},[_vm._v(_vm._s(_vm.getCurrentSizes))]):_vm._e()])])}
var BannerItem_staticRenderFns = []
var BannerItem_esExports = { render: BannerItem_render, staticRenderFns: BannerItem_staticRenderFns }
/* harmony default export */ var common_BannerItem = (BannerItem_esExports);
// CONCATENATED MODULE: ./src/components/common/BannerItem.vue
var BannerItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var BannerItem___vue_template_functional__ = false
/* styles */
var BannerItem___vue_styles__ = null
/* scopeId */
var BannerItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BannerItem___vue_module_identifier__ = null
var BannerItem_Component = BannerItem_normalizeComponent(
  BannerItem,
  common_BannerItem,
  BannerItem___vue_template_functional__,
  BannerItem___vue_styles__,
  BannerItem___vue_scopeId__,
  BannerItem___vue_module_identifier__
)

/* harmony default export */ var components_common_BannerItem = (BannerItem_Component.exports);

// EXTERNAL MODULE: ./src/components/common/PreviewSettings.vue + 2 modules
var PreviewSettings = __webpack_require__("gtId");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/InputSearch.vue
//
//
//
//
//
//

/* harmony default export */ var InputSearch = ({
  name: 'input-search',
  props: ['placeholder'],
  computed: {
    value: function value() {
      return this.$store.state.formats.searchFilter;
    }
  },
  methods: {
    onChange: function onChange(e) {
      var value = e.target.value;
      this.$store.commit('formats/setSearchFilter', value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f87e1a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/InputSearch.vue
var InputSearch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input input--search"},[_c('input',{staticClass:"input__field",attrs:{"type":"search","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"keyup":_vm.onChange}})])}
var InputSearch_staticRenderFns = []
var InputSearch_esExports = { render: InputSearch_render, staticRenderFns: InputSearch_staticRenderFns }
/* harmony default export */ var common_InputSearch = (InputSearch_esExports);
// CONCATENATED MODULE: ./src/components/common/InputSearch.vue
var InputSearch_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var InputSearch___vue_template_functional__ = false
/* styles */
var InputSearch___vue_styles__ = null
/* scopeId */
var InputSearch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InputSearch___vue_module_identifier__ = null
var InputSearch_Component = InputSearch_normalizeComponent(
  InputSearch,
  common_InputSearch,
  InputSearch___vue_template_functional__,
  InputSearch___vue_styles__,
  InputSearch___vue_scopeId__,
  InputSearch___vue_module_identifier__
)

/* harmony default export */ var components_common_InputSearch = (InputSearch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/InputField.vue
//
//
//
//

/* harmony default export */ var InputField = ({
  name: 'input-field',
  props: ['placeholder', 'value']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f40b59e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/InputField.vue
var InputField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var InputField_staticRenderFns = []
var InputField_esExports = { render: InputField_render, staticRenderFns: InputField_staticRenderFns }
/* harmony default export */ var common_InputField = (InputField_esExports);
// CONCATENATED MODULE: ./src/components/common/InputField.vue
var InputField_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var InputField___vue_template_functional__ = false
/* styles */
var InputField___vue_styles__ = null
/* scopeId */
var InputField___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InputField___vue_module_identifier__ = null
var InputField_Component = InputField_normalizeComponent(
  InputField,
  common_InputField,
  InputField___vue_template_functional__,
  InputField___vue_styles__,
  InputField___vue_scopeId__,
  InputField___vue_module_identifier__
)

/* harmony default export */ var components_common_InputField = (InputField_Component.exports);

// EXTERNAL MODULE: ./src/lib/api/calls.js
var calls = __webpack_require__("Sy47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MainNavigation.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var MainNavigation = ({
  name: 'main-navigation',
  methods: {
    closeMenu: function closeMenu() {
      if (this.profileActive) {
        this.profileActive = false;
      }
    },
    showSignIn: function showSignIn() {
      this.$modal.show('sign-in');
    },
    showIntersection: function showIntersection() {
      this.$modal.show('intersection');
    },
    logout: function logout() {
      Object(calls["_4" /* logout */])();
    },
    switchAccount: function switchAccount(account) {
      this.$store.dispatch('setAccount', account);
    },
    exit: function exit() {
      Object(integration["b" /* close */])();
    },
    removeAdminMocking: function removeAdminMocking() {
      this.profileActive = !this.profileActive;
      delete localStorage.user_id;
      this.$store.dispatch('reloadMe');
    },
    openVideoModal: function openVideoModal() {
      this.$modal.show('video', { title: 'ParkAve: Crash Course', video: 'https://www.youtube.com/embed/LDDeb8WdZoQ' });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])(['adminMocking', 'me']), {
    userIsSuperAdmin: function userIsSuperAdmin() {
      return this.me.admin || this.me.format_admin;
    },
    account: function account() {
      return this.$store.state.account;
    },
    accounts: function accounts() {
      return this.$store.getters['accounts/owned'];
    },
    isMocked: function isMocked() {
      return this.adminMocking;
    },
    canDisplay: function canDisplay() {
      return this.$route.name !== 'Demo' && this.$route.name !== 'EnterpriseForm' && this.$route.name !== 'UpdateSuccess' && this.$route.name !== 'Self Serve Updates';
    }
  }),
  data: function data() {
    return {
      profileActive: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a84c57a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MainNavigation.vue
var MainNavigation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canDisplay)?_c('header',{staticClass:"main-navigation",class:{'main-navigation--column-reverse': _vm.me.id }},[_c('h1',{staticClass:"main-navigation__logo"},[_c('router-link',{staticStyle:{"color":"white"},attrs:{"data-v-home-step":"0","data-v-long-step":"0","to":{ name: 'Home' }}},[_c('img',{attrs:{"src":"/static/images/logo-parkave.png","alt":"ParkAve"}})])],1),_vm._v(" "),(_vm.me.id == null && !_vm.getShareCode())?_c('span',{staticClass:"main-navigation__sign-up button button--primary",on:{"click":_vm.showIntersection}},[_vm._v("Sign In")]):_vm._e(),_vm._v(" "),(_vm.me.id)?_c('p',{staticClass:"main-navigation__links",staticStyle:{"color":"white"}},[_c('span',{staticClass:"member-nav"},[_c('router-link',{attrs:{"data-v-home-step":"5","to":{ name: 'Ads' }}},[_vm._v("My Creatives")]),_vm._v(" "),_c('router-link',{attrs:{"data-v-long-step":"1","to":"/","exact":""}},[_vm._v("Browse formats")]),_vm._v(" "),_c('a',{staticClass:"router-link",attrs:{"href":"#"},on:{"click":_vm.openVideoModal}},[_vm._v("Explainer Video (Tutorial)")])],1)]):_vm._e(),_vm._v(" "),(_vm.me.id)?_c('div',{staticClass:"main-navigation__user-profile user-profile"},[_c('span',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeMenu),expression:"closeMenu"}],staticClass:"user-profile__user-name",class:{'user-profile__user-name--active': _vm.profileActive},on:{"click":function($event){_vm.profileActive = !_vm.profileActive}}},[_vm._v(_vm._s(_vm.account.name))]),_vm._v(" "),_c('ul',{staticClass:"user-profile__list",class:{'user-profile__list--visible': _vm.profileActive}},[_vm._m(0,false,false),_vm._v(" "),_vm._l((_vm.accounts),function(account){return _c('li',{staticClass:"user-profile__item user-profile__item--hover",on:{"click":function($event){_vm.profileActive = !_vm.profileActive}}},[_c('span',{staticClass:"user-profile__link",on:{"click":function($event){_vm.switchAccount(account)}}},[_vm._v(_vm._s(account.name))])])}),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('li',{staticClass:"user-profile__item user-profile__item--hover",on:{"click":function($event){_vm.profileActive = !_vm.profileActive}}},[_c('router-link',{staticClass:"user-profile__link",attrs:{"to":{ name: 'Profile' }}},[_vm._v("Account Settings")])],1),_vm._v(" "),(_vm.userIsSuperAdmin)?_c('li',{staticClass:"user-profile__item user-profile__item--hover",on:{"click":function($event){_vm.profileActive = !_vm.profileActive}}},[_c('router-link',{staticClass:"user-profile__link",attrs:{"to":{ name: 'Administrator' }}},[_vm._v("Admin Controls")])],1):_vm._e(),_vm._v(" "),(_vm.isMocked)?_c('li',{staticClass:"user-profile__item user-profile__item--hover",on:{"click":_vm.removeAdminMocking}},[_c('router-link',{staticClass:"user-profile__link",attrs:{"to":{ name: 'Administrator' }}},[_vm._v("Remove Admin Mock")])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"user-profile__item user-profile__logout"},[(_vm.me.id)?_c('span',{staticClass:"button button--tertiary button--expand user-profile__item--hover",on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e()])],2)]):_vm._e(),_vm._v(" "),(!_vm.isAppStandalone())?_c('span',{staticClass:"main-navigation__close close",on:{"click":_vm.exit}},[_vm._v("Close")]):_vm._e()]):_vm._e()}
var MainNavigation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"user-profile__item"},[_c('span',{staticClass:"user-profile__link user-profile__item-title user-profile__item-title--top"},[_vm._v("Accounts")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"user-profile__item"},[_c('span',{staticClass:"user-profile__link user-profile__item-title"},[_vm._v("Settings")])])}]
var MainNavigation_esExports = { render: MainNavigation_render, staticRenderFns: MainNavigation_staticRenderFns }
/* harmony default export */ var common_MainNavigation = (MainNavigation_esExports);
// CONCATENATED MODULE: ./src/components/common/MainNavigation.vue
var MainNavigation_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MainNavigation___vue_template_functional__ = false
/* styles */
var MainNavigation___vue_styles__ = null
/* scopeId */
var MainNavigation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MainNavigation___vue_module_identifier__ = null
var MainNavigation_Component = MainNavigation_normalizeComponent(
  MainNavigation,
  common_MainNavigation,
  MainNavigation___vue_template_functional__,
  MainNavigation___vue_styles__,
  MainNavigation___vue_scopeId__,
  MainNavigation___vue_module_identifier__
)

/* harmony default export */ var components_common_MainNavigation = (MainNavigation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/MainFooter.vue
//
//
//
//

/* harmony default export */ var MainFooter = ({
  name: 'main-footer'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2002de4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MainFooter.vue
var MainFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"})}
var MainFooter_staticRenderFns = []
var MainFooter_esExports = { render: MainFooter_render, staticRenderFns: MainFooter_staticRenderFns }
/* harmony default export */ var common_MainFooter = (MainFooter_esExports);
// CONCATENATED MODULE: ./src/components/common/MainFooter.vue
var MainFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MainFooter___vue_template_functional__ = false
/* styles */
var MainFooter___vue_styles__ = null
/* scopeId */
var MainFooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MainFooter___vue_module_identifier__ = null
var MainFooter_Component = MainFooter_normalizeComponent(
  MainFooter,
  common_MainFooter,
  MainFooter___vue_template_functional__,
  MainFooter___vue_styles__,
  MainFooter___vue_scopeId__,
  MainFooter___vue_module_identifier__
)

/* harmony default export */ var components_common_MainFooter = (MainFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/CategoriesListing.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CategoriesListing = ({
  name: 'categories-listing',
  data: function data() {
    return {
      obj: {
        selected: undefined
      },
      expanded: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])('categories', ['categories']), Object(vuex_esm["b" /* mapState */])('users', ['favorites']), Object(vuex_esm["b" /* mapState */])(['account']), {
    customFormats: function customFormats() {
      return this.$store.getters['formats/custom'];
    },
    recentCount: function recentCount() {
      var counter = null;
      var formats = this.$store.getters['formats/formats'];
      if (formats) {
        formats.forEach(function (format) {
          var today = new Date();
          if (new Date(format.updated_at) > new Date().setDate(today.getDate() - 30)) {
            counter++;
          }
        });
      }
      return counter ? '(' + counter + ')' : null;
    },
    userIsAdmin: function userIsAdmin() {
      return this.$store.state.me.admin || this.$store.state.me.format_admin;
    },
    getCustomName: function getCustomName() {
      return this.account.name + ' Premium';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81b61ffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CategoriesListing.vue
var CategoriesListing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"categories__header",class:{ expanded: _vm.expanded },on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_c('h2',{staticClass:"categories__title"},[_vm._v("Categories")])]),_vm._v(" "),_c('ul',{staticClass:"categories__list",class:{ expanded: _vm.expanded }},[(_vm.favorites.length)?_c('li',{staticClass:"categories__item",class:{'categories__item--current':'favorites' == _vm.obj.selected}},[_c('router-link',{staticClass:"categories__link",class:{'categories__link--current':'favorites' == _vm.obj.selected},attrs:{"to":{ name: 'Category', params: {id: 'favorites'}}},nativeOn:{"click":function($event){_vm.obj.selected = 'favorites'}}},[_vm._v("Favorites")])],1):_vm._e(),_vm._v(" "),(_vm.customFormats.length)?_c('li',{staticClass:"categories__item",class:{'categories__item--current':'custom' == _vm.obj.selected}},[_c('router-link',{staticClass:"categories__link",class:{'categories__link--current':'custom' == _vm.obj.selected},attrs:{"to":{ name: 'Category', params: {id: 'custom'}}},nativeOn:{"click":function($event){_vm.obj.selected = 'custom'}}},[_vm._v(_vm._s(_vm.getCustomName))])],1):_vm._e(),_vm._v(" "),(_vm.userIsAdmin)?_c('li',{staticClass:"categories__item",class:{'categories__item--current':'invisible' == _vm.obj.selected}},[_c('router-link',{staticClass:"categories__link",class:{'categories__link--current':'invisible' == _vm.obj.selected},attrs:{"to":{ name: 'Category', params: {id: 'invisible'}}},nativeOn:{"click":function($event){_vm.obj.selected = 'invisible'}}},[_vm._v("Non-Public Ads")])],1):_vm._e(),_vm._v(" "),(_vm.recentCount)?_c('li',{staticClass:"categories__item",class:{'categories__item--current':'recent' == _vm.obj.selected}},[_c('router-link',{staticClass:"categories__link",class:{'categories__link--current':'recent' == _vm.obj.selected},attrs:{"to":{ name: 'Category', params: {id: 'recent'}}},nativeOn:{"click":function($event){_vm.obj.selected = 'recent'}}},[_vm._v("Recently Released "+_vm._s(_vm.recentCount))])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('li',{key:category.id,staticClass:"categories__item",class:{'categories__item--current':category.id == _vm.obj.selected}},[_c('router-link',{staticClass:"categories__link",class:{'categories__link--current':category.id == _vm.obj.selected},attrs:{"to":{ name: 'Category', params: {id: category.id}}},nativeOn:{"click":function($event){_vm.obj.selected = category.id}}},[_vm._v(_vm._s(category.name))])],1)})],2)])}
var CategoriesListing_staticRenderFns = []
var CategoriesListing_esExports = { render: CategoriesListing_render, staticRenderFns: CategoriesListing_staticRenderFns }
/* harmony default export */ var common_CategoriesListing = (CategoriesListing_esExports);
// CONCATENATED MODULE: ./src/components/common/CategoriesListing.vue
var CategoriesListing_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var CategoriesListing___vue_template_functional__ = false
/* styles */
var CategoriesListing___vue_styles__ = null
/* scopeId */
var CategoriesListing___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CategoriesListing___vue_module_identifier__ = null
var CategoriesListing_Component = CategoriesListing_normalizeComponent(
  CategoriesListing,
  common_CategoriesListing,
  CategoriesListing___vue_template_functional__,
  CategoriesListing___vue_styles__,
  CategoriesListing___vue_scopeId__,
  CategoriesListing___vue_module_identifier__
)

/* harmony default export */ var components_common_CategoriesListing = (CategoriesListing_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.common.js
var vuedraggable_common = __webpack_require__("u4Bf");
var vuedraggable_common_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/FormatListing.vue
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var FormatListing = ({
  components: {
    draggable: vuedraggable_common_default.a
  },
  name: 'format-listing',
  props: ['formats'],
  methods: {
    loadStep: function loadStep(index) {
      if (index === 0) {
        return 3;
      } else {
        return null;
      }
    }
  },
  computed: {
    isFormatAdmin: function isFormatAdmin() {
      return this.$store.state.me.admin || this.$store.state.me.format_admin;
    },

    format_list: {
      get: function get() {
        return this.formats;
      },
      set: function set(value) {
        this.$store.commit('formats/updateSort', value);
      }
    },
    sortedFormats: function sortedFormats() {
      return _this.formats.sort(function (a, b) {
        return a - b;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f07cf42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormatListing.vue
var FormatListing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"formats__list"},[_vm._l((_vm.format_list),function(format,index){return (!_vm.isFormatAdmin)?_c('li',{staticClass:"formats__item"},[_c('format-item',{attrs:{"index":index,"data-v-long-step":_vm.loadStep(index),"premium":format.premium,"title":format.name,"id":format.id,"description":format.description,"category-id":format.category_id,"preview_icon":format.preview_icon,"preview_image":format.preview_image,"formatdata":format.specification,"series":format.series}})],1):_vm._e()}),_vm._v(" "),(_vm.isFormatAdmin)?_c('draggable',{model:{value:(_vm.format_list),callback:function ($$v) {_vm.format_list=$$v},expression:"format_list"}},_vm._l((_vm.format_list),function(format,index){return _c('li',{staticClass:"formats__item"},[_c('format-item',{attrs:{"index":index,"data-v-long-step":_vm.loadStep(index),"premium":format.premium,"title":format.name,"id":format.id,"description":format.description,"category-id":format.category_id,"preview_icon":format.preview_icon,"preview_image":format.preview_image,"formatdata":format.specification,"series":format.series}})],1)})):_vm._e()],2)}
var FormatListing_staticRenderFns = []
var FormatListing_esExports = { render: FormatListing_render, staticRenderFns: FormatListing_staticRenderFns }
/* harmony default export */ var common_FormatListing = (FormatListing_esExports);
// CONCATENATED MODULE: ./src/components/common/FormatListing.vue
var FormatListing_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var FormatListing___vue_template_functional__ = false
/* styles */
var FormatListing___vue_styles__ = null
/* scopeId */
var FormatListing___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FormatListing___vue_module_identifier__ = null
var FormatListing_Component = FormatListing_normalizeComponent(
  FormatListing,
  common_FormatListing,
  FormatListing___vue_template_functional__,
  FormatListing___vue_styles__,
  FormatListing___vue_scopeId__,
  FormatListing___vue_module_identifier__
)

/* harmony default export */ var components_common_FormatListing = (FormatListing_Component.exports);

// CONCATENATED MODULE: ./src/components.js


// Import component files










// Standalone components
vue_esm["a" /* default */].component('format-item', components_common_FormatItem);
vue_esm["a" /* default */].component('banner-item', components_common_BannerItem);
vue_esm["a" /* default */].component('preview-settings', PreviewSettings["a" /* default */]);
vue_esm["a" /* default */].component('input-field', components_common_InputField);
vue_esm["a" /* default */].component('input-search', components_common_InputSearch);

// Grouped components
vue_esm["a" /* default */].component('main-navigation', components_common_MainNavigation);
vue_esm["a" /* default */].component('main-footer', components_common_MainFooter);
vue_esm["a" /* default */].component('categories-listing', components_common_CategoriesListing);
vue_esm["a" /* default */].component('format-listing', components_common_FormatListing);

/***/ }),

/***/ "XCeO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZPjm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aEm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bxs2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cX0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  methods: {
    isAppStandalone: function isAppStandalone() {
      try {
        return window.self === window.top;
      } catch (e) {
        return true;
      }
    },
    getShareCode: function getShareCode() {
      var m = void 0;
      if (m = location.href.match(/share_code=(.+)/)) {
        // \w+
        return m[1];
      }
    },
    isProduction: function isProduction() {
      return "production" == 'production';
    },

    unixToDate: function unixToDate(unix) {
      return new Date(unix * 1000).toLocaleDateString();
    },
    capitalize: function capitalize(word) {
      var firstLetter = word[0].toUpperCase();
      var rtnWord = firstLetter + word.substring(1);
      return rtnWord;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive("click-outside", {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

/***/ }),

/***/ "f+Yk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gCMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'onValueChange'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.initRender();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      return fullValues;
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      var _this = this;

      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
      this.$nextTick(function () {
        _this.onSelect();
      });
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    },
    initRender: function initRender() {
      var _this2 = this;

      (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.readValues();

              case 2:
                _context.next = 4;
                return _this2.fillValues();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onValueChange: function onValueChange() {
      var _this3 = this;

      (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.readValues();

              case 2:
                _context2.next = 4;
                return _this3.fillValues();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onSelect: function onSelect() {
      var _this4 = this;

      (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var fullValues;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.fillValues();

              case 2:
                fullValues = _context3.sent;

                _this4.updateTimeValue(fullValues);
                _this4.$emit('change', { data: fullValues });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ "gtId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api/calls.js
var calls = __webpack_require__("Sy47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/PreviewSettings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PreviewSettings = ({
  name: 'preview-settings',
  props: ['ad', 'inputs', ''],
  computed: {},
  mounted: function mounted() {
    this.generatePreview();
  },

  methods: {
    getWidth: function getWidth() {
      if (this.inputs.size && this.inputs.size.width) {
        if (this.inputs.size.type == 'fixed') {
          return this.inputs.size.width + 'px';
        } else if (this.inputs.size.type == 'flexible' && this.$refs.preview_content) {
          return this.$refs.preview_content.offsetWidth * .9 + 'px';
        }
      } else {
        // out of page
        return '100%';
      }
    },
    getHeight: function getHeight() {
      if (this.inputs.size && this.inputs.size.height) {
        if (this.inputs.size.type == 'fixed') {
          return this.inputs.size.height + 'px';
        } else if (this.inputs.size.type == 'flexible' && this.$refs.preview_content) {
          var ratio = this.inputs.size.height / this.inputs.size.width;
          return this.$refs.preview_content.offsetWidth * ratio * .9 + 'px';
        }
      } else {
        //out of page
        return '100%';
      }
    },
    generatePreview: function generatePreview() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        this._generatePreview();
      }.bind(this), 300);
    },
    _generatePreview: function _generatePreview() {
      var _this = this;

      var format_id = this.$route.params.format_id;

      var scaleX = 1,
          scaleY = 1,
          scale = 0;

      if (!format_id) {
        format_id = this.ad.format_id;
      }

      var updateParent = function updateParent() {
        _this.$emit('preview-data', {
          scale: parseInt(scale * 100)
        });
      };

      Object(calls["S" /* getPreview */])(format_id, this.inputs).then(function (res) {
        var length = res.headers.get("Content-Length");
        _this.$set(_this.preview, 'length', length);
        return res.text();
      }).then(function (html) {
        //this.$refs.preview.contentWindow.document.body.style.visibility = 'hidden';
        html = '<style>html{height:100%;}body{margin:0;padding:0;transform-origin:center center;height:100%;}</style>' + html;
        _this.$set(_this.preview, 'srcdoc', html);

        // now give it time to render
        setTimeout(function () {
          // width
          if (_this.$refs.preview_content.offsetWidth < _this.$refs.preview.contentWindow.document.body.offsetWidth) {
            var target_width = _this.$refs.preview_content.offsetWidth * .90;
            scaleX = target_width / _this.$refs.preview.contentWindow.document.body.offsetWidth;
          }

          // height
          if (_this.$refs.preview_content.offsetHeight < _this.$refs.preview.contentWindow.document.body.offsetHeight) {
            var target_height = _this.$refs.preview_content.offsetHeight * .90;
            scaleY = target_height / _this.$refs.preview.contentWindow.document.body.offsetHeight;
          }

          if (scaleX < scaleY) {
            scaleY = 1;
          } else if (scaleY < scaleX) {
            scaleX = 1;
          }

          scale = Math.min(scaleX, scaleY);

          _this.$refs.preview.contentWindow.document.body.style.transition = 'all .5s ease-in-out';
          _this.$refs.preview.contentWindow.document.body.style.transform = 'scale(' + scale + ')';
          _this.$refs.preview.contentWindow.document.body.style.tranformOrigin = 'center top 0px';

          // this.$refs.preview.contentWindow.document.body.style.visibility = 'visible';
          updateParent();
        }, 250);

        updateParent();
      });
    }
  },
  data: function data() {
    return {
      value: null,
      preview: {
        srcdoc: '',
        length: 0
      }
    };
  },

  watch: {
    inputs: {
      deep: true,
      handler: function handler(newVal) {
        this.generatePreview();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37020360","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PreviewSettings.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{ref:"preview_content",staticClass:"preview__content"},[(_vm.getWidth() != '100%')?_c('div',[_c('iframe',{ref:"preview",staticClass:"preview__frame",style:(("width: " + (_vm.getWidth()) + "; height: " + (_vm.getHeight()) + ";")),attrs:{"name":"parkave-preview","scrolling":"","srcdoc":_vm.preview.srcdoc}})]):_vm._e(),_vm._v(" "),(_vm.getWidth() == '100%')?_c('div',{staticClass:"browser browser__container"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"browser__content"},[_c('iframe',{ref:"preview",staticClass:"preview__frame",style:(("width: " + (_vm.getWidth()) + "; height: " + (_vm.getHeight()) + ";")),attrs:{"name":"parkave-preview","scrolling":"","srcdoc":_vm.preview.srcdoc}})])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"browser__row"},[_c('div',{staticClass:"browser__column browser__left"},[_c('span',{staticClass:"browser__dot",staticStyle:{"background":"#ED594A"}}),_vm._v(" "),_c('span',{staticClass:"browser__dot",staticStyle:{"background":"#FDD800"}}),_vm._v(" "),_c('span',{staticClass:"browser__dot",staticStyle:{"background":"#5AC05A"}})]),_vm._v(" "),_c('div',{staticClass:"browser__column browser__middle"},[_c('input',{attrs:{"type":"text","value":"https://www.yourwebsite.com","disabled":"true"}})]),_vm._v(" "),_c('div',{staticClass:"browser__column browser__right"},[_c('div',{staticStyle:{"float":"right"}},[_c('span',{staticClass:"browser__bar"}),_vm._v(" "),_c('span',{staticClass:"browser__bar"}),_vm._v(" "),_c('span',{staticClass:"browser__bar"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_PreviewSettings = (esExports);
// CONCATENATED MODULE: ./src/components/common/PreviewSettings.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  PreviewSettings,
  common_PreviewSettings,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_PreviewSettings = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iq7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iwTE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mmEW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nwCD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qr1n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rqOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = passback;
/* harmony export (immutable) */ __webpack_exports__["b"] = close;
/* harmony export (immutable) */ __webpack_exports__["a"] = allowBoostrapCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_calls__ = __webpack_require__("Sy47");


function passback(data) {
    window.parent.postMessage({
        app: 'parkave',
        event: 'passback',
        item: data
    }, '*');
}

function close() {
    window.parent.postMessage({
        app: 'parkave',
        event: 'close'
    }, '*');
}

/**
 * Allow other applications, inluding ParkAve,
 * to get recently created advertisements
 */
function allowBoostrapCall() {

    window.addEventListener('message', function (event) {
        if (event.data.app == 'parkave') {
            if (event.data.event == 'bootstrap_request') {
                Object(__WEBPACK_IMPORTED_MODULE_0__api_calls__["H" /* getAds */])().then(function (ads) {
                    var logged_in = true;
                    if (ads.error) {
                        logged_in = false;
                        ads = [];
                    } else {
                        ads = ads.map(function (o) {
                            return {
                                name: o.name,
                                placement_id: o.placement_id,
                                inputs: JSON.parse(o.json || '{}')
                            };
                        });
                    }
                    event.source.postMessage({
                        app: 'parkave',
                        event: 'bootstrap_response',
                        ads: ads,
                        logged_in: logged_in
                    }, '*');
                });
            }
        }
    }.bind(this), false);
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xHUm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "znRp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.29a1a11dba7c792b2185.js